
//////divakar
import {
  Box,
  Button,
  Divider,
  Flex,
  Grid,
  GridItem,
  Icon,
  Img,
  SimpleGrid,
  Text,
  keyframes,
  useToast,
  useColorModeValue,
  HStack,
  useDisclosure,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  FormControl,
  FormLabel,
  Tooltip,
  Badge,
  Switch,
} from '@chakra-ui/react';
import { getCreator } from 'utils/creator/creator';
import { getCompany } from 'utils/company/companyService';
import { MdOutlineRocketLaunch, MdOutlineSubtitles } from 'react-icons/md';
import React, { useEffect, useRef, useState, useCallback } from 'react';
import CharacterPreview from './CharacterPreview';
import { GoCodeReview } from 'react-icons/go';
import Card from 'components/card/Card';
import GameCard from './gameCard';
import {
  getImages,
  updateGame,
  getGameById,
  addgame,
  createSkills,
  createCategories,
  createReflection,
  getCreatorBlocks,
  getVoices,
  getStory,
  getBlocks,
  getListStory,
  getDefaultSkill,
  getReflection,
  setStory,
  QuestDeletion,
  getCompletionScreen,
  UpdateCompletionScreen,
  getTotalMinofWords,
  getStoryValidtion,
  getSelectedLanguages,
  getMaxBlockQuestNo,
  getLanguagescount,
  GameVoicegenaration,
} from 'utils/game/gameService';
import { useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';
import AboutStory from './AboutStory';
import GreetingsForm from './GreetingsForm';
import Customization from './Customize';
import IconBox from 'components/icons/IconBox';
import { TbView360 } from 'react-icons/tb';
import { FaRobot } from 'react-icons/fa';
import { GiBlackBook } from 'react-icons/gi';
import { FaCubes } from 'react-icons/fa';
import { MdTune } from 'react-icons/md';
import { IoArrowBackCircle, IoArrowForwardCircle } from 'react-icons/io5';
import { BsShareFill } from 'react-icons/bs';
import AddScores from './AddScores';
import CompletionScreen from './Completion';

import pro from 'assets/img/avatars/pro.png';

import OrderStep from 'components/dataDisplay/OrderStep';
import ImagePreview from './ImagePreview';
import { SidebarResponsive } from 'components/sidebar/Sidebar';
import routes from 'routes';

import ShareReviewTable from './ShareReview';
import tableDataCheck from 'views/admin/dashboards/rtl/variables/tableDataCheck';

import { AiFillMessage } from 'react-icons/ai';
import {
  addReadStatus,
  getAllReviews,
  updateReadStatusforalert,
  countofReviews,
} from 'utils/reviews/reviews';
import { API_SERVER } from 'config/constant';
import { useSelector, useDispatch } from 'react-redux';
import {
  updatePreviewData,
  createPreviewData,
  removeGame,
  onFieldContentModified,
  resetDeleteAction,
} from '../../../../../store/preview/previewSlice';
import { Dispatch } from '@reduxjs/toolkit'; // Import Dispatch type from @reduxjs/toolkit
import { RootState } from 'store/reducers';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import {
  gameOverviewGameContentLang,
  getGameStoryLine,
  getLaunch,
} from 'utils/game/gameService';
import CenterMode from './MobileProgressBar';

import { HashLoader } from 'react-spinners';
import {
  DemoPlayRoutePath,
  ReviewPlayRoutePath,
  previewPlayRoutePath,
} from 'config/constant';
import { Anatomy } from '@chakra-ui/theme-tools';
import { diff } from 'deep-diff';
import { parse } from 'path';
import { preloadedImages } from 'utils/hooks/function';
import { assetImageSrc } from 'utils/hooks/imageSrc';
import { isNull } from 'lodash';

const steps = [
  { title: 'BackGround' },
  { title: 'Non Playing Charater' },
  { title: 'About Story' },
  { title: 'Blocks' },
  { title: 'Score' },
  { title: 'Summaries' },
  { title: 'Endpage' },
];
interface ReflectionQuestion {
  length(arg0: string, length: any): unknown;
  ref1: any;
  ref2: any;
  ref3: any;
  ref4: any;
}
interface MyObject {
  seqs: any;
  option: any;
  secondaryId: any;
}
interface DeletionActionType {
  reqStatus: boolean | null;
  resStatus: boolean | null;
}
interface SelectedLanguageEntry {
  translationId: number;
  lmsMultiLanguageSupport: {
    language_name: string;
  };
  'lmsMultiLanguageSupport.language_name': string;
}
let updateGameAPIintialLoadTracker = 0;

const GameCreation = () => {
  const [languageCount, setlanguageCount] = useState<number>(0);
  const [questTabState, setQuestTabState] = useState<number>(1);
  const [uploadedFiles, setUploadedFiles] = useState<Record<string, File>>({});
  const [currentTab, setCurrentTab] = useState(0);
  const [openQuest, setOpenQuest] = useState(false);
  const [voicealert, setvoicealert] = useState(false);
  const [input, setInput] = useState<any>({});
  const [items, setItems] = useState<any>([]);
  const [foundLastInput, setFoundLastInput] = useState<any>([]);
  const [alphabet, setAlphabet] = useState<any>([]);
  const [showFunction, setShowFunction] = useState<any>('');
  const [interactionBlock, setInteractionBlock] = useState<any>();
  const [showReflectionQuestions, setShowReflectionQuestions] = useState(false);
  const [countalphabet, setAlphabetCount] = useState<any>(0);
  const [count, setCount] = useState<any>(1);
  const [sequence, setSequence] = useState<any>([]);
  const [dummySequence, setDummySequence] = useState<any>([]);
  //////////////////navin/////////////////////////
  const [BlockItems, setBlockItems] = useState<any>(null);
  const [isDeleteSeq, setDeleteseq] = useState<any>(false);
  const [isNextClicked, setNextClicked] = useState<any>(false);
  const [OkClose, setOkClose] = useState<any>(false);
  const [staticAssetImageUrls, setstaticAssetImageUrls] = useState<any>(null);
  const reflectionQuestionsdefault = [
    'What were your biggest learnings?',
    'How can you apply these learnings back at work?',
    "'What's one thing you learned about your mindset?",
    "What's one thing you are committing to change?",
  ];
  const [reflectionQuestions, setReflectionQuestions] = useState({
    ref1: 'What were your biggest learnings?',
    ref2: 'How can you apply these learnings back at work?',
    ref3: "What's one thing you learned about your mindset?",
    ref4: "What's one thing you are committing to change?",
  });

  const [Defaultstatus, setDefaultstatus] = useState(false);
  const [listBlockItems, setListBlockItems] = useState(null);
  const [listQuest, setListQuest] = useState(null);
  const [serias, setserias] = useState(1);
  const [targetSequence, setTargetSequence] = useState<any>();
  const [copySequence, setCopySequence] = useState<any>();
  const [badge, setBadge] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const toast = useToast();
  const [tab, setTab] = useState<number>(1);
  const [img, setImg] = useState<any[]>([]),
    [hoveredStates, setHoveredStates] = useState(Array(img.length).fill(false)),
    [showFullTextStates, setShowFullTextStates] = useState(
      Array(img.length).fill(false),
    ),
    [toggle, setToggle] = useState<any>(),
    [values, setValues] = useState<any>('Select'),
    [preview, setPreview] = useState<any>(),
    [players, setPlayers] = useState<any[]>([]);
  const [reflection, setReflection] = useState([]);
  const [showSelectBlock, setSelectBlock] = useState<any>([]);
  const [heightOfTab, setHeightOfTab] = useState<any>();
  const previewStoreData = useSelector((state: RootState) => state.preview);
  const [validation, setValidation] = useState<any>({
    note: false,
    dialog: false,
    Link: false,
    WehaveChoose: false,
    KeyInsights:false,
    SwipeMiniGame:false,
    DragForNow:false,
    PreAssessment:false,
    PostAssessment:false,
    validatePrompt:false,
    evaluationPrompt:false,
    Overview: false,
    ScenarioCompletion: false,
    dialogAnimation: false,
    interaction: false,
    options: false,
  });

  const [isDeleteActionDone, setIsDeleteActionDone] =
    useState<DeletionActionType>({ reqStatus: null, resStatus: null });

  const [extensiveNavigation, setExtensiveNavigation] = useState<number | null>(
    null,
  );
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  ///////reflectionQuestions///////////////

  const handleReflectionInput = (e: any, i?: any) => {
    setReflectionQuestions((prevref: any) => {
      // const noteKey = `Note`;
      const refkey = `ref${i - 1}`;
      const reflecation =
        e.target.id === `reflectionQuestion${i - 1}` ? e.target.value : null;
      return {
        ...prevref,
        [refkey]: reflecation,
      };
    });
  };

  const handlesaveReflection = async () => {
    const data = {
      reflectionQuestions: reflectionQuestions,
      gameReflectionQuestion: formData.gameReflectionQuestion,
      gameId: id,
    };
    const datas = JSON.stringify(data);
    const resu = await createReflection(datas);

    if (resu.status !== 'Success') {
      toast({
        title: 'Question not processed',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return false;
    } else {
    }
  };

  const textHover = useColorModeValue(
    { color: 'secondaryGray.900', bg: 'unset' },
    { color: 'secondaryGray.500', bg: 'unset' },
  );
  const iconColor = useColorModeValue('brand.500', 'white');
  const bgList = useColorModeValue('white', 'whiteAlpha.100');
  const Menupreview = {
    zIndex: 100000000,
  };
  const bgShadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.08)',
    'unset',
  );
  const bgButton = useColorModeValue('secondaryGray.300', 'whiteAlpha.100');
  const bgHover = useColorModeValue(
    { bg: 'secondaryGray.400' },
    { bg: 'whiteAlpha.50' },
  );
  const bgFocus = useColorModeValue(
    { bg: 'secondaryGray.300' },
    { bg: 'whiteAlpha.100' },
  );

  const [show, setShow] = useState(null);
  enum SummaryState {
    Yes = 'yes',
    No = 'no',
  }

  enum feedBackForm {
    Yes = 'yes',
    No = 'no',
  }

  const [isOpenSummary, setIsOpenSummary] = useState<SummaryState>(
    SummaryState.No,
  );
  const [cblocks, setCblocks] = useState([]);
  const [quest, setQuest] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [autosave, setAtuoSave] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [isSave, setIsSave] = useState(false);

  const [selections, setSelections] = useState(Array(img.length).fill(false));
  const [chatNote, setChatNote] = useState<any>('');
  const [isToggled, setIsToggled] = useState(false);

  const [showBadge, setShowBadge] = useState(null);
  const [selectedAud, setSelectedAud] = useState(null);
  const [previewId, setPreviewId] = useState(null);
  //navin
  const [fetchImg, setFetchImg] = useState<any>(''),
    [upNextCount, setUpNextCount] = useState<any>([]),
    [upNext, setUpNext] = useState<any>(),
    [number, setNumber] = useState<any>([]),
    [fetchPlayerImg, setFetchPlayerImg] = useState<any>(''),
    [selectedPlayer, setSelectedPlayer] = useState<any>(''),
    [backgroundIndex, setBackgroundIndex] = useState<any>(),
    [backgroundquestImage, setBackgroundquestImage] = useState<any[]>([]),
    [sentAud, setSentAud] = useState(null),
    [defaultskills, setDefaultSkills] = useState([]),
    [tags, setTags] = useState<any[]>([]),
    [nonPlayer, setNonPlayer] = useState(),
    [clicked, setClicked] = useState(false),
    [cat, setCat] = useState([]),
    [enter, setEnter] = useState(false),
    [entire, setEntire] = useState(false),
    [ShowReview, setShowReview] = useState(false),
    [share, setShare] = useState(false),
    [bgIndex, setBgIndex] = useState<number>(),
    [formData, setFormData] = useState({
      gameQuestNo: null,
      gameCategoryId: null,
      gameabstract: null,
      gameBibliography: null,

      gameMaxScore: null,
      gameBackgroundId: null,
      gameTheme: 'false',
      gameThemeColor:'',
      gameScenarioCompletion:'false',
      gameCourseType: 'Public',
      gameNonPlayingCharacterId: null,

      gameNonPlayerName: null,
      gameNonPlayerVoice: null,
      gameNonPlayerOption:[],
      gamePlayerMaleVoice: null,
      gamePlayerFemaleVoice: null,
      gamementorMaleVoice: null,
      gamementorFemaleVoice: null,
      gameNarratorVoice: null,

      gameStoryLine: '',
      gameReflectionQuestion: 4,
      gameRefQuestion1: '',
      gameRefQuestion2: '',
      gameRefQuestion3: '',
      gameRefQuestion4: '',
      ///
      gameAnimationId: null,
      gameTitle: '',

      gameSkills: '',
      gameLearningOutcome: '',
      gameDuration: null,
      gameAuthorName: '',
      gameIsShowLeaderboard: 'false', //indu --from
      gameIsShowReflectionScreen: 'false',
      gameTakeawayContent: '',
      gameAdditionalWelcomeNote: '',
      gameThankYouMessage: '',
      gameIsCollectLearnerFeedback: 'false',
      gameIsFeedbackMandatory: 'false',
      gameIsLearnerMandatoryQuestion: 'false',

      gameIsSetCongratsSingleMessage: 'false',

      gameIsShowTakeaway: 'false',
      gameIsShowSkill: 'false',
      gameIsShowStoryline: 'false',
      gameIsShowLearningOutcome: 'false',
      gameIsShowGameDuration: 'false',
      gameIsShowAuhorName: 'false',
      gameIsShowAdditionalWelcomeNote: 'false',
      gameReplayAllowed: null,
      gameReflectionpageAllowed: null,
      gameLeaderboardAllowed: null,
      gameReflectionPageId: null,
      gameSummarizes: null,
      gameThankYouPage: null,
      gamWelcomePageText: null,
      gameScormVersion: null,
      gameSummaryScreen: null,
      gameLaunchedWithinPlatform: null,
      gameLastTab: null,
      gameLastTabArray: null,
      refQuestion: [],
      gameDownloadedAsScorm: null,
      gameDefaultFeedbackForm: null,
      gameFeedbackQuestion: null,
      gameLanguageId: 1,
      gameShuffle: 'false',
      // gameIsShowInteractionFeedBack: '',
      gameDisableOptionalReplays: 'false',
      gameTrackQuestionWiseAnswers: 'false',
      gameDisableLearnerMailNotifications: 'false',
      gameenableVoiceOver: 'false',
      gameIntroMusic: null,
      gameIntroMusicName: null,
      gameGameStage: 'Creation',
      gameCompletionScreenId: null,
      gameLeaderboardScreenId: null,
      // gameReflectionPageId: null,
      gameReflectionScreenId: null,
      gameTakeawayScreenId: null,
      gameWelcomepageBackgroundScreenId: null,
      gameThankYouScreenId: null,
      gamelanguageCode: '',

      gameQuestion1: 'false',
      gameQuestion2: 'false',
      gameQuestionValue1: '',
      gameQuestionValue2: '',
      gameQuestionValue3: '',
      gameQuestionValue4: '',
      gameContent: 'false',
      gameRelevance: 'false',
      gameBehaviour: 'false',
      gameOthers: 'false',
      gameGamification: 'false',
      gameRecommendation: 'false',
      gameFeedBack: 'false',
      gameFeedBackLink: '',
      gameIsShowAdditionalWelcomeNoteInvalid: 'false',
      isCategoryIdInvalid: false,

      isStoryTitleInvalid: false,
      isSkillsInvalid: false,
      isfeedbackthankyou: false,

      gameVoiceClickCount: 0,
    });
  const [selectedCardIndex, setSelectedCardIndex] = useState(
    parseInt(formData.gameBackgroundId) - 1,
  );

  const [clickCount, setClickCount] = useState(0);
  const [compliData, setCompliData] = useState({
    0: {
      gameQuestNo: null,
      gameTotalScore: 0,
      gameIsSetMinPassScore: null,
      gameMinScore: null,
      gameIsSetDistinctionScore: null,
      gameDistinctionScore: null,
      gameIsSetSkillWiseScore: null,
      gameIsSetBadge: null,
      gameBadge: null,
      gameBadgeName: null,
      gameIsSetCriteriaForBadge: null,
      gameAwardBadgeScore: null,
      gameScreenTitle: isNull,
      gameCompletedCongratsMessage: null,
      gameIsSetCongratsScoreWiseMessage: null,
      gameMinimumScoreCongratsMessage: null,
      gameaboveMinimumScoreCongratsMessage: null,
      gameLessthanDistinctionScoreCongratsMessage: null,
      gameAboveDistinctionScoreCongratsMessage: null,
      gameIsSetCongratsSingleMessage: 'false',
      trasulationId: formData.gameLanguageId,
    },
  });
  const [reviews, setReviews] = useState<any[]>([]);

  const [reviewers, setReviewers] = useState<any[]>([]);
  const [reviewAlert, setReviewAlert] = useState<boolean>(false);

  const [completedReview, setCompletedReview] = useState<boolean>(false);
  const [reviewUnReadAlert, setReviewUnReadAlert] = useState<boolean>(false);
  const [unreadCount, setUnreadCount] = useState<boolean>(false);

  const [Completion, setCompletion] = useState<any>({});

  const [CompKeyCount, setCompKeyCount] = useState<any>(0);
  const [prevdata, setPrevdata] = useState();

  const [readMore, setReadMore] = useState(null);

  const { id, val } = useParams();
  const inputRef = useRef<HTMLButtonElement>(null);
  const [voices, setVoices] = useState([]);
  const dispatch: Dispatch<any> = useDispatch();

  //This state for refelection Answer show  and Thankyou feedback in thers textbox;
  const [RefelectionAnswer, setRefelectionAnswer] = useState<any>([]);
  const [ThankyouFeedback, setThankyouFeedback] = useState<any>(null);
  const user: any = JSON.parse(localStorage.getItem('user'));
  const [isGameHasBlock, setIsGameHasBlock] = useState(false);
  const [content, setContent] = useState<any>({
    newInputValue: '',
    fieldName: '',
  });
  //to detect the form data changes
  const prevFormDataRef = useRef(null);
  const prevCompliDataRef = useRef(null);
  const [isTabOnlyChange, setIsTabOnlyChange] = useState(false);

  const [launchPopup, setLaunchPopup] = useState(false);
  const [close, setClose] = useState(false);
  const [modalPopup, setModalPopup] = useState(false);
  const [EnableVoiceCallApi, setEnableVoiceCallApi] = useState(false);

  const voic = async () => {
    const result = await getVoices();
    console.log(result, 'resultingamepreviewvoice');
    if (result) {
      setVoices(result?.voices);
    }
  };
  let menuBg = useColorModeValue('white', 'navy.800');
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)',
  );

  const fetchImageData = async () => {
    const resolvedResult: any = await preloadedImages(assetImageSrc);

    setstaticAssetImageUrls(resolvedResult);
  };
  useEffect(() => {
    fetchImageData();
  }, []);
  useEffect(() => {
    fetchImageData();
  }, [id]);

  ////////////////Over view //////////////
  const fetchDefaultSkill = async () => {
    const result = await getDefaultSkill(id);
    if (result?.status !== 'Success')
      return console.warn('getSkills Error :', result?.error);
    if (result?.data) {
      setDefaultSkills(result?.data);
    } else {
      setDefaultSkills([]);
    }
  };

  useEffect(() => {
    if (defaultskills.length === 0 && id) {
      fetchDefaultSkill();
    }
    if (id) {
      let PreviewgameId = parseInt(id);
      dispatch(createPreviewData(PreviewgameId));
    }

    return () => {
      id && dispatch(removeGame(id));
    };
  }, [id]);
  useEffect(() => {
    voic();
  }, []);
  const userDetails = JSON.parse(localStorage.getItem('user')) || {};

  const getGameOwnerId = (gameData: any) => {
    if (!gameData) return null;

    const explicitOwner =
      gameData.creatorId ??
      gameData.createdBy ??
      gameData.created_by ??
      gameData.ctCreatorId ??
      gameData.gameCreatorId ??
      gameData.gameCreatedBy ??
      gameData.creator_id ??
      gameData.creatorid ??
      gameData.createdby ??
      gameData.userId ??
      gameData.user_id ??
      gameData?.creator?.id ??
      null;

    if (explicitOwner !== null && explicitOwner !== undefined) {
      return explicitOwner;
    }

    const keys = Object.keys(gameData);
    for (const key of keys) {
      const normalizedKey = key.toLowerCase();
      if (
        (normalizedKey.includes('creator') ||
          normalizedKey.includes('createdby') ||
          normalizedKey.includes('created') ||
          normalizedKey.includes('user')) &&
        normalizedKey.includes('id')
      ) {
        const value = gameData[key];
        if (value !== null && value !== undefined && value !== '') {
          return value;
        }
      }
    }

    return null;
  };

  const isAuthorizedCreator = (gameOwnerId: any) => {
    const currentUserId = userDetails?.data?.id?.toString();
    const currentUserRole = userDetails?.data?.role?.toString().toLowerCase();
    const ownerIdString =
      gameOwnerId !== undefined && gameOwnerId !== null
        ? gameOwnerId.toString().trim()
        : null;

    if (currentUserRole !== 'creator') {
      return true;
    }

    if (!currentUserId) {
      return false;
    }

    if (!ownerIdString) {
      console.warn('Creator cannot be authorized because owner ID could not be determined from game record.');
      return false;
    }

    return currentUserId === ownerIdString;
  };

  const denyUnauthorizedGameAccess = () => {
    toast({
      title: 'Access denied',
      description:
        'You do not have permission to access this game. Redirecting to game home.',
      status: 'error',
      duration: 2000,
      isClosable: true,
    });
    navigate('/admin/superadmin/game/home', { replace: true });
  };

  const fetchData = async () => {
    const ctId = userDetails?.data?.id.toString();

    const result = await getImages(1, ctId);
    if (result?.status !== 'Success')
      return console.warn('getbackruond error:' + result?.message);

    setImg(result?.data);
    const players = await getImages(2, ctId);
    if (players?.status !== 'Success')
      return console.warn('getbackruond error:' + players?.message);
    setPlayers(players?.data);
  };
  interface OptionType {
    value: string;
    label: string;
  }
  useEffect(() => {
    setFormData((prev) => ({ ...prev, gameLastTab: tab }));
    if (tab == 5) {
      handleCompletionScreen(1);
    }
  }, [tab]);
  let borderColor = useColorModeValue('secondaryGray.100', 'whiteAlpha.100');
  const [languageOptions, setLanguageOptions] = useState([]);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [languages, setLanguage] = useState<number>(1);
  const [gameOwnerId, setGameOwnerId] = useState<any>(null);
  const defaultLanguageOption = { label: 'English', value: 1 };
  useEffect(() => {
    const fetchLanguages = async () => {
      const ChooseLangId = formData?.gameLanguageId;
      try {
        const selectedLanguagesResult = await getSelectedLanguages(id);

        if (
          selectedLanguagesResult &&
          selectedLanguagesResult.data &&
          selectedLanguagesResult.data.selectedLanguages
        ) {
          const options = selectedLanguagesResult.data.selectedLanguages.map(
            (language: SelectedLanguageEntry) => ({
              value: language['translationId'],
              label: language['lmsMultiLanguageSupport.language_name'],
              selected: language['translationId'] === ChooseLangId,
            }),
          );
          setLanguageOptions(options);
        } else {
          console.error(
            'Error: Selected languages data is missing or in unexpected format.',
          );
        }
      } catch (error) {
        console.error('Error:', error);
      }
    };

    if (isMenuOpen && tab !== 1) {
      fetchLanguages();
      setMenuOpen(false); // Close the menu after fetching
    }
  }, [id, isMenuOpen, tab]);

  const fetchLanguagescount = async () => {
    try {
      const CountResult = await getLanguagescount(id);
      setlanguageCount(CountResult?.data?.count);
    } catch (error) {
      console.error('Error:', error);
    }
  };

   useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user'));
        const userId = user?.data?.id;
    
        console.log('Login user id:', userId);
    
        if (userId) {
          // First get user details including company ID
          getCreator(userId)
            .then((userResult) => {
              console.log('Complete login user data:', userResult);
    
              if (userResult?.data?.ctCompanyId) {
                const companyId = userResult.data.ctCompanyId;
                console.log('User company ID:', companyId);
    
                // Now fetch company details using company ID
                return getCompany(companyId).then((companyResult) => {
                  console.log('Company details:', companyResult);
    
                  // Get company name - data is an array, so use [0]
                  const companyName = companyResult?.data?.[0]?.cpCompanyName;
    
                  console.log('User belongs to company:', companyName);
    
                  // Now you can use companyName for your logic
                  if (companyName?.toLowerCase() === 'cognizant'|| 'CTS') {
                    setShowReflectionQuestions(true);
                    // setshowScenarioCompletion(true);
                  } else {
                    setShowReflectionQuestions(false);
                    // setshowScenarioCompletion(false);
                  }
                });
              } else {
                console.log('User has no company ID');
                setShowReflectionQuestions(false);
                // setshowScenarioCompletion(false);
              }
            })
            .catch((error) => {
              console.error('Error fetching user or company details:', error);
              setShowReflectionQuestions(false);
              // setshowScenarioCompletion(false);
            });
        }
      }, []);
  useEffect(() => {
    const previewElement = document.querySelector('.css-gbtzxi') as HTMLElement;

    if (previewElement) {
      if (!previewElement.dataset.originalDisplay) {
        previewElement.dataset.originalDisplay =
          getComputedStyle(previewElement).display || 'block';
      }

      if (loading) {
        previewElement.style.display = 'none';
      } else {
        previewElement.style.display = previewElement.dataset.originalDisplay;
      }
    }
  }, [loading]);

  useEffect(() => {
    const previewElement = document.querySelector(
      '.game-creation-preview',
    ) as HTMLElement;

    if (previewElement) {
      // Store original display in dataset if not already stored
      if (!previewElement.dataset.originalDisplay) {
        previewElement.dataset.originalDisplay =
          getComputedStyle(previewElement).display || 'block';
      }

      if (loading) {
        previewElement.style.display = 'none';
      } else {
        previewElement.style.display = previewElement.dataset.originalDisplay;
      }
    }
  }, [loading]);

  useEffect(() => {
    fetchLanguagescount();
  }, []);

  const handleSelectChange = async (selectedOption: {
    value: any;
    label: string;
  }) => {
    setLanguage(selectedOption.value);
    dispatch(
      updatePreviewData({
        gameId: parseInt(id),
        gameLanguage: selectedOption.value,
        isModified: true,
      }),
    );
  };
  const getGameOverViewTransContent = async (gameLanguageId: number) => {
    if (gameLanguageId === 1) {
      const gameById = await getGameById(id);
      if (gameById?.status !== 'Success')
        return console.warn('error:' + gameById?.message);

      const ownerId = getGameOwnerId(gameById?.data);
      if (!isAuthorizedCreator(ownerId)) {
        denyUnauthorizedGameAccess();
        return;
      }

      setFormData((prev: any) => ({
        ...prev,
        gameStoryLine: gameById.data.gameStoryLine,
        gameTitle: gameById.data.gameTitle,
        gameTakeawayContent: gameById.data.gameTakeawayContent,
        gameAdditionalWelcomeNote: gameById.data.gameAdditionalWelcomeNote,
        gameThankYouMessage: gameById.data.gameThankYouMessage,
        gameAuthorName: gameById.data.gameAuthorName,
        gameNonPlayerName: gameById.data.gameNonPlayerName,
        gameLearningOutcome: gameById.data.gameLearningOutcome,
        gameLanguageId: parseInt(gameById.data.gameLanguageId),
      }));

      setDefaultstatus(true);
    } else {
      if (!isAuthorizedCreator(gameOwnerId)) {
        denyUnauthorizedGameAccess();
        return;
      }

      const blockData = await getGameStoryLine(id, gameLanguageId);

      setFormData((prev: any) => ({
        ...prev,
        gameStoryLine: blockData.gameStoryLine,
        gameTitle: blockData.gameTitle,
        gameLearningOutcome: blockData.gameLearningOutcome ?? '',
        gameTakeawayContent: blockData.gameTakeawayContent,
        gameAdditionalWelcomeNote: blockData.gameAdditionalWelcomeNote,
        gameThankYouMessage: blockData.gameThankYouMessage,
        gameAuthorName: blockData.gameAuthorName,
        gameNonPlayerName: blockData.gameNonPlayerName,
        gameLanguageId: parseInt(blockData.gameLanguageId),
      }));
    }
  };

  const handleBackGroundImage = (e: any) => {
    setFormData((prev) => ({
      ...prev,
      gameWelcomepageBackground: e.target.id,
    }));
  };

  const handleH = (i: any) => {
    setBackgroundIndex(i);
  };
  const handleL = () => {
    setBackgroundIndex('');
  };

  const skillMapping: Record<number, string[]> = {
    1: ['Delegation', 'Accountability', 'Motivation'],
    2: ['New Manager', 'Collaboration', 'Building Trust'],
    3: ['Sales', 'Interpersonal Skills', 'Persuasion'],
    4: ['Customer Centricity', 'Customer Service', 'Problem Solving'],
    5: ['Conflict Resolution', 'Collaboration', 'Managing a Team'],
    6: ['Change Management', 'Emotional Intelligence', 'Leadership'],
    7: ['Negotiation', 'Persuasion', 'Strategic Thinking'],
    8: ['Any Topic'],
    9: ['Employee Retention', 'Problem Solving', 'Negotiation'],
    12: [
      'Difficult Conversations',
      'Emotional Intelligence',
      'Giving Feedback',
    ],
    11: ['Difficult Conversations', 'Problem Solving', 'Accountability'],
    10: ['Situational Leadership', 'Coaching', 'Empathy'],
  };

  const handlePreview = (img: any, backgroundIndex: any, i: any) => {
    const skills = skillMapping[img?.gasId] || [];

    setPreview(true);
    setFetchImg((prev: any) => {
      return {
        ...prev,
        gasId: img?.gasId,
        gasAssetImage: img?.gasAssetImage,
        gasAssetName: img?.gasAssetName,
        backgroundIndex,
        i,
        skills,
        temp: {
          tempTitle: img.temp.tempTitle,
          tempStoryLine: img.temp.tempStoryLine,
        },
      };
    });
    onOpen();
  };
  const updateQuestBackground = (questNo: number, backgroundId: number) => {
    setBackgroundquestImage((prev) => {
      const questKey = `quest${questNo}`;

      const existingIndex = prev.findIndex(
        (q) => q[questKey] !== undefined
      );

      // ✅ Update existing quest
      if (existingIndex !== -1) {
        const updated = [...prev];
        updated[existingIndex] = { [questKey]: backgroundId };
        return updated;
      }

      // ✅ Add new quest
      return [...prev, { [questKey]: backgroundId }];
    });
  };
  const mapQuestBackgrounds = (allquestData: any[]) => {
    if (!Array.isArray(allquestData)) return [];

    return allquestData.map((quest) => ({
      [`quest${quest.gameQuestNo}`]: quest.gameBackgroundId,
    }));
  };
  const fetchGameId = async () => {
    setLoading(true);
    const reviews = await getAllReviews(id);

    if (reviews && reviews?.status !== 'Success')
      return console.warn(reviews?.message);
    const countAlert = await countofReviews(JSON.stringify(reviews));

    if (countAlert?.status === 'Success') {
      if (id === reviews?.gameId) {
        if (countAlert?.data > 0) {
          setReviewAlert(true);
          setCompletedReview(true);
          setReviewUnReadAlert(false);
        } else {
          if (countAlert?.countofUnread && countAlert?.countofUnread !== 0) {
            setUnreadCount(countAlert?.countofUnread);
            setReviewAlert(true);
            setReviewUnReadAlert(true);
            setCompletedReview(false);
          } else {
            setReviewAlert(false);
            setReviewUnReadAlert(false);
            setCompletedReview(false);
          }
        }
      }
    } else {
      setReviewAlert(false);
      setReviewUnReadAlert(false);
      setCompletedReview(false);
    }
    setReviewers(reviews?.reviewerDetails);
    setReviews(reviews?.reviewlist);
    const images = await getCreatorBlocks(id);
    if (images?.status !== 'Success') {
    } else {
      setCblocks(images?.data);
      setQuest(images?.quest);
    }

    const gameById = await getGameById(id);
    if (gameById?.status !== 'Success') {
      console.warn('error:' + gameById?.message);
      setLoading(false);
      return false;
    }

    const ownerId = getGameOwnerId(gameById?.data);
    setGameOwnerId(ownerId);
    if (!isAuthorizedCreator(ownerId)) {
      denyUnauthorizedGameAccess();
      setLoading(false);
      return false;
    }

    setDefaultstatus(true);
       console.log('gameById?.data=>',gameById?.data)
    // setFormData({
    //   ...gameById?.data,
    //   gameNonPlayerOption:gameById?.data?.gameNonPlayerOption.length > 0 ? JSON.parse(gameById?.data?.gameNonPlayerOption):[]
    // });

    setFormData({
  ...gameById?.data,
  gameNonPlayerOption:
    typeof gameById?.data?.gameNonPlayerOption === "string"
      ? JSON.parse(gameById?.data?.gameNonPlayerOption)
      : gameById?.data?.gameNonPlayerOption || [],
});

    setLanguage(gameById?.data.gameLanguageId);
    if (gameById?.allquestData?.length > 0) {
      const questBackgrounds = mapQuestBackgrounds(
        gameById.allquestData
      );
      setBackgroundquestImage(questBackgrounds);
    }
    const stringContainingNumbers = gameById?.data?.gameLastTabArray;
    const stringGameLastTab = gameById?.data?.gameLastTab;
    if (
      gameById?.data?.gameGameStage === null ||
      gameById?.data?.gameGameStage === ''
    ) {
      alert(gameById?.data?.gameGameStage);
      setFormData((prev) => ({ ...prev, gameGameStage: 'Creation' }));
    }
    if (stringGameLastTab === 111) {
      setTab(1);
      setFormData((prev) => ({ ...prev, gameLastTab: 1 }));
    } else if (stringContainingNumbers) {
      const numbersArray = stringContainingNumbers?.match(/\d+/g);

      if (numbersArray?.length === 1) {
        setTab(2);
        setFormData((prev) => ({ ...prev, gameLastTab: 2 }));
      } else {
        setTab(stringGameLastTab);
      }
    }
    const storedSelectedIndex = localStorage.getItem('selectedCardIndex');
    if (storedSelectedIndex !== null) {
      setSelectedCardIndex(parseInt(formData.gameBackgroundId) - 1);
    }
    setAtuoSave(true);

    const review = await getAllReviews(id);
    if (review && review?.status !== 'Success') {
      console.warn(review?.message);
      setLoading(false);
      return false;
    }
    setReviewers(review?.reviewerDetails);
    setReviews(review?.reviewlist);
    setLoading(false);
    return true;
  };

  const handleReviewOkAlert = async () => {
    const data = JSON.stringify(reviewers);
    await updateReadStatusforalert(id, data);
  };

  const handleGet = async (quest: number) => {
    setAtuoSave(false);
    const maxInputItem = items.reduce(
      (max: any, item: any) => (item.input > max.input ? item : max),
      items[0],
    );

    const lastInput = maxInputItem?.input ? maxInputItem.input + 1 : 1;
    try {
      const data = {
        quest: quest,
        transulateId: languages ? languages : 1,
      };
      const result = await getStory(id, JSON.stringify(data));
      if (result?.status !== 'Success') {
        return console.warn('updateBackground error :' + result?.err);
      } else {
        setserias(result.serias);
        setCount(result.count);
        if (result.alpacount) {
          setAlphabetCount(result.alpacount);
        }
        if (result.maxInput) {
          const itemsArray = Object.values(result.items);
          let sequance = itemsArray.map((it: any) => it.id);
          let upNext = itemsArray.map((it: any) => it.upNext);
          setSequence(sequance);
          setUpNextCount(upNext);
          setDummySequence(sequance);
          setItems(itemsArray);
          setInput(result.input);
          setAlphabet(Object.values(result.alp));
          setInteractionBlock(result.intra);
          setBlockItems(result.items);
        } else {
          setItems([]);
          setSequence([]);
          setUpNextCount([]);
          setDummySequence([]);
          setInput([]);
          setInteractionBlock([]);
          setBlockItems([]);
        }
        setTimeout(() => {
          setAtuoSave(true);
        }, 2000);
      }
    } catch (error) {
      setAtuoSave(true);
      console.error('An error occurred while sending the request:', error);
    }
  };

  const handleCompletionScreen = async (quest: number) => {
    setAtuoSave(false);

    try {
      const data = {
        quest: 1,
        translationId: languages ? languages : 1 /**Lokie New */,
      };
      const result = await getCompletionScreen(id, JSON.stringify(data));

      if (result?.status !== 'Success') {
        setAtuoSave(true);
        return false;
      } else {
        setCompletion(result?.data);
        setCompliData(result?.data);

        setCompKeyCount(Object.keys(result?.data).length - 1);

        if (formData && formData.gameLastTabArray) {
          const tabformArray = formData.gameLastTabArray;
          const findArrayValue = tabformArray.includes(5);

          if (findArrayValue) {
            // Lokie Add 12/06/2024
            setCurrentTab(currentTab);
          } else {
            setCurrentTab(0);
          }
        } else {
          setCurrentTab(0);
        }
        setAtuoSave(true);
      }
    } catch (error) {
      setAtuoSave(true);
    }
  };

  // const getDuration = async () => {
  //   try {
  //     const result = await getTotalMinofWords(id);
  //     if (result?.status !== 'Success') {
  //       return false;
  //     }

  //     setFormData({
  //       ...formData,
  //       gameDuration: result.totalMinutes,
  //     });
  //   } catch (error) {
  //     console.error('An error occurred while sending the request:', error);
  //   }
  // };

  const [intercount, setIntercount] = useState(0);
  const fetchBlockCount = async () => {
    const getblockcount = await getBlocks(id);

    if (getblockcount?.status === 'Success') {
      setIntercount(getblockcount?.count);
    }
  };
  const fetchBlocks = async () => {
    const result2 = await getListStory(id);

    if (result2?.status !== 'Success') {
    } else {
      setListBlockItems(result2?.BlockObject);
      const countOfBlock = Object.keys(result2?.BlockObject).some(
        (item: any) => item,
      );

      countOfBlock && setIsGameHasBlock(true);
      setListQuest(result2?.gameIn);
    }
  };
  useEffect(() => {
    fetchData();
    if (id) {
      setAtuoSave(false);
      fetchGameId();
      fetchBlocks();
      handleGet(1);
      fetchBlockCount();
      setExtensiveNavigation(null);
    }
  }, [id]);

  const handleGetReflection = async () => {
    const data = {
      translationId: languages ? languages : 1,
    };
    const storedReflection = await getReflection(id, JSON.stringify(data));
    if (storedReflection?.status !== 'Success') {
    }

    if (storedReflection?.data) {
      setReflectionQuestions(storedReflection?.data);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (languages !== formData.gameLanguageId) {
        setLoading(true);

        try {
          await getGameOverViewTransContent(languages);
          await handleGet(1);
          await handleGetReflection();
          await handleCompletionScreen(1);
        } catch (error) {
          console.error('Error fetching data:', error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchData();
  }, [languages]);

  useEffect(() => {
    if (id) {
      fetchBlocks();
      const keysToKeep = new Set(
        items.map((item: any) => item.type + item.input),
      );
      console.log('issuess', keysToKeep);
      // Filter the input object
      const newFilteredInput = Object.fromEntries(
        Object.entries(input).filter(([key]) => keysToKeep.has(key)),
      );
      setInput(newFilteredInput);
    }
  }, [id, items]);

  useEffect(() => {
    dispatch(
      updatePreviewData({
        gameId: parseInt(id),
        onFocusValue: null,
        modifiedField: null,
        updatedValue: null,
      }),
    );
  }, [CompKeyCount]);

  useEffect(() => {
    if (id) {
      const previewData: any = {
        gameId: parseInt(id),
        currentTab: tab,
        currentSubTab: currentTab,
        currentQuest: questTabState,
        activeBlockSeq: 1,
        isModified: false,
        CompKeyCount: 0,
        onFocusValue: null,
        isDispatched: false,
        modifiedField: null,
        updatedValue: null,
      };
      dispatch(updatePreviewData(previewData));
    }
  }, [id, tab, currentTab, questTabState]);

  const handleEntirePrev = async () => {
    const {
      CompKeyCount,
      activeBlockSeq,
      currentQuest,
      currentSubTab,
      currentTab,
      gameId,
      isDispatched,
      isModified,
      modifiedField,
      onFocusValue,
      updatedValue,
      gameLanguage,
    } = previewStoreData[parseInt(id)];
    let previewData: any = {};
    if (isModified === true && gameId === parseInt(id)) {
      previewData = {
        gameId: gameId,
        currentTab: currentTab,
        currentSubTab: currentSubTab,
        currentQuest: currentQuest,
        activeBlockSeq: activeBlockSeq,
        isModified: isModified,
        CompKeyCount: CompKeyCount,
        onFocusValue: onFocusValue,
        isDispatched: isDispatched,
        modifiedField: modifiedField,
        updatedValue: updatedValue,
        gameLanguage: gameLanguage,
      };
    } else {
      previewData = {
        gameId: parseInt(id),
        currentTab: tab,
        currentSubTab: currentTab,
        currentQuest: questTabState,
        activeBlockSeq: 1,
        isModified: false,
        CompKeyCount: 0,
        onFocusValue: null,
        isDispatched: false,
        modifiedField: null,
        updatedValue: null,
        isPreviewOpen: true,
        gameLanguage: 1,
      };
    }
    dispatch(updatePreviewData(previewData));

    // const Link = `${DemoPlayRoutePath+id}`;
    const Link = `${previewPlayRoutePath + id}`;
    window.open(Link, '_blank');
  };

  const handleShareReview = () => {
    setEntire(false);
    setShare(true);
    setPreview(false);
    onOpen();
  };
  const handleShowReview = () => {
    setShowReview(!ShowReview);
    const element = document.getElementById('handa');
    setTimeout(() => {
      const element3 = document.getElementById('screenReview');
      if (element && !ShowReview) {
        element3?.scrollIntoView({ behavior: 'smooth' });
      }
    }, 50);
  };

  const handleTrans = (tabs: number) => {
    let tabArray: number[] = [];

    // Watching Stepper Height for Green Progress
    const tab1 = document.getElementById(`tab1`);
    const title1 = tab1?.getAttribute('title');
    const getfirstElementHgt = tab1?.clientHeight;

    //tab2
    const tab2 = document.getElementById(`tab2`);
    const title2 = tab2?.getAttribute('title');
    const getsecondElementHgt = tab2?.clientHeight;
    //tab3
    const tab3 = document.getElementById(`tab3`);
    const title3 = tab3?.getAttribute('title');
    const getThirdElementHgt = tab3?.clientHeight;
    //tab4

    const tab4 = document.getElementById(`tab4`);
    const title4 = tab4?.getAttribute('title');
    const getFourElementHgt = tab4?.clientHeight + getfirstElementHgt;
    const tab4Height = tabs == 4 && getFourElementHgt + getfirstElementHgt;

    //tab5
    const tab5 = document.getElementById(`tab5`);
    const title5 = tab5?.getAttribute('title');
    const getFifthElementHgt = tab5?.clientHeight;
    //tab6
    const tab6 = document.getElementById(`tab6`);
    const title6 = tab6?.getAttribute('title');
    const getSixthElementHgt = tab6?.clientHeight;

    if (title6 === 'done') {
      setHeightOfTab(
        getfirstElementHgt +
          getsecondElementHgt +
          getThirdElementHgt +
          getFourElementHgt +
          getFifthElementHgt +
          getSixthElementHgt +
          150,
      );
    } else if (title5 === 'done') {
      setHeightOfTab(
        getfirstElementHgt +
          getsecondElementHgt +
          getThirdElementHgt +
          getFourElementHgt +
          getFifthElementHgt +
          120,
      );
    } else if (title4 === 'done') {
      setHeightOfTab(
        getfirstElementHgt +
          getsecondElementHgt +
          getThirdElementHgt +
          getFourElementHgt +
          90,
      );
    } else if (title3 === 'done') {
      setHeightOfTab(
        getfirstElementHgt + getsecondElementHgt + getThirdElementHgt + 60,
      );
    } else if (title2 === 'done') {
      setHeightOfTab(getfirstElementHgt + getsecondElementHgt + 30);
    } else if (title1 === 'done') {
      setHeightOfTab(getfirstElementHgt);
    }

    if (!formData?.gameLastTabArray?.includes(tabs)) {
      const stringContainingNumbers = formData.gameLastTabArray;
      if (typeof stringContainingNumbers === 'string') {
        tabArray = (stringContainingNumbers.match(/\d+/g) || []).map(Number);
      }
    } else {
      tabArray = formData.gameLastTabArray;
    }

    let lastValue: number;
    if (tabArray.length > 0) {
      lastValue = tabArray[tabArray.length - 1];
    } else {
    }

    if (tab > tabs) {
      setTab(tabs);
    }
    if (tab < tabs) {
      if (tabArray.includes(tabs) || tabs === lastValue + 1) {
        if (tab === 1) {
          if (!formData.gameBackgroundId) {
            toast({
              title: 'Please Select a background image.',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
            return false;
          }
        }
        if (tab === 2) {
          if (!formData.gameNonPlayerName) {
            toast({
              title: 'Please Enter a NonplayerName.',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
            return false;
          }
          if (!formData.gameNonPlayingCharacterId) {
            toast({
              title: 'Please Select a Character image.',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
            return false;
          }
          if (!formData.gameNonPlayerVoice) {
            toast({
              title: 'Please Select a NonPlayer Voice.',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
            return false;
          }
          if (!formData.gamePlayerMaleVoice) {
            toast({
              title: 'Please Select a Male Voice.',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
            return false;
          }
          if (!formData.gamePlayerFemaleVoice) {
            toast({
              title: 'Please Select a Female Voice.',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
            return false;
          }
            if (!formData.gamementorMaleVoice) {
            toast({
              title: 'Please Select a Mentor Male Voice.',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
            return false;
          }
          if (!formData.gamementorFemaleVoice) {
            toast({
              title: 'Please Select a Mentor Female Voice.',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
            return false;
          }
          if (!formData.gameNarratorVoice) {
            toast({
              title: 'Please Select a Narrator Voice.',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
            return false;
          }
        }

        if (tab === 3) {
          if (!formData.gameTitle) {
            toast({
              title: 'Please Enter The Story Title',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
            setFormData({
              ...formData,
              isStoryTitleInvalid: true,
            });
            return false;
          }
          if (!formData.gameSkills || formData.gameSkills.length === 0) {
            toast({
              title: 'Please Enter The Skills',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
            setFormData({
              ...formData,
              isSkillsInvalid: true,
            });
            return false;
          }
          if (
            !formData.gameCategoryId ||
            formData.gameCategoryId.length === 0
          ) {
            toast({
              title: 'Please Enter The Category',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });

            return false;
          }
        }

        if (tab === 4) {
          if (items.length !== 0) {
            if (typeof items === 'object' && items !== null) {
              var inputData = items;
              for (var i = 0; i < inputData.length; i++) {
                var key = inputData[i];
                var inputkey = key.type + key.input;
                if (key.type === 'Note') {
                  var note = input[inputkey]?.note;

                  if (!note) {
                    toast({
                      title: `Note is empty on Block ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                  if (input[inputkey]?.NoteleadShow) {
                    if (
                      input[inputkey]?.NoteleadShow === 'New Block' ||
                      input[inputkey]?.NoteleadShow === 'Select Block'
                    ) {
                      if (!input[inputkey]?.Notenavigate) {
                        toast({
                          // title: `${input[inputkey]?.NoteleadShow} is Empty On This Sequence ${key.id} `,
                          title: `${input[inputkey]?.NoteleadShow} Navigate has not been selected on Block ${key.id} `,
                          status: 'error',
                          duration: 3000,
                          isClosable: true,
                        });
                        return false;
                      }
                    }
                  } else {
                    toast({
                      title: `Navigate has not been selected on Block  ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                }
                if (key.type === 'Link') {
                  var Link = input[inputkey]?.Link;

                  if (!Link) {
                    toast({
                      title: `Link is empty on Block ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                  if (input[inputkey]?.LinkleadShow) {
                    if (
                      input[inputkey]?.LinkleadShow === 'New Block' ||
                      input[inputkey]?.LinkleadShow === 'Select Block'
                    ) {
                      if (!input[inputkey]?.Linknavigate) {
                        toast({
                          title: `Navigate has not been selected on ${key.id} `,

                          status: 'error',
                          duration: 3000,
                          isClosable: true,
                        });
                        return false;
                      }
                    }
                  } else {
                    toast({
                      title: `Navigate has not been selected on Block  ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                }
		   if (key.type === 'WehaveChoose') {
                  var WehaveChoose = input[inputkey]?.WehaveChoose;

                  if (!WehaveChoose) {
                    toast({
                      title: `WehaveChoose is empty on Block ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                  if (input[inputkey]?.WehaveChooseleadShow) {
                    if (
                      input[inputkey]?.WehaveChooseleadShow === 'New Block' ||
                      input[inputkey]?.WehaveChooseleadShow === 'Select Block'
                    ) {
                      if (!input[inputkey]?.WehaveChoosenavigate) {
                        toast({
                          title: `Navigate has not been selected on ${key.id} `,

                          status: 'error',
                          duration: 3000,
                          isClosable: true,
                        });
                        return false;
                      }
                    }
                  } else {
                    toast({
                      title: `Navigate has not been selected on Block  ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                }
                 if (key.type === 'KeyInsights') {
                  var KeyInsights = input[inputkey]?.KeyInsights;

                  if (!KeyInsights) {
                    toast({
                      title: `KeyInsights is empty on Block ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                  if (input[inputkey]?.KeyInsightsleadShow) {
                    if (
                      input[inputkey]?.KeyInsightsleadShow === 'New Block' ||
                      input[inputkey]?.KeyInsightsleadShow === 'Select Block'
                    ) {
                      if (!input[inputkey]?.KeyInsightsnavigate) {
                        toast({
                          title: `Navigate has not been selected on ${key.id} `,

                          status: 'error',
                          duration: 3000,
                          isClosable: true,
                        });
                        return false;
                      }
                    }
                  } else {
                    toast({
                      title: `Navigate has not been selected on Block  ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                }
                 if (key.type === 'SwipeMiniGame') {
                  var SwipeMiniGame = input[inputkey]?.SwipeMiniGame;

                  if (!SwipeMiniGame) {
                    toast({
                      title: `SwipeMiniGame is empty on Block ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                  if (input[inputkey]?.SwipeMiniGameleadShow) {
                    if (
                      input[inputkey]?.SwipeMiniGameleadShow === 'New Block' ||
                      input[inputkey]?.SwipeMiniGameleadShow === 'Select Block'
                    ) {
                      if (!input[inputkey]?.SwipeMiniGamenavigate) {
                        toast({
                          title: `Navigate has not been selected on ${key.id} `,

                          status: 'error',
                          duration: 3000,
                          isClosable: true,
                        });
                        return false;
                      }
                    }
                  } else {
                    toast({
                      title: `Navigate has not been selected on Block  ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                }
                 if (key.type === 'DragForNow') {
                  var DragForNow = input[inputkey]?.DragForNow;

                  if (!DragForNow) {
                    toast({
                      title: `DragForNow is empty on Block ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                  if (input[inputkey]?.DragForNowleadShow) {
                    if (
                      input[inputkey]?.DragForNowleadShow === 'New Block' ||
                      input[inputkey]?.DragForNowleadShow === 'Select Block'
                    ) {
                      if (!input[inputkey]?.DragForNowenavigate) {
                        toast({
                          title: `Navigate has not been selected on ${key.id} `,

                          status: 'error',
                          duration: 3000,
                          isClosable: true,
                        });
                        return false;
                      }
                    }
                  } else {
                    toast({
                      title: `Navigate has not been selected on Block  ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                }
                if (key.type === 'PreAssessment') {
                  var PreAssessment = input[inputkey]?.PreAssessment;

                  if (!PreAssessment) {
                    toast({
                      title: `PreAssessment is empty on Block ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                  if (input[inputkey]?.PreAssessmentleadShow) {
                    if (
                      input[inputkey]?.PreAssessmentleadShow === 'New Block' ||
                      input[inputkey]?.PreAssessmentleadShow === 'Select Block'
                    ) {
                      if (!input[inputkey]?.PreAssessmentnavigate) {
                        toast({
                          title: `Navigate has not been selected on ${key.id} `,

                          status: 'error',
                          duration: 3000,
                          isClosable: true,
                        });
                        return false;
                      }
                    }
                  } else {
                    toast({
                      title: `Navigate has not been selected on Block  ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                }
                if (key.type === 'PostAssessment') {
                  var PostAssessment = input[inputkey]?.PostAssessment;

                  if (!PostAssessment) {
                    toast({
                      title: `PostAssessment is empty on Block ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                  if (input[inputkey]?.PostAssessmentleadShow) {
                    if (
                      input[inputkey]?.PostAssessmentleadShow === 'New Block' ||
                      input[inputkey]?.PostAssessmentleadShow === 'Select Block'
                    ) {
                      if (!input[inputkey]?.PostAssessmentnavigate) {
                        toast({
                          title: `Navigate has not been selected on ${key.id} `,

                          status: 'error',
                          duration: 3000,
                          isClosable: true,
                        });
                        return false;
                      }
                    }
                  } else {
                    toast({
                      title: `Navigate has not been selected on Block  ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                }
                if (key.type === 'validatePrompt') {
                  var validatePrompt = input[inputkey]?.validatePrompt;

                  if (!validatePrompt) {
                    toast({
                      title: `validatePrompt is empty on Block ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                  if (input[inputkey]?.validatePromptleadShow) {
                    if (
                      input[inputkey]?.validatePromptleadShow === 'New Block' ||
                      input[inputkey]?.validatePromptleadShow === 'Select Block'
                    ) {
                      if (!input[inputkey]?.validatePromptnavigate) {
                        toast({
                          title: `Navigate has not been selected on ${key.id} `,

                          status: 'error',
                          duration: 3000,
                          isClosable: true,
                        });
                        return false;
                      }
                    }
                  } else {
                    toast({
                      title: `Navigate has not been selected on Block  ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                }
                if (key.type === 'evaluationPrompt') {
                  var evaluationPrompt = input[inputkey]?.evaluationPrompt;

                  if (!evaluationPrompt) {
                    toast({
                      title: `evaluationPrompt is empty on Block ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                  if (input[inputkey]?.evaluationPromptleadShow) {
                    if (
                      input[inputkey]?.evaluationPromptleadShow === 'New Block' ||
                      input[inputkey]?.evaluationPromptleadShow === 'Select Block'
                    ) {
                      if (!input[inputkey]?.evaluationPromptnavigate) {
                        toast({
                          title: `Navigate has not been selected on ${key.id} `,

                          status: 'error',
                          duration: 3000,
                          isClosable: true,
                        });
                        return false;
                      }
                    }
                  } else {
                    toast({
                      title: `Navigate has not been selected on Block  ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                }
                if (key.type === 'Overview') {
                  var Overview = input[inputkey]?.Overview;

                  if (!Overview) {
                    toast({
                      title: `Overview is empty on Block ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                  if (input[inputkey]?.OverviewleadShow) {
                    if (
                      input[inputkey]?.OverviewleadShow === 'New Block' ||
                      input[inputkey]?.OverviewleadShow === 'Select Block'
                    ) {
                      if (!input[inputkey]?.Overviewnavigate) {
                        toast({
                          title: `Navigate has not been selected on ${key.id} `,

                          status: 'error',
                          duration: 3000,
                          isClosable: true,
                        });
                        return false;
                      }
                    }
                  } else {
                    toast({
                      title: `Navigate has not been selected on Block  ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                }
                if (key.type === 'ScenarioCompletion') {
                  var ScenarioCompletion = input[inputkey]?.ScenarioCompletion;

                  // if (!ScenarioCompletion) {
                  //   toast({
                  //     title: `ScenarioCompletion is empty on Block ${key.id} `,
                  //     status: 'error',
                  //     duration: 3000,
                  //     isClosable: true,
                  //   });
                  //   return false;
                  // }
                  if (input[inputkey]?.ScenarioCompletionleadShow) {
                    if (
                      input[inputkey]?.ScenarioCompletionleadShow === 'New Block' ||
                      input[inputkey]?.ScenarioCompletionleadShow === 'Select Block'
                    ) {
                      if (!input[inputkey]?.ScenarioCompletionnavigate) {
                        toast({
                          title: `Navigate has not been selected on ${key.id} `,

                          status: 'error',
                          duration: 3000,
                          isClosable: true,
                        });
                        return false;
                      }
                    }
                  } else {
                    toast({
                      title: `Navigate has not been selected on Block  ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                }
                if (key.type === 'Reflection') {
                  var Reflection = input[inputkey]?.Reflection;

                  if (!Reflection) {
                    toast({
                      title: `Reflection is empty on Block ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                  if (input[inputkey]?.ReflectionleadShow) {
                    if (
                      input[inputkey]?.ReflectionleadShow === 'New Block' ||
                      input[inputkey]?.ReflectionleadShow === 'Select Block'
                    ) {
                      if (!input[inputkey]?.Reflectionnavigate) {
                        toast({
                          title: `Navigate has not been selected on ${key.id} `,

                          status: 'error',
                          duration: 3000,
                          isClosable: true,
                        });
                        return false;
                      }
                    }
                  } else {
                    toast({
                      title: `Navigate has not been selected on Block  ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                }
                if (key.type === 'Dialog') {
                  var Dialog = input[inputkey]?.dialog;
                  var animation = input[inputkey]?.animation;
                  var voice = input[inputkey]?.voice;
                  var character = input[inputkey]?.character;
                  if (!Dialog) {
                    toast({
                      title: `Dialogue is empty on Block ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                  if (
                    character !== '99999' &&
                    character !== 99999 &&
                    !animation
                  ) {
                    toast({
                      title: `Animate is empty on Block ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                  if (input[inputkey]?.DialogleadShow) {
                    if (
                      input[inputkey]?.DialogleadShow === 'New Block' ||
                      input[inputkey]?.DialogleadShow === 'Select Block'
                    ) {
                      if (!input[inputkey]?.Dialognavigate) {
                        toast({
                          title: `${input[inputkey]?.DialogleadShow} Navigate has not been selected on Block ${key.id} `,
                          status: 'error',
                          duration: 3000,
                          isClosable: true,
                        });
                        return false;
                      }
                    }
                  } else {
                    toast({
                      title: `Navigate has not been selected on Block  ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                }
                if (key.type === 'Interaction') {
                  var QuestionsEmotion = input[inputkey]?.QuestionsEmotion;
                  var blockRoll = input[inputkey]?.blockRoll;
                  var interaction = input[inputkey]?.interaction;
                  var character = input[inputkey]?.character;
                  if (!interaction) {
                    toast({
                      title: `Question is empty on Block ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                  if (
                    blockRoll !== '99999' &&
                    blockRoll !== 99999 &&
                    !QuestionsEmotion
                  ) {
                    toast({
                      title: `Question is empty on Block ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                  if (!blockRoll) {
                    toast({
                      title: `Character has not been selected on Block  ${key.id} `,
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    return false;
                  }
                  if (typeof alphabet === 'object' && alphabet !== null) {
                    var alphabetData = alphabet;

                    for (const alp of alphabetData?.filter(
                      (alp: any) => key.id === alp.seqs,
                    ) || []) {
                      if (!input[inputkey]?.optionsObject[alp.option]) {
                        var option = alp.option;
                        toast({
                          title: `${option} is empty on Block ${key.id} `,
                          status: 'error',
                          duration: 3000,
                          isClosable: true,
                        });
                        return false;
                      }
                      if (!input[inputkey]?.optionsemotionObject[alp.option]) {
                        var option = alp.option;
                        toast({
                          title: `${option} is Empty On This Sequence ${key.id} Please Select`,
                          status: 'error',
                          duration: 3000,
                          isClosable: true,
                        });
                        return false;
                      }
                      let isAtLeastOneTrue = false;

                      for (const option of alphabet.map(
                        (alp: any) => alp.option,
                      )) {
                        if (
                          input[inputkey]?.ansObject[option] === 'true' ||
                          input[inputkey]?.ansObject[option] === true
                        ) {
                          const ansValue = input[inputkey]?.ansObject[option];
                          isAtLeastOneTrue = true;
                          if (!input[inputkey]?.scoreObject[option]) {
                            toast({
                              title: `At least one option must have a score on Block ${key.id}`,
                              status: 'error',
                              duration: 3000,
                              isClosable: true,
                            });
                            return false;
                          }
                        }
                      }
                      if (!isAtLeastOneTrue) {
                        toast({
                          title: `At least one option must be selected on this sequence ${key.id}`,
                          status: 'error',
                          duration: 3000,
                          isClosable: true,
                        });
                        return false;
                      }
                      // Lokie Work Here
                      if (
                        input[inputkey]?.navigateshowObjects[alp.option] !== ''
                      ) {
                        if (
                          input[inputkey]?.navigateshowObjects[alp.option] ===
                            'New Block' ||
                          input[inputkey]?.navigateshowObjects[alp.option] ===
                            'Select Block'
                        ) {
                          if (!input[inputkey]?.navigateObjects[alp.option]) {
                            toast({
                              title: `${alp.option} is Empty On This Sequence ${key.id} `,
                              status: 'error',
                              duration: 3000,
                              isClosable: true,
                            });
                            return false;
                          }
                        }
                      } else {
                        toast({
                          title: `This ${alp.option} is Empty On This Sequence ${key.id} `,
                          status: 'error',
                          duration: 3000,
                          isClosable: true,
                        });
                        return false;
                      }
                      //End Lokie Work Here
                    }
                  }
                }
              }
            }
          } else {
            toast({
              title: `Create Your Story !!`,
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
            return false;
          }
        }
        if (tab === 5) {
          // Completion Screen Validation
          const complidatalength = Object.keys(compliData).length;
          const getcompliData = Object.keys(compliData);

          if (complidatalength !== 0) {
            for (let i = 0; i < complidatalength; i++) {
              const compkey = getcompliData[
                i
              ] as unknown as keyof typeof compliData;
              const compkeyNumber = Number(compkey);
              const getgameTotalScore = compliData[compkey].gameTotalScore;
              if (
                Array.isArray(getgameTotalScore) &&
                getgameTotalScore.length > 0
              ) {
                const maxScore = getgameTotalScore[0].maxScore;
                if (!maxScore) {
                  toast({
                    title: 'Please Enter Total Score.',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  setCompKeyCount(compkeyNumber);
                  setCurrentTab(0);
                  return false;
                }
              }
              if (compliData[compkey]?.gameIsSetMinPassScore === 'true') {
                if (!compliData[compkey]?.gameMinScore) {
                  toast({
                    title: 'Please Enter Minimum Score.',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  setCompliData((prevInput: any) => ({
                    ...prevInput,
                    [CompKeyCount]: {
                      ...prevInput[CompKeyCount],
                      redBorderForMinScore: true,
                    },
                  }));
                  setCompKeyCount(compkeyNumber);
                  setCurrentTab(0);
                  return false;
                }

                // Reset the red border style for the InputField
                setCompliData((prevInput: any) => ({
                  ...prevInput,
                  [CompKeyCount]: {
                    ...prevInput[CompKeyCount],
                    redBorderForMinScore: false,
                  },
                }));
              }
              if (compliData[compkey]?.gameIsSetDistinctionScore === 'true') {
                if (!compliData[compkey]?.gameDistinctionScore) {
                  toast({
                    title: 'Please Enter Distinction  Score.',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  setCompKeyCount(compkeyNumber);
                  setCurrentTab(0);
                  return false;
                }
              }
              if (compliData[compkey]?.gameIsSetBadge === 'true') {
                if (!compliData[compkey]?.gameBadge) {
                  toast({
                    title: 'Please Select Badge.',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  setCompKeyCount(compkeyNumber);
                  setCurrentTab(0);
                  return false;
                }
                if (!compliData[compkey]?.gameBadgeName) {
                  toast({
                    title: 'Please Fill Badge Name.',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  setCompKeyCount(compkeyNumber);
                  setCurrentTab(0);
                  return false;
                }
              }
              if (compliData[compkey]?.gameIsSetCriteriaForBadge === 'true') {
                if (!compliData[compkey]?.gameAwardBadgeScore) {
                  toast({
                    title: 'Please Set Criteria for Badge .',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  setCompKeyCount(compkeyNumber);
                  setCurrentTab(0);
                  return false;
                }
              }
              if (!compliData[compkey]?.gameScreenTitle) {
                toast({
                  title: 'Please Provide a screen Title.',
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
                });
                setCompKeyCount(compkeyNumber);
                setCurrentTab(0);
                return false;
              }
              if (
                compliData[compkey]?.gameIsSetCongratsSingleMessage === 'true'
              ) {
                if (!compliData[compkey]?.gameCompletedCongratsMessage) {
                  toast({
                    title: 'Please Set CongratsMessage.',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  setCompKeyCount(compkeyNumber);
                  setCurrentTab(0);
                  return false;
                }
              }
              if (
                compliData[compkey]?.gameIsSetCongratsScoreWiseMessage ===
                'true'
              ) {
                if (compliData[compkey]?.gameIsSetMinPassScore === 'true') {
                  if (!compliData[compkey]?.gameMinimumScoreCongratsMessage) {
                    toast({
                      title: 'Please Enter Minimum Score Congrats Message.',
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    setCompKeyCount(compkeyNumber);
                    setCurrentTab(0);
                    return false;
                  }
                  if (
                    !compliData[compkey]?.gameaboveMinimumScoreCongratsMessage
                  ) {
                    toast({
                      title:
                        'Please Enter Above Minimum Score CongratsMessage.',
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    setCompKeyCount(compkeyNumber);
                    setCurrentTab(0);
                    return false;
                  }
                }

                if (compliData[compkey]?.gameIsSetDistinctionScore === 'true') {
                  if (
                    !compliData[compkey]
                      ?.gameAboveDistinctionScoreCongratsMessage
                  ) {
                    toast({
                      title:
                        'Please Enter Above Distinction Score CongratsMessage.',
                      status: 'error',
                      duration: 3000,
                      isClosable: true,
                    });
                    setCompKeyCount(compkeyNumber);
                    setCurrentTab(0);
                    return false;
                  }
                }
              }

              setCompKeyCount(compkeyNumber);
              setCurrentTab(0);

              setCompliData((prevInput: any) => ({
                ...prevInput,
                [CompKeyCount]: {
                  ...prevInput[CompKeyCount],
                },
              }));
            }
          }
          // refelection Screen Validation
          if (formData.gameIsShowReflectionScreen === 'true') {
            if (
              typeof reflectionQuestions === 'object' &&
              reflectionQuestions !== null
            ) {
              var keys = Object.keys(reflectionQuestions);

              //newlyadded start
              if (!keys) {
                var keys1 = Object.keys(reflectionQuestions);
              } else {
                var keys1 = ['ref1', 'ref2', 'ref3', 'ref4'];
              }

              //newlyadded end
              // Assuming formData.gameReflectionQuestion is the number of questions to check
              for (var i = 0; i < formData.gameReflectionQuestion; i++) {
                const refkey = keys1[
                  i
                ] as unknown as keyof typeof reflectionQuestions; //changes keys1[i] instead of keys[i]
                var value = reflectionQuestions[refkey];
                if (refkey == 'ref1') {
                  var question = 'Question1';
                }
                if (refkey == 'ref2') {
                  var question = 'Question2';
                }
                if (refkey == 'ref3') {
                  var question = 'Question3';
                }
                if (refkey == 'ref4') {
                  var question = 'Question4';
                }

                if (!value) {
                  toast({
                    title: `${question} is empty. Please fill in the ${question} question.`,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  setCurrentTab(2);
                  return false;
                }
              }
            }
          }
          // Takeaway Screen Validation
          if (
            formData.gameIsShowTakeaway === 'true' &&
            (formData.gameTakeawayContent === null ||
              formData.gameTakeawayContent === undefined ||
              formData.gameTakeawayContent === '')
          ) {
            toast({
              title: 'Please Enter TakeAway Content',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
            setCurrentTab(3);
            return false;
          }
          // Welcome  Screen Validation
          if (
            formData.gameIsShowAdditionalWelcomeNote === 'true' &&
            (formData.gameAdditionalWelcomeNote === null ||
              formData.gameAdditionalWelcomeNote === undefined ||
              formData.gameAdditionalWelcomeNote === '')
          ) {
            toast({
              title: 'Please Add Welcome Note',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
            //newlyadded start
            setFormData({
              ...formData,
              gameIsShowAdditionalWelcomeNoteInvalid: 'true',
            });
            setCurrentTab(4);
            //newlyadded End
            return false;
          }
          // Thankyou Screen Validation
          if (
            formData.gameThankYouMessage === '' ||
            formData.gameThankYouMessage === null ||
            formData.gameThankYouMessage === undefined
          ) {
            toast({
              title: 'Please add a Thank You message',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
            setFormData({
              ...formData,
              isfeedbackthankyou: true,
            });
            setCurrentTab(5);
            return false;
          }
        }

        setTab(tabs);
      }
    }
  };
  ///navin 15-12
  //lokie work
  useEffect(() => {
    if (val === '1' && val !== undefined) {
      setTab(4);
    }
  }, [val]);
  //lokie work

  useEffect(() => {
    // Watching Stepper Height

    const tab1 = document.getElementById(`tab1`);
    const title1 = tab1?.getAttribute('title');
    const getfirstElementHgt = tab1?.clientHeight;
    //tab2
    const tab2 = document.getElementById(`tab2`);
    const title2 = tab2?.getAttribute('title');
    const getsecondElementHgt = tab2?.clientHeight;
    //tab3
    const tab3 = document.getElementById(`tab3`);
    const title3 = tab3?.getAttribute('title');
    const getThirdElementHgt = tab3?.clientHeight;
    //tab4
    const tab4 = document.getElementById(`tab4`);
    const taby4 = document.getElementById(`taby4`);
    const title4 = taby4?.getAttribute('title');
    const getFourElementHgt = tab4?.clientHeight + getfirstElementHgt;
    const tab4Height = tab == 4 && getFourElementHgt + getfirstElementHgt;

    //tab5
    const tab5 = document.getElementById(`tab5`);
    const title5 = tab5?.getAttribute('title');
    const getFifthElementHgt = tab5?.clientHeight;
    //tab6
    const tab6 = document.getElementById(`tab6`);
    const title6 = tab6?.getAttribute('title');
    const getSixthElementHgt = tab6?.clientHeight;

    if (title6 === 'done') {
      setHeightOfTab(
        getfirstElementHgt +
          getsecondElementHgt +
          getThirdElementHgt +
          getFourElementHgt +
          getFifthElementHgt +
          getSixthElementHgt +
          150,
      );
    } else if (title5 === 'done') {
      setHeightOfTab(
        getfirstElementHgt +
          getsecondElementHgt +
          getThirdElementHgt +
          getFourElementHgt +
          getFifthElementHgt +
          120,
      );
    } else if (title4 === 'done') {
      setHeightOfTab(
        getfirstElementHgt +
          getsecondElementHgt +
          getThirdElementHgt +
          getFourElementHgt +
          90,
      );
    } else if (title3 === 'done') {
      setHeightOfTab(
        getfirstElementHgt + getsecondElementHgt + getThirdElementHgt + 60,
      );
    } else if (title2 === 'done') {
      setHeightOfTab(getfirstElementHgt + getsecondElementHgt + 30);
    } else if (title1 === 'done') {
      setHeightOfTab(getfirstElementHgt);
    }
  }, [tab, listQuest?.length, questTabState]);

  const handleNext = async () => {
    if (!isNextClicked) {
      // Set to true only on the first click
      setNextClicked(true);
      setOkClose(true);
    } else {
      const selectedOptions = [
        formData.gameContent,
        formData.gameRecommendation,
        formData.gameRelevance,
        formData.gameGamification,
        formData.gameBehaviour,
        formData.gameOthers,
      ];
      // Completion Screen Validation
      const complidatalength = Object.keys(compliData).length;
      const getcompliData = Object.keys(compliData);
      if (complidatalength !== 0) {
        for (let i = 0; i < complidatalength; i++) {
          const compkey = getcompliData[
            i
          ] as unknown as keyof typeof compliData;
          const compkeyNumber = Number(compkey);
          const getgameTotalScore = compliData[compkey].gameTotalScore;
          if (
            Array.isArray(getgameTotalScore) &&
            getgameTotalScore.length > 0
          ) {
            const maxScore = getgameTotalScore[0].maxScore;
            if (!maxScore) {
              toast({
                title: 'Please Enter Total Score.',
                status: 'error',
                duration: 3000,
                isClosable: true,
              });
              setCompKeyCount(compkeyNumber);
              setCurrentTab(0);
              return false;
            }
          }
          if (compliData[compkey]?.gameIsSetMinPassScore === 'true') {
            if (!compliData[compkey]?.gameMinScore) {
              toast({
                title: 'Please Enter Minimum Score.',
                status: 'error',
                duration: 3000,
                isClosable: true,
              });
              setCompliData((prevInput: any) => ({
                ...prevInput,
                [CompKeyCount]: {
                  ...prevInput[CompKeyCount],
                  redBorderForMinScore: true,
                },
              }));
              setCompKeyCount(compkeyNumber);
              setCurrentTab(0);
              return false;
            }

            // Reset the red border style for the InputField
            setCompliData((prevInput: any) => ({
              ...prevInput,
              [CompKeyCount]: {
                ...prevInput[CompKeyCount],
                redBorderForMinScore: false,
              },
            }));
          }
          if (compliData[compkey]?.gameIsSetDistinctionScore === 'true') {
            if (!compliData[compkey]?.gameDistinctionScore) {
              toast({
                title: 'Please Enter Distinction  Score.',
                status: 'error',
                duration: 3000,
                isClosable: true,
              });
              setCompKeyCount(compkeyNumber);
              setCurrentTab(0);
              return false;
            }
          }
          if (compliData[compkey]?.gameIsSetBadge === 'true') {
            if (!compliData[compkey]?.gameBadge) {
              toast({
                title: 'Please Select Badge.',
                status: 'error',
                duration: 3000,
                isClosable: true,
              });
              setCompKeyCount(compkeyNumber);
              setCurrentTab(0);
              return false;
            }
            if (!compliData[compkey]?.gameBadgeName) {
              toast({
                title: 'Please Fill Badge Name.',
                status: 'error',
                duration: 3000,
                isClosable: true,
              });
              setCompKeyCount(compkeyNumber);
              setCurrentTab(0);
              return false;
            }
          }
          if (compliData[compkey]?.gameIsSetCriteriaForBadge === 'true') {
            if (!compliData[compkey]?.gameAwardBadgeScore) {
              toast({
                title: 'Please Set Criteria for Badge .',
                status: 'error',
                duration: 3000,
                isClosable: true,
              });
              setCompKeyCount(compkeyNumber);
              setCurrentTab(0);
              return false;
            }
          }
          if (!compliData[compkey]?.gameScreenTitle) {
            toast({
              title: 'Please Screen Titles.',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
            setCompKeyCount(compkeyNumber);
            setCurrentTab(0);
            return false;
          }
          if (compliData[compkey]?.gameIsSetCongratsSingleMessage === 'true') {
            if (!compliData[compkey]?.gameCompletedCongratsMessage) {
              toast({
                title: 'Please Set CongratsMessage.',
                status: 'error',
                duration: 3000,
                isClosable: true,
              });
              setCompKeyCount(compkeyNumber);
              setCurrentTab(0);
              return false;
            }
          }
          if (
            compliData[compkey]?.gameIsSetCongratsScoreWiseMessage === 'true'
          ) {
            if (compliData[compkey]?.gameIsSetMinPassScore === 'true') {
              if (!compliData[compkey]?.gameMinimumScoreCongratsMessage) {
                toast({
                  title: 'Please Enter Minimum Score Congrats Message.',
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
                });
                setCompKeyCount(compkeyNumber);
                setCurrentTab(0);
                return false;
              }
              if (!compliData[compkey]?.gameaboveMinimumScoreCongratsMessage) {
                toast({
                  title: 'Please Enter Above Minimum Score CongratsMessage.',
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
                });
                setCompKeyCount(compkeyNumber);
                setCurrentTab(0);
                return false;
              }
            }

            if (compliData[compkey]?.gameIsSetDistinctionScore === 'true') {
              if (
                !compliData[compkey]?.gameAboveDistinctionScoreCongratsMessage
              ) {
                toast({
                  title:
                    'Please Enter Above Distinction Score CongratsMessage.',
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
                });
                setCompKeyCount(compkeyNumber);
                setCurrentTab(0);
                return false;
              }
            }
          }

          setCompKeyCount(compkeyNumber);
          setCurrentTab(0);
          setCompliData((prevInput: any) => ({
            ...prevInput,
            [CompKeyCount]: {
              ...prevInput[CompKeyCount],
            },
          }));
        }
      }

      //       if (formData.gameIsShowReflectionScreen === 'true') {
      //   if (reflectionQuestions && typeof reflectionQuestions === 'object') {
      //     var keys1 = Object.keys(reflectionQuestions);

      // console.log(formData.gameReflectionQuestion,'formData.gameReflectionQuestion')
      //     const totalQuestions = Number(formData.gameReflectionQuestion) || 0;

      //     for (let i = 0; i < totalQuestions; i++) {
      //       const key = keys1[i] as keyof typeof reflectionQuestions;
      //       console.log(key,'keyingamecreation')
      //       const value = reflectionQuestions[key];
      //       console.log(value,'valueingamecreation')
      //       const question = `Question${i + 1}`;

      //       if (!value || value.trim() === '') {
      //         toast({
      //           title: `${question} is empty. Please fill in the ${question} question.`,
      //           status: 'error',
      //           duration: 3000,
      //           isClosable: true,
      //         });
      //         setCurrentTab(2);
      //         return false;
      //       }
      //     }
      //   }
      // }
      // ✅ small delay ensures latest React state (important fix)
      // await new Promise((resolve) => setTimeout(resolve, 0));

      // if (formData.gameIsShowReflectionScreen === 'true') {
      //   if (reflectionQuestions && typeof reflectionQuestions === 'object') {
      //     var keys1 = Object.keys(reflectionQuestions);

      //     // ✅ FIX 1: skip validation if reflectionQuestions not ready yet
      //     // if (!keys1 || keys1.length === 0) {
      //     //   console.log("⏳ ReflectionQuestions not ready yet — skipping first validation");
      //     //   return false; // stop validation until state updates
      //     // }

      //     console.log(formData.gameReflectionQuestion, 'formData.gameReflectionQuestion');
      //     const totalQuestions = Number(formData.gameReflectionQuestion) || 0;

      //     for (let i = 0; i < totalQuestions; i++) {
      //       console.log(totalQuestions,'totalQuestionsingamecreation')
      //       console.log('working')
      //       const key = keys1[i] as keyof typeof reflectionQuestions;
      //       console.log(reflectionQuestions,'reflectionQuestionsingamecreation')
      //       console.log(key,'keyingamecreation')
      //       const value = reflectionQuestions[key];
      //       console.log(reflectionQuestions[key],'reflectionQuestions[key]incgamecration')
      //       console.log(value,'valueingamecreation')
      //       const question = `Question${i + 1}`;

      //       // ✅ FIX 2: only toast when value is actually missing
      //       if (!value || value.trim() === '') {
      //         toast({
      //           title: `${question} is empty. Please fill in the ${question} question.`,
      //           status: 'error',
      //           duration: 3000,
      //           isClosable: true,
      //         });
      //         setCurrentTab(2);
      //         return false;
      //       }
      //     }
      //   }
      // }

      await new Promise((resolve) => setTimeout(resolve, 0));

      if (formData.gameIsShowReflectionScreen === 'true') {
        if (reflectionQuestions && typeof reflectionQuestions === 'object') {
          // ✅ if reflectionQuestions is empty, auto-fill defaults
          if (Object.keys(reflectionQuestions).length === 0) {
            setReflectionQuestions({
              ref1: 'What were your biggest learnings?',
              ref2: 'How can you apply these learnings back at work?',
              ref3: "What's one thing you learned about your mindset?",
              ref4: "What's one thing you are committing to change?",
            });
            console.log('🪶 reflectionQuestions was empty — defaults applied');
            return false; // stop here so next click uses updated state
          }

          // 🔽 your existing logic continues below unchanged
          var keys1 = Object.keys(reflectionQuestions);
          console.log(keys1, 'keys1ingamecreation');
          console.log(
            formData.gameReflectionQuestion,
            'formData.gameReflectionQuestion',
          );
          const totalQuestions = Number(formData.gameReflectionQuestion) || 0;

          for (let i = 0; i < totalQuestions; i++) {
            const key = keys1[i] as keyof typeof reflectionQuestions;
            console.log(
              reflectionQuestions,
              'reflectionQuestionsingamecreation',
            );
            const value = reflectionQuestions[key];
            console.log(value, 'valueingamecreation');
            const question = `Question${i + 1}`;

            if (!value || value.trim() === '') {
              toast({
                title: `${question} is empty. Please fill in the ${question} question.`,
                status: 'error',
                duration: 3000,
                isClosable: true,
              });
              setCurrentTab(2);
              return false;
            }
          }
        }
      }

      // Takeaway Screen Validation
      if (
        formData.gameIsShowTakeaway === 'true' &&
        (formData.gameTakeawayContent === null ||
          formData.gameTakeawayContent === undefined ||
          formData.gameTakeawayContent === '')
      ) {
        toast({
          title: 'Please Enter TakeAway Content',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        setCurrentTab(3);
        return false;
      }
      // Welcome  Screen Validation
      if (
        formData.gameIsShowAdditionalWelcomeNote === 'true' &&
        (formData.gameAdditionalWelcomeNote === null ||
          formData.gameAdditionalWelcomeNote === undefined ||
          formData.gameAdditionalWelcomeNote === '')
      ) {
        toast({
          title: 'Please Add Welcome Note',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        //newlyadded start
        setFormData({
          ...formData,
          gameIsShowAdditionalWelcomeNoteInvalid: 'true',
        });
        setCurrentTab(4);
        //newlyadded End
        return false;
      }
      // Thankyou Screen Validation
      if (
        formData.gameThankYouMessage === '' ||
        formData.gameThankYouMessage === null ||
        formData.gameThankYouMessage === undefined
      ) {
        toast({
          title: 'Please add a Thank You message',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        setFormData({
          ...formData,
          isfeedbackthankyou: true,
        });
        setCurrentTab(5);
        return false;
      } else {
        // Completion Screen Validation
        if (complidatalength !== 0) {
          for (let i = 0; i < complidatalength; i++) {
            const compkey = getcompliData[
              i
            ] as unknown as keyof typeof compliData;
            const compkeyNumber = Number(compkey);
            const getgameTotalScore = compliData[compkey].gameTotalScore;
            if (
              Array.isArray(getgameTotalScore) &&
              getgameTotalScore.length > 0
            ) {
              const maxScore = getgameTotalScore[0].maxScore;
              if (!maxScore) {
                toast({
                  title: 'Please Enter Total Score.',
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
                });
                setCompKeyCount(compkeyNumber);
                setCurrentTab(0);
                return false;
              }
            }
            if (compliData[compkey]?.gameIsSetMinPassScore === 'true') {
              if (!compliData[compkey]?.gameMinScore) {
                toast({
                  title: 'Please Enter Minimum Score.',
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
                });
                setCompliData((prevInput: any) => ({
                  ...prevInput,
                  [CompKeyCount]: {
                    ...prevInput[CompKeyCount],
                    redBorderForMinScore: true,
                  },
                }));
                setCompKeyCount(compkeyNumber);
                setCurrentTab(0);
                return false;
              }

              // Reset the red border style for the InputField
              setCompliData((prevInput: any) => ({
                ...prevInput,
                [CompKeyCount]: {
                  ...prevInput[CompKeyCount],
                  redBorderForMinScore: false,
                },
              }));
            }
            if (compliData[compkey]?.gameIsSetDistinctionScore === 'true') {
              if (!compliData[compkey]?.gameDistinctionScore) {
                toast({
                  title: 'Please Enter Distinction  Score.',
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
                });
                setCompKeyCount(compkeyNumber);
                setCurrentTab(0);
                return false;
              }
            }
            if (compliData[compkey]?.gameIsSetBadge === 'true') {
              if (!compliData[compkey]?.gameBadge) {
                toast({
                  title: 'Please Select Badge.',
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
                });
                setCompKeyCount(compkeyNumber);
                setCurrentTab(0);
                return false;
              }
              if (!compliData[compkey]?.gameBadgeName) {
                toast({
                  title: 'Please Fill Badge Name.',
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
                });
                setCompKeyCount(compkeyNumber);
                setCurrentTab(0);
                return false;
              }
            }
            if (compliData[compkey]?.gameIsSetCriteriaForBadge === 'true') {
              if (!compliData[compkey]?.gameAwardBadgeScore) {
                toast({
                  title: 'Please Set Criteria for Badge .',
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
                });
                setCompKeyCount(compkeyNumber);
                setCurrentTab(0);
                return false;
              }
            }
            if (!compliData[compkey]?.gameScreenTitle) {
              toast({
                title: 'Please Screen Title.',
                status: 'error',
                duration: 3000,
                isClosable: true,
              });
              setCompKeyCount(compkeyNumber);
              setCurrentTab(0);
              return false;
            }
            if (
              compliData[compkey]?.gameIsSetCongratsSingleMessage === 'true'
            ) {
              if (!compliData[compkey]?.gameCompletedCongratsMessage) {
                toast({
                  title: 'Please Set CongratsMessage.',
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
                });
                setCompKeyCount(compkeyNumber);
                setCurrentTab(0);
                return false;
              }
            }
            if (
              compliData[compkey]?.gameIsSetCongratsScoreWiseMessage === 'true'
            ) {
              if (compliData[compkey]?.gameIsSetMinPassScore === 'true') {
                if (!compliData[compkey]?.gameMinimumScoreCongratsMessage) {
                  toast({
                    title: 'Please Enter Minimum Score Congrats Message.',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  setCompKeyCount(compkeyNumber);
                  setCurrentTab(0);
                  return false;
                }
                if (
                  !compliData[compkey]?.gameaboveMinimumScoreCongratsMessage
                ) {
                  toast({
                    title: 'Please Enter Above Minimum Score CongratsMessage.',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  setCompKeyCount(compkeyNumber);
                  setCurrentTab(0);
                  return false;
                }
              }

              if (compliData[compkey]?.gameIsSetDistinctionScore === 'true') {
                if (
                  !compliData[compkey]?.gameAboveDistinctionScoreCongratsMessage
                ) {
                  toast({
                    title:
                      'Please Enter Above Distinction Score CongratsMessage.',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  setCompKeyCount(compkeyNumber);
                  setCurrentTab(0);
                  return false;
                }
              }
            }

            setCompKeyCount(compkeyNumber);
            setCurrentTab(0);
            setCompliData((prevInput: any) => ({
              ...prevInput,
              [CompKeyCount]: {
                ...prevInput[CompKeyCount],
              },
            }));
          }
        } else {
          // refelection Screen Validation
          if (formData.gameIsShowReflectionScreen === 'true') {
            if (
              typeof reflectionQuestions === 'object' &&
              reflectionQuestions !== null
            ) {
              var keys = Object.keys(reflectionQuestions);

              //newlyadded start
              if (!keys) {
                var keys1 = Object.keys(reflectionQuestions);
              } else {
                var keys1 = ['ref1', 'ref2', 'ref3', 'ref4'];
              }

              //newlyadded end

              for (var i = 0; i < formData.gameReflectionQuestion; i++) {
                var key = keys1[
                  i
                ] as unknown as keyof typeof reflectionQuestions; //changes keys1[i] instead of keys[i]
                var value = reflectionQuestions[key];
                if (key == 'ref1') {
                  var question = 'Question1';
                }
                if (key == 'ref2') {
                  var question = 'Question2';
                }
                if (key == 'ref3') {
                  var question = 'Question3';
                }
                if (key == 'ref4') {
                  var question = 'Question4';
                }

                if (!value) {
                  toast({
                    title: `${question} is empty. Please fill in the ${question} question.`,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  setCurrentTab(2);
                  return false;
                }
              }
            }
          }
          // Takeaway Screen Validation
          else if (
            formData.gameIsShowTakeaway === 'true' &&
            (formData.gameTakeawayContent === null ||
              formData.gameTakeawayContent === undefined ||
              formData.gameTakeawayContent === '')
          ) {
            setCurrentTab(3);
            toast({
              title: 'Please Enter TakeAway Content',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
            setCurrentTab(3);
            return false;
          }
          // Welcome  Screen Validation
          else if (
            formData.gameIsShowAdditionalWelcomeNote === 'true' &&
            (formData.gameAdditionalWelcomeNote === null ||
              formData.gameAdditionalWelcomeNote === undefined ||
              formData.gameAdditionalWelcomeNote === '')
          ) {
            setCurrentTab(3);
            toast({
              title: 'Please Add Welcome Note',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });

            setFormData({
              ...formData,
              gameIsShowAdditionalWelcomeNoteInvalid: 'true',
            });
            setCurrentTab(4);

            return false;
          }
        }
      }

      if (formData.gameIsFeedbackMandatory === 'true') {
        if (
          formData.gameQuestion1 === 'true' &&
          formData.gameQuestionValue1 === ''
        ) {
          toast({
            title: 'Please Enter Question 1',
            status: 'error',
            duration: 3000,
            isClosable: true,
          });
          return false;
        } else if (
          formData.gameQuestion2 === 'true' &&
          formData.gameQuestionValue2 === ''
        ) {
          toast({
            title: 'Please Enter Question 2',
            status: 'error',
            duration: 3000,
            isClosable: true,
          });
          return false;
        } else if (
          formData.gameQuestionValue3 === '' ||
          formData.gameQuestionValue4 === ''
        ) {
          toast({
            title: 'Please Enter Rating Questions',
            status: 'error',
            duration: 3000,
            isClosable: true,
          });
          return false;
        }
      }
      const countSelectedOptions = selectedOptions.filter(
        (option) =>
          option !== '' &&
          option !== 'false' &&
          option !== undefined &&
          option !== null,
      ).length;
      if (formData.gameIsCollectLearnerFeedback === 'true') {
        if (
          formData.gameFeedBack === 'true' &&
          formData.gameFeedBackLink === ''
        ) {
          toast({
            title: 'Please Enter Feedback Link',
            status: 'error',
            duration: 3000,
            isClosable: true,
          });
          return false;
        }
      }
      const combinedData = {...formData,backgroundquestImage}
      let data = JSON.stringify(combinedData);
      // alert("cn"+tab);
      const result = await updateGame(id, data);
      if (result?.status !== 'Success') {
        toast({
          title: 'Data Not Updated.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return console.warn('updateBackground error :' + result?.err);
      }
      if (tab === 5 && result.status === 'Success') {
        toast({
          title: 'All Screens are Updated',
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'bottom-right',
        });

        const { gameLastTab, ...formDataWithoutLastTab } = result?.data;
        setFormData(formDataWithoutLastTab);
        const MaxBlockQuestNumber = await getMaxBlockQuestNo(id); // Assuming this function returns a promise
        if (result.status === 'Success') {
          const maxQuestNo = MaxBlockQuestNumber.data?.maxBlockQuestNo;
          if (maxQuestNo < 5) {
            setOpenQuest(true);
          } else {
            setOpenQuest(false);
            setTab(6);
          }
        } else {
          console.error('Error:', result.message);
        }
      }
    }
  };
  const [scrollToElementEnabled, setScrollToElementEnabled] =
    useState<boolean>(false);

  const commonNextFunction = async () => {
    if (tab === 1 && !formData?.gameBackgroundId) {
      toast({
        title: 'Please Select a background image.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return false;
    }
    if (tab === 2) {
      // if (!formData?.gameNonPlayerName) {
      //   toast({
      //     title: 'Please Enter a NonplayerName.',
      //     status: 'error',
      //     duration: 3000,
      //     isClosable: true,
      //   });
      //   return false;
      // }
      if (!formData?.gameNonPlayingCharacterId) {
        toast({
          title: 'Please Select a Character image.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return false;
      }
      // if (!formData?.gameNonPlayerVoice) {
      //   toast({
      //     title: 'Please Select a NonPlayer Voice.',
      //     status: 'error',
      //     duration: 3000,
      //     isClosable: true,
      //   });
      //   return false;
      // }
      if (!formData?.gamePlayerMaleVoice) {
        toast({
          title: 'Please Select a Male Voice.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return false;
      }
      if (!formData?.gamePlayerFemaleVoice) {
        toast({
          title: 'Please Select a Female Voice.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return false;
      }
        if (!formData.gamementorMaleVoice) {
            toast({
              title: 'Please Select a Mentor Male Voice.',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
            return false;
          }
          if (!formData.gamementorFemaleVoice) {
            toast({
              title: 'Please Select a Mentor Female Voice.',
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
            return false;
          }
      if (!formData?.gameNarratorVoice) {
        toast({
          title: 'Please Select a Narrator Voice.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return false;
      }
    }
    if (tab === 3) {
      if (!formData?.gameTitle) {
        toast({
          title: 'Please Enter The Story Title',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        setFormData({
          ...formData,
          isStoryTitleInvalid: true,
        });
        return false;
      }
      if (!formData?.gameSkills || formData.gameSkills.length === 0) {
        toast({
          title: 'Please Enter The Skills',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        setFormData({
          ...formData,
          isSkillsInvalid: true,
        });
        return false;
      }
      if (!formData?.gameCategoryId || formData.gameCategoryId.length === 0) {
        toast({
          title: 'Please Enter The Category',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        setFormData({
          ...formData,
          isCategoryIdInvalid: true,
        });
        return false;
      }
      let cate = JSON.stringify(cat);
      let da = JSON.stringify(tags);
      const res = await createSkills(id, da);
      const cats = await createCategories(id, cate);
      if (res?.status !== 'Success' && res?.data.length === 0)
        return toast({
          title: 'Cannot Skills',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      if (cats?.status !== 'Success' && cats?.data.length === 0)
        return toast({
          title: 'Cannot Skills',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
    }
    if (tab === 4) {
      if (items.length !== 0) {
        if (items.some((item: any) => item.type === 'Interaction')) {
          if (typeof items === 'object' && items !== null) {
            var inputData = items;
            for (var i = 0; i < inputData.length; i++) {
              var key = inputData[i];
              var inputkey = key.type + key.input;
              var inputget = input;
              var inputdataget = Object.values(inputget);

              if (key.type === 'Note') {
                var note = input[inputkey].note;

                if (!note) {
                  setValidation({ ...validation, [`Note${key.input}`]: true });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Note is empty on Block ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }

                if (input[inputkey]?.NoteleadShow) {
                  if (
                    input[inputkey]?.NoteleadShow === 'New Block' ||
                    input[inputkey]?.NoteleadShow === 'Select Block'
                  ) {
                    if (!input[inputkey]?.Notenavigate) {
                      setValidation({
                        ...validation,
                        [`Navigation${key.input}`]: true,
                      });
                      setScrollToElementEnabled(true);
                      toast({
                        title: `Navigate has not been selected on ${key.id} `,
                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                      });
                      return false;
                    }
                  }
                } else {
                  setValidation({
                    ...validation,
                    [`Navigation${key.input}`]: true,
                  });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Navigate has not been selected on Block  ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }
              }

              if (key.type === 'Link') {
                const currentInput = input?.[inputkey];

                if (!currentInput || !currentInput.Link) {
                  setValidation({ ...validation, [`Link${key.input}`]: true });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Link is empty on Block ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }

                if (currentInput?.LinkleadShow) {
                  if (
                    currentInput.LinkleadShow === 'New Block' ||
                    currentInput.LinkleadShow === 'Select Block'
                  ) {
                    if (!currentInput?.Linknavigate) {
                      setValidation({
                        ...validation,
                        [`Navigation${key.input}`]: true,
                      });
                      setScrollToElementEnabled(true);
                      toast({
                        title: `Navigate has not been selected on ${key.id} `,
                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                      });
                      return false;
                    }
                  }
                } else {
                  setValidation({
                    ...validation,
                    [`Navigation${key.input}`]: true,
                  });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Navigate has not been selected on Block  ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }
              }
              if (key.type === 'KeyInsights') {
                const currentInput = input?.[inputkey];

                if (!currentInput || !currentInput.KeyInsights) {
                  setValidation({ ...validation, [`KeyInsights${key.input}`]: true });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `KeyInsights is empty on Block ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }

                if (currentInput?.KeyInsightsleadShow) {
                  if (
                    currentInput.KeyInsightsleadShow === 'New Block' ||
                    currentInput.KeyInsightsleadShow === 'Select Block'
                  ) {
                    if (!currentInput?.KeyInsightsnavigate) {
                      setValidation({
                        ...validation,
                        [`Navigation${key.input}`]: true,
                      });
                      setScrollToElementEnabled(true);
                      toast({
                        title: `Navigate has not been selected on ${key.id} `,
                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                      });
                      return false;
                    }
                  }
                } else {
                  setValidation({
                    ...validation,
                    [`Navigation${key.input}`]: true,
                  });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Navigate has not been selected on Block  ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }
              }
	      
	      if (key.type === 'WehaveChoose') {
                const currentInput = input?.[inputkey];

                if (!currentInput || !currentInput.WehaveChoose) {
                  setValidation({ ...validation, [`WehaveChoose${key.input}`]: true });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `WehaveChoose is empty on Block ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }

                if (currentInput?.WehaveChooseleadShow) {
                  if (
                    currentInput.WehaveChooseleadShow === 'New Block' ||
                    currentInput.WehaveChooseleadShow === 'Select Block'
                  ) {
                    if (!currentInput?.WehaveChoosenavigate) {
                      setValidation({
                        ...validation,
                        [`Navigation${key.input}`]: true,
                      });
                      setScrollToElementEnabled(true);
                      toast({
                        title: `Navigate has not been selected on ${key.id} `,
                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                      });
                      return false;
                    }
                  }
                } else {
                  setValidation({
                    ...validation,
                    [`Navigation${key.input}`]: true,
                  });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Navigate has not been selected on Block  ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }
              }
              if (key.type === 'SwipeMiniGame') {
                const currentInput = input?.[inputkey];

                if (!currentInput || !currentInput.SwipeMiniGame) {
                  setValidation({ ...validation, [`SwipeMiniGame${key.input}`]: true });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `SwipeMiniGame is empty on Block ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }

                if (currentInput?.SwipeMiniGameleadShow) {
                  if (
                    currentInput.SwipeMiniGameleadShow === 'New Block' ||
                    currentInput.SwipeMiniGameleadShow === 'Select Block'
                  ) {
                    if (!currentInput?.SwipeMiniGamenavigate) {
                      setValidation({
                        ...validation,
                        [`Navigation${key.input}`]: true,
                      });
                      setScrollToElementEnabled(true);
                      toast({
                        title: `Navigate has not been selected on ${key.id} `,
                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                      });
                      return false;
                    }
                  }
                } else {
                  setValidation({
                    ...validation,
                    [`Navigation${key.input}`]: true,
                  });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Navigate has not been selected on Block  ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }
              }
              if (key.type === 'DragForNow') {
                const currentInput = input?.[inputkey];

                if (!currentInput || !currentInput.DragForNow) {
                  setValidation({ ...validation, [`DragForNow${key.input}`]: true });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `DragForNow is empty on Block ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }

                if (currentInput?.DragForNowleadShow) {
                  if (
                    currentInput.DragForNowleadShow === 'New Block' ||
                    currentInput.DragForNowleadShow === 'Select Block'
                  ) {
                    if (!currentInput?.DragForNownavigate) {
                      setValidation({
                        ...validation,
                        [`Navigation${key.input}`]: true,
                      });
                      setScrollToElementEnabled(true);
                      toast({
                        title: `Navigate has not been selected on ${key.id} `,
                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                      });
                      return false;
                    }
                  }
                } else {
                  setValidation({
                    ...validation,
                    [`Navigation${key.input}`]: true,
                  });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Navigate has not been selected on Block  ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }
              }
              if (key.type === 'PreAssessment') {
                const currentInput = input?.[inputkey];

                if (!currentInput || !currentInput.PreAssessment) {
                  setValidation({ ...validation, [`PreAssessment${key.input}`]: true });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `PreAssessment is empty on Block ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }

                if (currentInput?.PreAssessmentleadShow) {
                  if (
                    currentInput.PreAssessmentleadShow === 'New Block' ||
                    currentInput.PreAssessmentleadShow === 'Select Block'
                  ) {
                    if (!currentInput?.PreAssessmentnavigate) {
                      setValidation({
                        ...validation,
                        [`Navigation${key.input}`]: true,
                      });
                      setScrollToElementEnabled(true);
                      toast({
                        title: `Navigate has not been selected on ${key.id} `,
                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                      });
                      return false;
                    }
                  }
                } else {
                  setValidation({
                    ...validation,
                    [`Navigation${key.input}`]: true,
                  });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Navigate has not been selected on Block  ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }
              }
              if (key.type === 'PostAssessment') {
                const currentInput = input?.[inputkey];

                if (!currentInput || !currentInput.PostAssessment) {
                  setValidation({ ...validation, [`PostAssessment${key.input}`]: true });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `PostAssessment is empty on Block ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }

                if (currentInput?.PostAssessmentleadShow) {
                  if (
                    currentInput.PostAssessmentleadShow === 'New Block' ||
                    currentInput.PostAssessmentleadShow === 'Select Block'
                  ) {
                    if (!currentInput?.PostAssessmentnavigate) {
                      setValidation({
                        ...validation,
                        [`Navigation${key.input}`]: true,
                      });
                      setScrollToElementEnabled(true);
                      toast({
                        title: `Navigate has not been selected on ${key.id} `,
                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                      });
                      return false;
                    }
                  }
                } else {
                  setValidation({
                    ...validation,
                    [`Navigation${key.input}`]: true,
                  });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Navigate has not been selected on Block  ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }
              }
              if (key.type === 'validatePrompt') {
                const currentInput = input?.[inputkey];

                if (!currentInput || !currentInput.validatePrompt) {
                  setValidation({ ...validation, [`validatePrompt${key.input}`]: true });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `validatePrompt is empty on Block ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }

                if (currentInput?.validatePromptleadShow) {
                  if (
                    currentInput.validatePromptleadShow === 'New Block' ||
                    currentInput.validatePromptleadShow === 'Select Block'
                  ) {
                    if (!currentInput?.validatePromptnavigate) {
                      setValidation({
                        ...validation,
                        [`Navigation${key.input}`]: true,
                      });
                      setScrollToElementEnabled(true);
                      toast({
                        title: `Navigate has not been selected on ${key.id} `,
                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                      });
                      return false;
                    }
                  }
                } else {
                  setValidation({
                    ...validation,
                    [`Navigation${key.input}`]: true,
                  });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Navigate has not been selected on Block  ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }
              }
              if (key.type === 'evaluationPrompt') {
                const currentInput = input?.[inputkey];

                if (!currentInput || !currentInput.evaluationPrompt) {
                  setValidation({ ...validation, [`evaluationPrompt${key.input}`]: true });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `evaluationPrompt is empty on Block ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }

                if (currentInput?.evaluationPromptleadShow) {
                  if (
                    currentInput.evaluationPromptleadShow === 'New Block' ||
                    currentInput.evaluationPromptleadShow === 'Select Block'
                  ) {
                    if (!currentInput?.evaluationPromptnavigate) {
                      setValidation({
                        ...validation,
                        [`Navigation${key.input}`]: true,
                      });
                      setScrollToElementEnabled(true);
                      toast({
                        title: `Navigate has not been selected on ${key.id} `,
                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                      });
                      return false;
                    }
                  }
                } else {
                  setValidation({
                    ...validation,
                    [`Navigation${key.input}`]: true,
                  });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Navigate has not been selected on Block  ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }
              }
              if (key.type === 'Overview') {
                const currentInput = input?.[inputkey];

                if (!currentInput || !currentInput.Overview) {
                  setValidation({ ...validation, [`Overview${key.input}`]: true });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Overview is empty on Block ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }

                if (currentInput?.OverviewleadShow) {
                  if (
                    currentInput.OverviewleadShow === 'New Block' ||
                    currentInput.OverviewleadShow === 'Select Block'
                  ) {
                    if (!currentInput?.Overviewnavigate) {
                      setValidation({
                        ...validation,
                        [`Navigation${key.input}`]: true,
                      });
                      setScrollToElementEnabled(true);
                      toast({
                        title: `Navigate has not been selected on ${key.id} `,
                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                      });
                      return false;
                    }
                  }
                } else {
                  setValidation({
                    ...validation,
                    [`Navigation${key.input}`]: true,
                  });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Navigate has not been selected on Block  ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }
              }
              if (key.type === 'ScenarioCompletion') {
                const currentInput = input?.[inputkey];

               

                if (currentInput?.ScenarioCompletionleadShow) {
                  if (
                    currentInput.ScenarioCompletionleadShow === 'New Block' ||
                    currentInput.ScenarioCompletionleadShow === 'Select Block'
                  ) {
                    if (!currentInput?.ScenarioCompletionnavigate) {
                      setValidation({
                        ...validation,
                        [`Navigation${key.input}`]: true,
                      });
                      setScrollToElementEnabled(true);
                      toast({
                        title: `Navigate has not been selected on ${key.id} `,
                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                      });
                      return false;
                    }
                  }
                } else {
                  setValidation({
                    ...validation,
                    [`Navigation${key.input}`]: true,
                  });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Navigate has not been selected on Block  ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }
              }
              if (key.type === 'Reflection') {
                const currentInput = input?.[inputkey];

                if (!currentInput || !currentInput.Reflection) {
                  setValidation({ ...validation, [`Reflection${key.input}`]: true });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Reflection is empty on Block ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }

                if (currentInput?.ReflectionleadShow) {
                  if (
                    currentInput.ReflectionleadShow === 'New Block' ||
                    currentInput.ReflectionleadShow === 'Select Block'
                  ) {
                    if (!currentInput?.Reflectionnavigate) {
                      setValidation({
                        ...validation,
                        [`Navigation${key.input}`]: true,
                      });
                      setScrollToElementEnabled(true);
                      toast({
                        title: `Navigate has not been selected on ${key.id} `,
                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                      });
                      return false;
                    }
                  }
                } else {
                  setValidation({
                    ...validation,
                    [`Navigation${key.input}`]: true,
                  });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Navigate has not been selected on Block  ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }
              }

              if (key.type === 'Dialog') {
                var Dialog = input[inputkey]?.dialog;
                var animation = input[inputkey]?.animation;
                var voice = input[inputkey]?.voice;
                var blockRoll = input[inputkey]?.blockRoll;
                var character = input[inputkey]?.character; //added by nivetha

                if (!Dialog) {
                  setValidation({
                    ...validation,
                    [`Dialog${key.input}`]: true,
                  });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Dialogue is empty on Block ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }

                if (
                  character !== '99999' &&
                  character !== 99999 &&
                  !animation
                ) {
                  setValidation({
                    ...validation,
                    [`dailogAnimation${key.input}`]: true,
                  });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Animate is empty on Block ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }

                if (input[inputkey]?.DialogleadShow) {
                  if (
                    input[inputkey]?.DialogleadShow === 'New Block' ||
                    input[inputkey]?.DialogleadShow === 'Select Block'
                  ) {
                    if (!input[inputkey]?.Dialognavigate) {
                      setValidation({
                        ...validation,
                        [`Navigation${key.input}`]: true,
                      });
                      setScrollToElementEnabled(true);
                      toast({
                        title: `Navigate has not been selected on${key.id} `,
                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                      });
                      return false;
                    }
                  }
                } else {
                  setValidation({
                    ...validation,
                    [`Navigation${key.input}`]: true,
                  });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Navigate has not been selected on Block ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }
              }
              if (key.type === 'Interaction') {
                var QuestionsEmotion = input[inputkey]?.QuestionsEmotion;
                var blockRoll = input[inputkey]?.blockRoll;
                var interaction = input[inputkey]?.interaction;
                if (!interaction) {
                  // setValidation({
                  //   ...validation,
                  //   [`Interaction${key.input}`]: true,
                  // });
                  setValidation((prev: any) => ({
                    ...prev,
                    [`Interaction${key.input}`]: true,
                  }));
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Question is empty on Block ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }

                if (
                  blockRoll !== '99999' &&
                  blockRoll !== 99999 &&
                  !QuestionsEmotion
                ) {
                  setValidation({
                    ...validation,
                    [`QuestionsEmotion${key.input}`]: true,
                  });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Animate is empty on Block ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }
                if (!blockRoll) {
                  setValidation({
                    ...validation,
                    [`Interaction${key.input}`]: true,
                  });
                  setScrollToElementEnabled(true);
                  toast({
                    title: `Character has not been selected on Block ${key.id} `,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  });
                  return false;
                }
                if (typeof alphabet === 'object' && alphabet !== null) {
                  var alphabetData = alphabet;

                  for (const alp of alphabetData?.filter(
                    (alp: any) => key.id === alp.seqs,
                  ) || []) {
                    if (!input[inputkey]?.optionsObject[alp.option]) {
                      var option = alp.option;
                      // setValidation({
                      //   ...validation,
                      //   [`options${key.input}${option}`]: true,
                      // });
                      setValidation((prev: any) => ({
                        ...prev,
                        [`options${key.input}${option}`]: true,
                      }));
                      setScrollToElementEnabled(true);

                      toast({
                        title: `Option ${option} is empty on Blocks ${key.id} `,

                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                      });
                      setScrollToElementEnabled(true);
                      return false;
                    }
                    if (!input[inputkey]?.optionsemotionObject[alp.option]) {
                      var option = alp.option;
                      setValidation({
                        ...validation,
                        [`optionsEmotion${key.input}${option}`]: true,
                      });

                      setScrollToElementEnabled(true);
                      toast({
                        title: `Animate is empty on Block ${key.id} Option  ${option}`,
                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                      });
                      return false;
                    }
                    let isAtLeastOneTrue = false;

                    for (const option of alphabet.map(
                      (alp: any) => alp.option,
                    )) {
                      if (
                        input[inputkey]?.ansObject[option] === 'true' ||
                        input[inputkey]?.ansObject[option] === true
                      ) {
                        const ansValue = input[inputkey]?.ansObject[option];
                        isAtLeastOneTrue = true;
                        if (!input[inputkey]?.scoreObject[option]) {
                          setValidation({
                            ...validation,
                            [`score${key.input}`]: true,
                          });
                          setScrollToElementEnabled(true);
                          toast({
                            title: `At least one option must have a score on Block ${key.id}`,
                            status: 'error',
                            duration: 3000,
                            isClosable: true,
                          });
                          return false;
                        }
                      }
                    }
                    if (!isAtLeastOneTrue) {
                      setValidation({
                        ...validation,
                        [`checkbox${key.input}`]: true,
                      });
                      setScrollToElementEnabled(true);

                      toast({
                        title: `At least one option must be selected as right on Block ${key.id}`, //Pavi
                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                      });
                      return false;
                    }

                    if (
                      input[inputkey]?.navigateshowObjects &&
                      input[inputkey]?.navigateshowObjects[alp?.option] !== ''
                    ) {
                      if (
                        input[inputkey]?.navigateshowObjects[alp?.option] ===
                          'New Block' ||
                        input[inputkey]?.navigateshowObjects[alp?.option] ===
                          'Select Block' ||
                        input[inputkey]?.navigateshowObjects[alp?.option] ===
                          undefined
                      ) {
                        if (!input[inputkey]?.navigateObjects[alp.option]) {
                          setValidation({
                            ...validation,
                            [`NavigationOption${key.input}`]: true,
                          });
                          setScrollToElementEnabled(true);
                          toast({
                            title: `Navigate has not been selected on Block ${key.id}`,
                            status: 'error',
                            duration: 3000,
                            isClosable: true,
                          });

                          return false;
                        }
                      }
                    } else {
                      setValidation({
                        ...validation,
                        [`NavigationOption${key.input}`]: true,
                      });
                      setScrollToElementEnabled(true);
                      toast({
                        title: `Navigate has not been selected on Block ${key.id} `,
                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                      });
                      return false;
                    }
                  }
                }
              }
              var hasComplete = inputdataget.some((item: any) => {
                return (
                  item &&
                  (item.Notenavigate === 'Complete' ||
                    item.Dialognavigate === 'Complete' ||
                    item.Linknavigate === 'Complete' ||
                    item.KeyInsightsnavigate === 'Complete' ||
                    item.SwipeMiniGamenavigate === 'Complete' ||
                    item.DragForNownavigate === 'Complete' ||
		                item.WehaveChoosenavigate  === 'Complete' ||
                    item.PreAssessmentnavigate === 'Complete' ||
                    item.PostAssessmentnavigate === 'Complete' ||
                    item.validatePromptnavigate === 'Complete' ||
                    item.evaluationPromptnavigate === 'Complete' ||
                    item.Overviewnavigate === 'Complete' ||
                    item.ScenarioCompletionnavigate === 'Complete' ||
                    item.Reflectionnavigate === 'Complete' ||
                    (item.navigateObjects &&
                      Object.values(item.navigateObjects).includes('Complete')))
                );
              });
              if (!hasComplete) {
                toast({
                  // pavi
                  title: `At least one block must navigate to Game Complete`,
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
                });
                return false;
              }
            }

            const apiValidationResult = await getStoryValidtion(id);
            if (apiValidationResult?.status === 'Failure') {
              // There are empty fields, show an error message
              toast({
                title: ` ${apiValidationResult?.message}`,
                status: 'error',
                duration: 3000,
                isClosable: true,
              });
              return false;
            } else {
              setLoading(true);
              if (apiValidationResult?.status === 'Success') {
                setTimeout(() => {
                  setLoading(false); // Set loading to false after showing the toast
                }, 1000); // Set the timeout duration as needed
              }
            }
          }
        } else {
          toast({
            title: 'No Interaction in items.',
            status: 'error',
            duration: 3000,
            isClosable: true,
          });
          return false;
        }
      } else {
        toast({
          title: `Create Your Story !!`,
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return false;
      }
    }
    if (tab === 6) {
      if (formData.gameVoiceClickCount < 2 && !voicealert) {
        setLaunchPopup(true);
        setCurrentTab(6);

        return false;
      } else {
        setLaunchPopup(false);
        if (
          formData.gameIntroMusic === '' ||
          formData.gameIntroMusic === null ||
          formData.gameIntroMusic === undefined
        ) {
          toast({
            title: 'Please Select Intro music Audio',
            status: 'error',
            duration: 3000,
            isClosable: true,
          });
          setCurrentTab(6);
          return false;
        } else {
          setFormData({ ...formData, gameGameStage: 'Review' });
          localStorage.setItem('gameGameStage', 'Review');
        }
      }
    }

    const combined = {...formData,backgroundquestImage}
    let data = JSON.stringify(combined);
    if (tab === 1 && !id) {
      try {
        const result = await addgame(formData);

        if (result?.status !== 'Success') {
          toast({
            title: 'Data Not Created.',
            status: 'error',
            duration: 3000,
            isClosable: true,
          });
          return console.warn('updateBackground error :' + result?.err);
        } else {
          if (tab === 1 && result.status === 'Success') {
            toast({
              title: 'Background Image Stored',
              status: 'success',
              duration: 3000,
              isClosable: true,
              position: 'bottom-right',
            });
            setTab(tab + 1);
            const parsedGameLastTabArray = JSON.parse(
              result.data.gameLastTabArray,
            );

            // Update formData with the parsed array
            setFormData({
              ...formData,
              gameLastTabArray: parsedGameLastTabArray,
            });
            navigate(`/admin/superadmin/game/creation/${result.data.gameId}`);
          }
        }
      } catch (error) {
        console.error('An error occurred while sending the request:', error);
      }
    } else {
      try {
        let result;
        formData.gameLanguageId === 1
          ? (result = await updateGame(id, data))
          : (result = await gameOverviewGameContentLang(id, data));
        if (result?.status !== 'Success') {
          toast({
            title: 'Data Not Updated.',
            status: 'error',
            duration: 3000,
            isClosable: true,
          });
          return console.warn('updateBackground error :' + result?.err);
        }

        if (tab === 1 && result.status === 'Success') {
          toast({
            title: 'Background Image Updated',
            status: 'success',
            duration: 3000,
            isClosable: true,
            position: 'bottom-right',
          });
          const { gameLastTab, ...formDataWithoutLastTab } = result?.data;
          setFormData(formDataWithoutLastTab);
          setTab(tab + 1);
        }

        if (tab === 2 && result.status === 'Success') {
          toast({
            title: 'Non-Playing Character Updated',
            status: 'success',
            duration: 3000,
            isClosable: true,
            position: 'bottom-right',
          });
          const { gameLastTab, ...formDataWithoutLastTab } = result?.data;

          setFormData(formDataWithoutLastTab);
          setTab(tab + 1);
        }

        if (tab === 3 && result.status === 'Success') {
          toast({
            title: 'Game Overview Updated',
            status: 'success',
            duration: 3000,
            isClosable: true,
            position: 'bottom-right',
          });
          const { gameLastTab, ...formDataWithoutLastTab } = result?.data;

          setFormData(formDataWithoutLastTab);
          setTab(tab + 1);
        }

        if (tab === 4 && result.status === 'Success') {
          toast({
            title: 'Story  Updated',
            status: 'success',
            duration: 3000,
            isClosable: true,
            position: 'bottom-right',
          });

          const { gameLastTab, ...formDataWithoutLastTab } = result?.data;
          setFormData(formDataWithoutLastTab);
          setTab(tab + 1);
        }

        if (tab === 6 && result?.status === 'Success') {
          const { gameLastTab, gameGameStage, ...formDataWithoutLastTab } =
            result?.data;

          setFormData({ ...formDataWithoutLastTab, gameGameStage: 'Review' });
          // setTab(tab + 1);
          setLoading(true);
          setTimeout(() => {
            navigate(`/admin/superadmin/game/home`);
            setLoading(false);
          }, 2000);
        }
      } catch (error) {
        console.error('An error occurred while sending the request:', error);
      }
    }
  };
  function truncateText(text: any, maxLength: any, maxLineLength: 10) {
    if (text.length <= maxLength) {
      return text;
    } else {
      let truncatedText = text.slice(0, maxLength);

      // Break lines after maxLineLength characters
      truncatedText = truncatedText.replace(
        new RegExp(`(.{${maxLineLength}})`, 'g'),
        '$1\n',
      );

      return truncatedText;
    }
  }
console.log(img,'imgingamecreation')
  const checkStroyLineTitle = (Title: any, Story: any) => {
    const oldimg = img.filter(
      (item: { temp: { tempTitle: string } }) => item.temp.tempTitle !== '',
    ) as { temp: { tempTitle: string; tempStoryLine: string } }[];
console.log(oldimg,'olgimg')
    const isMatchingTitle = oldimg.some((item) => {
      return item.temp.tempTitle === formData.gameTitle;
    });

    const isMatchingStory = oldimg.some((item) => {
      return item.temp.tempStoryLine === formData.gameStoryLine;
    });

    if (isMatchingTitle) {
      setFormData((prev) => ({
        ...prev,
        gameTitle: Title,
      }));
    } else {
      if (formData.gameTitle) {
        setFormData((prev) => ({
          ...prev,
          gameTitle: formData.gameTitle,
        }));
      } else if (!formData.gameTitle) {
        setFormData((prev) => ({
          ...prev,
          gameTitle: Title,
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          gameTitle: formData.gameTitle,
        }));
      }
    }

    if (isMatchingStory) {
      setFormData((prev) => ({
        ...prev,
        gameStoryLine: Story,
      }));
    } else {
      if (formData.gameStoryLine) {
        setFormData((prev) => ({
          ...prev,
          gameStoryLine: formData.gameStoryLine,
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          gameStoryLine: Story,
        }));
      }
    }
  };

  const handleBackground = async (img: any, i: any) => {
    setDefaultstatus(false);

    // setIsSelected(!isSelected);
    setBackgroundIndex((prevIndex: any) => (prevIndex === i ? null : i));
    // setFetchImg(img?.aniId);
    setFetchImg((prev: any) => {
      return {
        ...prev,
        gasId: img?.gasId,
        gasAssetImage: img?.gasAssetImage,
        gasAssetName: img?.gasAssetName,
        i,
        title: img?.temp?.tempTitle,
        stroyline: img?.temp?.tempStoryLine,
      };
    });
    updateQuestBackground(1,img.gasId);
    if (selectedCardIndex !== i) {
      await checkStroyLineTitle(img?.temp?.tempTitle, img?.temp?.tempStoryLine);

      setSelectedCardIndex(i);
      setFormData((prev) => ({
        ...prev,
        gameBackgroundId: img.gasId,
      }));

      localStorage.setItem('selectedCardIndex', i);
    }
    setBackgroundIndex((prevIndex: any) => (prevIndex === i ? null : i));
    const updatedSelections = [...selections];
    updatedSelections[i] = !updatedSelections[i];
    setSelections(updatedSelections);
    onClose();

    if (selectedCardIndex === i) {
      return;
    } else {
    }
  };

  useEffect(() => {
    setSelectedCardIndex(parseInt(formData.gameBackgroundId) - 1);

    if (!Defaultstatus) {
      if (formData.gameBackgroundId) {
        setPreview(false);
        commonNextFunction();
      }
    }
  }, [formData.gameBackgroundId]);

  const handlePlayer = (player: any, i: any) => {
    setNonPlayer((prevIndex: any) => (prevIndex === i ? null : i));

    setSelectedPlayer((prev: any) => {
      return {
        ...prev,
        id: player?.gasId,
        img: player?.gasAssetImage,
        name: player?.gasAssetName,
      };
    });
  };

  const handleEnables = (e: any) => {
    const { name, checked } = e.target;

    const feedbackselectedOptions = [
      formData.gameContent,
      formData.gameRecommendation,
      formData.gameRelevance,
      formData.gameGamification,
      formData.gameBehaviour,
      formData.gameOthers,
    ];
    const countfbSelectedOptions = feedbackselectedOptions.filter(
      (option) =>
        option !== '' &&
        option !== 'false' &&
        option !== undefined &&
        option !== null,
    ).length;

    if (checked && countfbSelectedOptions >= 4) {
      return false;
    }
    if (
      name === 'gameContent' ||
      name === 'gameRelevance' ||
      name === 'gameBehaviour' ||
      name === 'gameOthers' ||
      name === 'gameGamification' ||
      name === 'gameRecommendation'
    ) {
      setFormData((prev) => ({ ...prev, [name]: String(checked) }));
      /*** To handle & trigger the modification in data in Preview ***/
      dispatch(
        onFieldContentModified({
          gameId: id,
          modifiedField: name,
          updatedValue: String(checked),
        }),
      );
    }
  };

  useEffect(() => {
    const handleVoiceOver = async () => {
      if (formData.gameenableVoiceOver === '') {
        setLaunchPopup(true);
      } else {
        if (formData.gameenableVoiceOver === 'true') {
          if (EnableVoiceCallApi === true) {
            // if (formData.gameVoiceClickCount < 3) {
            setLaunchPopup(false);
            setLoading(true);
            const voiceresult = await GameVoicegenaration(id);

            if (voiceresult.status === 'Success') {
              setLoading(false);
              if (EnableVoiceCallApi === true) {
                setFormData((prevState) => ({
                  ...prevState,
                  gameVoiceClickCount: (prevState.gameVoiceClickCount || 0) + 1,
                  gameenableVoiceOver: 'true',
                }));
              }

              setEnableVoiceCallApi(false);
              toast({
                title: 'Summary Updated',
                status: 'success',
                duration: 3000,
                isClosable: true,
                position: 'bottom-right',
              });
            }
            // }
          } else {
            setLoading(false);
            setEnableVoiceCallApi(false);
          }
        } else {
          setModalPopup(false);
          setEnableVoiceCallApi(false);
        }
      }
    };
    if (EnableVoiceCallApi === true) {
      handleVoiceOver();
    }
  }, [
    EnableVoiceCallApi,
    formData.gameenableVoiceOver,
    formData.gameVoiceClickCount,
  ]);

  const handleChange = (e: any) => {
    const inputValue = e.target.value;
    const inputFieldName = e.target.name;

    setContent((prev: any) => ({
      ...prev,
      newInputValue: inputValue,
      fieldName: inputFieldName,
    }));

    const { name, value, checked } = e.target;

    const toggleFieldArray = [
      'gameIsSetMinPassScore',
      'gameIsSetDistinctionScore',
      'gameIsSetSkillWiseScore',
      'gameIsSetBadge',
      'gameIsSetCriteriaForBadge',
      'gameIsSetCongratsSingleMessage',
      'gameIsSetCongratsScoreWiseMessage',
      'gameIsShowLeaderboard',
      'gameIsShowReflectionScreen',
      'gameIsLearnerMandatoryQuestion',
      'gameIsShowTakeaway',
      'gameIsShowSkill',
      'gameIsShowStoryline',
      'gameIsShowLearningOutcome',
      'gameIsShowGameDuration',
      'gameIsShowAuhorName',
      'gameIsShowAdditionalWelcomeNote',
      'gameIsCollectLearnerFeedback',
      'gameIsFeedbackMandatory',
      'gameShuffle',
      'gameDisableOptionalReplays',
      'gameTrackQuestionWiseAnswers',
      'gameDisableLearnerMailNotifications',
      'gameQuestion1',
      'gameQuestion2',
      'gameContent',
      'gameRelevance',
      'gameBehaviour',
      'gameOthers',
      'gameGamification',
      'gameRecommendation',
      'gameFeedBack',
      'gameenableVoiceOver',
    ];

    /*** To handle & trigger the modification in data in Preview ***/
    const extendedtoggleFieldArray = [
      ...toggleFieldArray,
      'gameReplayAllowed',
      'gameLeaderboardAllowed',
      'gameReflectionpageAllowed',
      'gameFeedbackQuestion',
      'gameShuffle',
    ];

    if (extendedtoggleFieldArray.includes(name)) {
      if (tab === 6) {
        dispatch(
          onFieldContentModified({
            gameId: id,
            modifiedField: inputFieldName,
            updatedValue: checked ? 'true' : 'false',
            currentSubTab: 0,
          }),
        );
      } else {
        dispatch(
          onFieldContentModified({
            gameId: id,
            modifiedField: inputFieldName,
            updatedValue: checked ? 'true' : 'false',
          }),
        );
      }
    } else {
      dispatch(
        onFieldContentModified({
          gameId: id,
          modifiedField: inputFieldName,
          updatedValue: value ? value : '',
        }),
      );
    }
    /***  End  ***/

    if (name === 'gameDuration') {
      //No code here
    } else if (toggleFieldArray.includes(name)) {
      setFormData((prev) => ({ ...prev, [name]: String(checked) }));
    } else if (e.target.id === 'gameLaunchedWithinPlatform') {
      e.target.checked
        ? setFormData((prev) => ({ ...prev, [name]: value }))
        : setFormData((prev) => ({ ...prev, [name]: 0 }));
    } else if (name === 'gameDownloadedAsScorm') {
      setFormData((prev) => ({ ...prev, [name]: checked ? 1 : 0 }));
    } else if (name === 'gameDefaultFeedbackForm') {
      setFormData((prev) => ({
        ...prev,
        [name]: checked ? feedBackForm.Yes : feedBackForm.No,
      }));
    } else if (name === 'gameReplayAllowed') {
      setFormData((prev) => ({ ...prev, [name]: checked ? 'true' : 'false' }));
    } else if (name === 'gameLeaderboardAllowed') {
      setFormData((prev) => ({ ...prev, [name]: checked ? 'true' : 'false' }));
    } else if (name === 'gameReflectionpageAllowed') {
      setFormData((prev) => ({ ...prev, [name]: checked ? 'true' : 'false' }));
    } else if (name === 'gameFeedbackQuestion') {
      setFormData((prev) => ({ ...prev, [name]: checked ? 'true' : 'false' }));
    } else if (name === 'gameShuffle') {
      setFormData((prev) => ({ ...prev, [name]: checked ? 'true' : 'false' }));
    } else if (name === 'gameenableVoiceOver') {
      setFormData((prev) => ({ ...prev, [name]: checked ? 'true' : 'false' }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }

    ///Completion Screen
    if (name === 'gameIsSetCongratsSingleMessage' && !checked) {
      // Reset the value when switch is turned off
      setFormData((prevData) => ({
        ...prevData,
        gameCompletedCongratsMessage: '', // Set to an empty string or any default value
      }));
    } else if (name === 'gameIsSetCongratsScoreWiseMessage' && !checked) {
      // Reset the value when switch is turned off
    } else if (name === 'gameenableVoiceOver') {
      if (checked) {
        setFormData((prev) => ({ ...prev, gameenableVoiceOver: 'true' }));

        setModalPopup(true);
      } else {
        setFormData((prev) => ({ ...prev, gameenableVoiceOver: 'false' }));
        setModalPopup(false); // Ensure the modal is closed when unchecked
      }
    }
  };

  const handleVoiceBack = () => {
    setFormData((prev) => ({ ...prev, gameenableVoiceOver: 'false' }));

    setModalPopup(false);
  };

  const handleLaunchConfirm = () => {
    setvoicealert(true);
    setLaunchPopup(false);
  };

  useEffect(() => {
    if (voicealert === true) {
      commonNextFunction();
    }
  }, [voicealert]);

  const handlecompletion = (e: any) => {
    const inputValue = e.target.value;
    const { name, value, checked } = e.target;

    if (
      (name === 'gameIsSetMinPassScore' && checked === true) ||
      (name === 'gameIsSetDistinctionScore' && checked === true)
    ) {
      setCompliData((prevInput: any) => {
        return {
          ...prevInput,
          [CompKeyCount]: {
            ...prevInput[CompKeyCount],
            gameIsSetCongratsSingleMessage: 'true',
            gameIsSetCongratsScoreWiseMessage: 'false',
          },
        };
      });
    }
    if (
      name === 'gameIsSetMinPassScore' ||
      name === 'gameIsSetDistinctionScore' ||
      name === 'gameIsSetSkillWiseScore' ||
      name === 'gameIsSetBadge' ||
      name === 'gameIsSetCriteriaForBadge' ||
      name === 'gameIsSetCongratsScoreWiseMessage' ||
      name === 'gameIsSetCongratsSingleMessage'
    ) {
      setCompliData((prevInput: any) => {
        return {
          ...prevInput,
          [CompKeyCount]: {
            ...prevInput[CompKeyCount],
            [name]: String(checked),
          },
        };
      });
    } else {
      setCompliData((prevInput: any) => {
        return {
          ...prevInput,
          [CompKeyCount]: {
            ...prevInput[CompKeyCount],
            [name]: value,
          },
        };
      });
    }
    // If gameIsSetMinPassScore is unchecked (checked === false), set gameIsSetCongratsScoreWiseMessage to false
    if (name === 'gameIsSetMinPassScore' && checked === false) {
      setCompliData((prevInput: any) => {
        return {
          ...prevInput,
          [CompKeyCount]: {
            ...prevInput[CompKeyCount],
            gameIsSetCongratsScoreWiseMessage: 'false',
          },
        };
      });
    }
    if (name === 'gameIsSetCongratsSingleMessage' && checked === true) {
      setCompliData((prevInput: any) => {
        return {
          ...prevInput,
          [CompKeyCount]: {
            ...prevInput[CompKeyCount],
            gameIsSetCongratsScoreWiseMessage: 'false',
          },
        };
      });
    }

    if (name === 'gameIsSetCongratsScoreWiseMessage' && checked === true) {
      setCompliData((prevInput: any) => {
        return {
          ...prevInput,
          [CompKeyCount]: {
            ...prevInput[CompKeyCount],
            gameIsSetCongratsSingleMessage: 'false',
          },
        };
      });
    }
  };

  const handleSummaryState = (isOpen: any) => {
    setIsOpenSummary(isOpen);
    setFormData((prev) => ({
      ...prev,
      gameSummaryScreen: !isOpen ? SummaryState.No : SummaryState.Yes,
    }));
  };

  const handleLanguageChange = (selectedOption: OptionType | null) => {
    setFormData({
      ...formData,
      gameLanguageId: parseInt(selectedOption.value),
    });
  };
  const handleIntroMusic = (selectedOption: OptionType | null) => {
    setFormData({ ...formData, gameIntroMusic: selectedOption.value });
  };

  const myBlink = keyframes`
  0% {
    filter: drop-shadow(2px 4px 6px #0000);
  }
  50% {
    filter: drop-shadow(2px 4px 6px #411ab3);
  }
  100% {
    filter: drop-shadow(2px 4px 6px #0000);
  }
  `;

  const blink = `${myBlink} 0.5s linear infinite`;
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const brandColor = useColorModeValue('#36c136', 'white');
  const completeBg = useColorModeValue(
    'white',
    'linear-gradient(180deg, #1F2A4F 0%, #18224D 50.63%, #111C44 100%)',
  );
  const incompleteColor = useColorModeValue(
    'secondaryGray.600',
    'whiteAlpha.200',
  );
  const completeShadow = 'rgba(112, 144, 176, 0.1) 0px 18px 22px inset';
  const incompleteShadow = 'rgba(112, 144, 176, 0.12) 0px 18px 40px';
  const lineColor = useColorModeValue('%23a3aed0', '%23FFFFFF1A');
  // SET BORDER IN IMAGE
  const stepImgActiveBorder = 'done';
  const stepImgBorder = '';

  const tab1 =
    formData && formData?.gameLastTabArray?.includes(1)
      ? stepImgActiveBorder
      : stepImgBorder;
  const tab2 =
    formData && formData?.gameLastTabArray?.includes(2)
      ? stepImgActiveBorder
      : stepImgBorder;
  const tab3 =
    formData && formData?.gameLastTabArray?.includes(3)
      ? stepImgActiveBorder
      : stepImgBorder;
  const tab4 =
    formData && formData?.gameLastTabArray?.includes(4)
      ? stepImgActiveBorder
      : stepImgBorder;
  const tab5 =
    formData && formData?.gameLastTabArray?.includes(5)
      ? stepImgActiveBorder
      : stepImgBorder;
  const tab6 =
    formData && formData?.gameLastTabArray?.includes(6)
      ? stepImgActiveBorder
      : stepImgBorder;
  const tab7 =
    formData && formData?.gameLastTabArray?.includes(7)
      ? stepImgActiveBorder
      : stepImgBorder;

  // set height and width for stepper image based on tab
  const stepImgActiveHeight = '110px';
  const stepImgHeight = '78px';
  const stepBgImg = tab == 1 ? stepImgActiveHeight : stepImgHeight;
  const stepNonPlaying = tab == 2 ? stepImgActiveHeight : stepImgHeight;
  const stepAbtStory = tab == 3 ? stepImgActiveHeight : stepImgHeight;
  const stepBlocks = tab == 4 ? stepImgActiveHeight : stepImgHeight;
  const stepScore = tab == 5 ? stepImgActiveHeight : stepImgHeight;
  const stepSummaries = tab == 6 ? stepImgActiveHeight : stepImgHeight;
  const stepEnd = tab == 7 ? stepImgActiveHeight : stepImgHeight;

  // SET ACTIVE STATUS BASED ON TAB
  const stepIconActiveColor = completeShadow;
  const stepIconColor = incompleteShadow;
  const stepPoseIcon = tab === 1 ? stepIconActiveColor : stepIconColor;
  const stepAboutStoryIcon = tab === 2 ? stepIconActiveColor : stepIconColor;
  const stepBlockIcon = tab === 3 ? stepIconActiveColor : stepIconColor;
  const stepScoreIcon = tab === 4 ? stepIconActiveColor : stepIconColor;
  const stepSummariesIcon = tab === 5 ? stepIconActiveColor : stepIconColor;
  const stepCompleteIcon = tab === 6 ? stepIconActiveColor : stepIconColor;

  // SET ACTIVE CHECK BASED ON TAB
  const stepCheckActiveColor = brandColor;
  const stepCheckColor = incompleteColor;
  const stepbgCheck = formData?.gameLastTabArray?.includes(1)
    ? stepCheckActiveColor
    : tab === 1
    ? 'brand.500'
    : stepCheckColor;
  const stepPoseCheck = formData?.gameLastTabArray?.includes(2)
    ? stepCheckActiveColor
    : tab === 2
    ? 'brand.500'
    : stepCheckColor;
  const stepAboutStoryCheck = formData?.gameLastTabArray?.includes(3)
    ? stepCheckActiveColor
    : tab === 3
    ? 'brand.500'
    : stepCheckColor;
  const stepBlockCheck = formData?.gameLastTabArray?.includes(4)
    ? stepCheckActiveColor
    : tab === 4
    ? 'brand.500'
    : stepCheckColor;
  const stepScoreCheck = formData?.gameLastTabArray?.includes(5)
    ? stepCheckActiveColor
    : tab === 5
    ? 'brand.500'
    : stepCheckColor;
  const stepSummariesCheck = formData?.gameLastTabArray?.includes(6)
    ? stepCheckActiveColor
    : tab === 6
    ? 'brand.500'
    : stepCheckColor;
  const stepCompleteCheck = formData?.gameLastTabArray?.includes(7)
    ? stepCheckActiveColor
    : tab === 7
    ? 'brand.500'
    : stepCheckColor;

  const steps = [
    {
      title: 'Background',
      description:
        'Contact Info sddfaf asfasf  fASAF dad  EDsd dA dADda DDEde Dd DEWe Q QW OIH OIHO HIUG G 8G 8G 8 UG8 G8 G8 G 8G GEwgeg',
    },
    { title: 'Character', description: 'Date & Time' },
    { title: 'Overview', description: 'Select Rooms' },
    { title: 'Story', description: 'Select Rooms' },
    { title: 'Prefrences', description: 'Select Rooms' },
    { title: 'Design', description: 'Select Rooms' },
    { title: 'Launch', description: 'Select Rooms' },
  ];
  const [activeStep, setActiveStep] = useState(1);

  const handleStepChange = (step: any) => {
    setActiveStep(step);
  };

  const handleReadMore = (index: number) => {
    const newShowFullTextStates = [...showFullTextStates];
    newShowFullTextStates[index] = true;
    setShowFullTextStates(newShowFullTextStates);
  };

  const handleEditClick = (player: any, i: any) => {
    setInputValue((prev: any) => {
      return {
        ...prev,
        pid: player?.gasId,
        pimg: player?.gasAssetImage,
        pname: player?.gasAssetName,
        i,
      };
    });
    setIsEditing(true);
    setIsSave(false);
  };

  const handleSave = () => {
    setIsSave(true);
    setIsEditing(false);
  };
  //navin 16-12

  useEffect(() => {
    if (formData.gameIsSetCongratsSingleMessage === 'true') {
      setFormData((prev) => ({
        ...prev,
        gameIsSetCongratsSingleMessage: 'true',
        gameIsSetCongratsScoreWiseMessage: 'false',
      }));
    }
  }, [formData.gameIsSetCongratsSingleMessage]);

  //navin
  const playerPerview = (id: any) => {
    setPreview(true);
    setPreviewId(id);
  };
  const makeInputFiled = (id: any, name: any) => {
    if (formData.gameNonPlayingCharacterId !== id) {
      // setFormData((prev) => ({
      //   ...prev,
      //   gameNonPlayingCharacterId: id,
      //   gameNonPlayerName: name,
      // }));
        setFormData((prev) => {
         const options = Array.isArray(prev.gameNonPlayerOption)
          ? prev.gameNonPlayerOption
          : [];

        const alreadyExists = options.some(
          (npc: any) => npc.gasId === id
        );
        return {
          ...prev,
          gameNonPlayingCharacterId: id,
          gameNonPlayerName: name,
          gameNonPlayerOption: alreadyExists
            ? prev.gameNonPlayerOption
            : prev.gameNonPlayerOption.length === 0 ? [{
                  gasId: id,
                  name,
                  voices: {
                    npc: '',
                    male: '',
                    female: '',
                    narrator: '',
                  },
                }] :[
                ...(prev.gameNonPlayerOption),
                {
                  gasId: id,
                  name,
                  voices: {
                    npc: '',
                    male: '',
                    female: '',
                    narrator: '',
                  },
                },
              ],
        };
      });
      setPreview(true);
    } else {
      setFormData((prev) => ({
        ...prev,
        gameNonPlayingCharacterId: '',
        gameNonPlayerName: name,
      }));
    }
  };
  const reducePercentage = 16 * tab - 16;

  useEffect(() => {
    if (formData.gameNonPlayingCharacterId) {
      playerPerview(formData.gameNonPlayingCharacterId);
    }
  }, [formData.gameNonPlayingCharacterId]);

  //// debounced for auto upload when onchange for reflection
  const debouncedSubmit = useCallback(
    debounce(async (data: any) => {
      try {
        const datas = JSON.stringify(data);
        const resu = await createReflection(datas);
        if (resu.status !== 'Success') {
          return false;
        }
        if (resu.status == 'Success') {
        }
      } catch (error) {
        console.error('An error occurred while sending the request:', error);
      }
    }, 500),
    [id], // Empty dependency array to ensure that the function is only created once
  );

  useEffect(() => {
    if (id && autosave) {
      if (formData.gameIsShowReflectionScreen === 'true' && tab === 5) {
        // if (reflectionQuestions && formData.gameReflectionQuestion) {

        const data = {
          reflectionQuestions: reflectionQuestions,
          gameReflectionQuestion: formData.gameReflectionQuestion,
          gameId: id,
          translationId: formData.gameLanguageId,
        };
        //end
        if (languages === formData.gameLanguageId) {
          debouncedSubmit(data);
        }
        debouncedSubmit(data);
      }
      // }
    }
  }, [
    reflectionQuestions,
    formData.gameReflectionQuestion,
    id,
    formData.gameIsShowReflectionScreen,
  ]);

  //// debounce for game table

  const debouncedSubmitGame = useCallback(
    debounce(async (data: any, changeLangId: number) => {
      try {
        if (changeLangId === 1) {
          const result = await updateGame(id, data);
          if (result?.status !== 'Success') {
          } else {
            if (tab !== 4 && updateGameAPIintialLoadTracker > 0) {
              const prevFormData = prevFormDataRef?.current;
              if (prevFormData !== null) {
                const difference = findTheDifferenceInAnObject(
                  formData,
                  prevFormData,
                );
                const hasTabChange = difference.some((obj: any) => {
                  return obj.path.includes('gameLastTab');
                });
                if (hasTabChange === false) {
                  dispatch(
                    updatePreviewData({
                      isModified: true,
                      action: null,
                      gameId: parseInt(id),
                    }),
                  );
                }
                prevFormDataRef.current = { ...formData };
              } else if (updateGameAPIintialLoadTracker == 0) {
                updateGameAPIintialLoadTracker++;
              }
            }
          }
        } else {
          const result = await gameOverviewGameContentLang(id, data);
        }
      } catch (error) {
        console.error('An error occurred while sending the request:', error);
      }
    }, 500),
    [id],
  );
  const findTheDifferenceInAnObject = (extObj: any = {}, newObj: any = {}) => {
    const difference = diff(extObj, newObj);
    return difference;
  };

  useEffect(() => {
    const changeLangId = languages;
    if (id && autosave) {
      if (formData && formData.gameQuestNo) {
        const newFormData = { ...formData };
        delete newFormData['gameLastTabArray'];
        // delete newFormData['gameLastTab'];

        const combinedData = {...newFormData,backgroundquestImage}
        let data = JSON.stringify(combinedData);
        if (languages === formData.gameLanguageId) {
          debouncedSubmitGame(data, changeLangId);
        }
        setExtensiveNavigation(null);
      }
    }
  }, [formData]);

  const debouncedStorySubmit = useCallback(
    debounce(async (data: any,files: Record<string, File>) => {
      try {
        const formData = new FormData();

        formData.append('data', JSON.stringify(data));
        Object.entries(files).forEach(([key, file]) => {
          if (file instanceof File) {
            formData.append(key, file);
          }
        });

        console.log('FormData sending:', [...formData.entries()]);
        const result = await setStory(id, formData);
        if (result?.status !== 'Success') {
          setIsDeleteActionDone((prev) => ({
            reqStatus: null,
            resStatus: null,
          }));
          return console.warn('updateBackground error :' + result?.err);
        } else {
          setIsDeleteActionDone((prev) => ({ ...prev, resStatus: true }));
        }
      } catch (error) {
        console.error('An error occurred while sending the request:', error);
      }
    }, 500),
    [id], // Empty dependency array to ensure that the function is only created once
  );
  //// debounced for auto upload when onchange in Completion Screen(s)
  const debouncedCompliSubmit = useCallback(
    debounce(async (data: any) => {
      const prevFormData = prevCompliDataRef?.current;
      if (prevFormData !== null) {
        const difference = findTheDifferenceInAnObject(data, prevFormData);
        const hasTabChange = difference.some((obj: any) => {
          return obj.path.includes('gameLastTab');
        });
        if (hasTabChange === false) {
          dispatch(
            updatePreviewData({ isModified: true, gameId: parseInt(id) }),
          );
        }
      }
      prevFormDataRef.current = { ...formData };
      try {
        let datas = JSON.stringify(data);

        const result = await UpdateCompletionScreen(id, datas);
        if (result?.status !== 'Success') {
        } else {
          dispatch(
            updatePreviewData({ isDispatched: true, gameId: parseInt(id) }),
          );
        }
      } catch (error) {
        console.error('An error occurred while sending the request:', error);
      }
    }, 500),
    [id], // Empty dependency array to ensure that the function is only created once
  );

  function debounce(func: any, wait?: any) {
    let timeout: any;
    return function executedFunction(...args: any) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  useEffect(() => {
    const handleBlockChange = async () => {
      if (id && autosave) {
        // if (input.length !== 0 && items.length !== 0) {
        const data = {
          items: items,
          input: input,
          alphabet: alphabet,
          interactionBlock: interactionBlock,
          transulateId: formData.gameLanguageId,
          gameQuestNo: serias,
        };

        if (languages === formData.gameLanguageId) {
          await debouncedStorySubmit(data,uploadedFiles);
        }
        // }
        // getDuration();
      }
    };

    handleBlockChange();
  }, [input, items ,uploadedFiles]);

  useEffect(() => {
    if (id && autosave) {
      if (languages === formData.gameLanguageId) {
        if (Object.keys(Completion).length) debouncedCompliSubmit({...compliData,backgroundquestImage});
      }
    }
  }, [compliData,backgroundquestImage]);
  ////handleCompliStore

  useEffect(() => {
    const selectBlockoptions = items.map((item: any) => ({
      value: item.input,
      label: item.id,
    }));
    setSelectBlock(selectBlockoptions);

    if (items && items.length > 0) {
      const lastItem = items[items.length - 1];
      const maxInputItem = items.reduce(
        (max: any, item: any) => (item.input > max.input ? item : max),
        items[0],
      );
      setFoundLastInput(maxInputItem.input);
    }
  }, [items]);

  // onClick Func
  const duplicateSeq = (seq: any, i: any, name: any) => {
    const sequencial = `${count / 10 + 1}`;
    const upNextSequencial = `${(count + 1) / 10 + 1}`;
    const floatRegex = /^[-+]?(\d*\.\d+|\.\d+)$/;
    const id = `${serias}.${count}`;
    const upNext = `${serias}.${count + 1}`;
    setUpNext(upNext);
    setCount(count + 1);
    const newArr = { id, type: name, upNext, input: count, questNo: serias };

    setItems((prevArray: any) => {
      const nextIndex = i + 1;
      setNumber([...number, newArr.input]);
      return [
        ...prevArray.slice(0, nextIndex),
        newArr,
        ...prevArray
          .slice(nextIndex)
          .map((item: any) => ({ ...item, upNext: id })),
      ];
    });

    setSequence([...sequence, id]);
    setDummySequence([...dummySequence, id]);
    setUpNextCount([...upNextCount, upNext]);
    if (name === 'Interaction') {
      const currentAlpha = alphabet
        .slice()
        .find((item: any) => item.seqs === id);
      if (id !== currentAlpha?.seqs) {
        let secondaryArray: any = [];
        let makcount = countalphabet;

        for (let i = 0; i < 3; i++) {
          // Insert data into the array
          let inc = makcount + i + 1;
          secondaryArray.push(inc);
        }
        setAlphabetCount(secondaryArray[2]);
        setAlphabet((prev: any) => [
          ...prev,
          { seqs: id, option: 'A', secondaryId: secondaryArray[0] },
          { seqs: id, option: 'B', secondaryId: secondaryArray[1] },
          { seqs: id, option: 'C', secondaryId: secondaryArray[2] },
        ]);
      }
    }
    setInput((prevInput: any) => {
      const noteKey = `Note${count}`;
      const LinkKey = `Link${count}`;
      const WehaveChooseKey = `WehaveChoose${count}`;
      const KeyInsightsKey = `KeyInsights${count}`;
      const SwipeMiniGameKey = `SwipeMiniGame${count}`;
      const DragForNowKey = `DragForNow${count}`;
      const PreAssessmentKey = `PreAssessment${count}`;
      const PostAssessmentKey = `PostAssessment${count}`;
      const validatePromptKey = `validatePrompt${count}`;
      const evaluationPromptKey = `evaluationPrompt${count}`;
      const OverviewKey = `Overview${count}`;
      const ScenarioCompletionKey = `ScenarioCompletion${count}`;
      const dialogKey = `Dialog${count}`;
      const interactionKey = `Interaction${count}`;
      const ReflectionKey = `Reflection${count}`;

      // Previous Data Object
      const oldNoteKey = prevInput?.[`Note${seq.input}`];
      const oldLinkKey = prevInput?.[`Link${seq.input}`]; 
      const oldWehaveChooseKey = prevInput?.[`WehaveChoose${seq.input}`]; 
      const oldKeyInsightsKey = prevInput?.[`KeyInsights${seq.input}`]; 
      const oldSwipeMiniGameKey = prevInput?.[`SwipeMiniGame${seq.input}`]; 
      const oldDragForNowKey = prevInput?.[`DragForNow${seq.input}`]; 
      const oldPreAssessmentKey = prevInput?.[`PreAssessment${seq.input}`];
      const oldPostAssessmentKey = prevInput?.[`PostAssessment${seq.input}`];
      const oldvalidatePromptKey = prevInput?.[`validatePrompt${seq.input}`];
      const oldevaluationPromptKey = prevInput?.[`evaluationPrompt${seq.input}`];
      const oldOverviewKey = prevInput?.[`Overview${seq.input}`];
      const oldScenarioCompletionKey = prevInput?.[`ScenarioCompletion${seq.input}`];
      const oldDialogKey = prevInput?.[`Dialog${seq.input}`];
      const oldInteractionKey = prevInput?.[`Interaction${seq.input}`];
      const oldReflectionKey = prevInput?.[`Reflection${seq.input}`];

      // Activate RFST
      if (oldInteractionKey?.responseObject?.A !== '' || null) {
        setInteractionBlock((prev: any) => {
          return { ...prev, [`Resp${[count]}`]: count };
        });
      }
      if (oldInteractionKey?.feedbackObject?.A !== '' || null) {
        setInteractionBlock((prev: any) => {
          return { ...prev, [`Feedbk${[count]}`]: count };
        });
      }
      if (oldInteractionKey?.SkillTag !== '' || null) {
        setInteractionBlock((prev: any) => {
          return { ...prev, [`Skills${[count]}`]: count };
        });
      }
      if (oldInteractionKey?.optionTitleObject?.A !== '' || null) {
        setInteractionBlock((prev: any) => {
          return { ...prev, [`Title${[count]}`]: count };
        });
      }

      if (seq.type === 'Note') {
        return {
          ...prevInput,
          [noteKey]: {
            ...prevInput?.noteKey,
            id: id,
            note: oldNoteKey?.note,
          },
        };
      }
      if (seq.type === 'Link') {
        return {
          ...prevInput,
          [LinkKey]: {
            ...prevInput?.LinkKey,
            id: id,
            Link: oldLinkKey?.Link,
          },
        };
      }
       if (seq.type === 'WehaveChoose') {
        return {
          ...prevInput,
          [WehaveChooseKey]: {
            ...prevInput?.WehaveChooseKey,
            id: id,
            WehaveChoose: oldWehaveChooseKey?.WehaveChoose,
          },
        };
      }
      if (seq.type === 'KeyInsights') {
        return {
          ...prevInput,
          [KeyInsightsKey]: {
            ...prevInput?.KeyInsightsKey,
            id: id,
            KeyInsights: oldKeyInsightsKey?.KeyInsights,
          },
        };
      }
      if (seq.type === 'SwipeMiniGame') {
        return {
          ...prevInput,
          [SwipeMiniGameKey]: {
            ...prevInput?.SwipeMiniGameKey,
            id: id,
            SwipeMiniGame: oldSwipeMiniGameKey?.SwipeMiniGame,
          },
        };
      }
      if (seq.type === 'DragForNow') {
        return {
          ...prevInput,
          [DragForNowKey]: {
            ...prevInput?.DragForNowKey,
            id: id,
            DragForNow: oldDragForNowKey?.DragForNow,
          },
        };
      }
      if (seq.type === 'PreAssessment') {
        return {
          ...prevInput,
          [PreAssessmentKey]: {
            ...prevInput?.PreAssessmentKey,
            id: id,
            PreAssessment: oldPreAssessmentKey?.PreAssessment,
          },
        };
      }
      if (seq.type === 'PostAssessment') {
        return {
          ...prevInput,
          [PostAssessmentKey]: {
            ...prevInput?.PostAssessmentKey,
            id: id,
            PostAssessment: oldPostAssessmentKey?.PostAssessment,
          },
        };
      }
      if (seq.type === 'validatePrompt') {
        return {
          ...prevInput,
          [validatePromptKey]: {
            ...prevInput?.validatePromptKey,
            id: id,
            validatePrompt: oldvalidatePromptKey?.validatePrompt,
          },
        };
      }
      if (seq.type === 'evaluationPrompt') {
        return {
          ...prevInput,
          [evaluationPromptKey]: {
            ...prevInput?.evaluationPromptKey,
            id: id,
            evaluationPrompt: oldevaluationPromptKey?.evaluationPrompt,
          },
        };
      }
      if (seq.type === 'Overview') {
        return {
          ...prevInput,
          [OverviewKey]: {
            ...prevInput?.OverviewKey,
            id: id,
            Overview: oldOverviewKey?.Overview,
          },
        };
      }
      if (seq.type === 'ScenarioCompletion') {
        return {
          ...prevInput,
          [ScenarioCompletionKey]: {
            ...prevInput?.ScenarioCompletionKey,
            id: id,
            ScenarioCompletion: oldScenarioCompletionKey?.ScenarioCompletion,
          },
        };
      }
      if (seq.type === 'Reflection') {
        return {
          ...prevInput,
          [ReflectionKey]: {
            ...prevInput?.ReflectionKey,
            id: id,
            Reflection: oldReflectionKey?.Reflection,
          },
        };
      }
      if (seq.type === 'Dialog') {
        return {
          ...prevInput,
          [dialogKey]: {
            ...prevInput[dialogKey],
            id: id,
            dialog: oldDialogKey?.dialog,
            character: oldDialogKey?.character,
            animation: oldDialogKey?.animation,
            voice: '',
          },
        };
      }
      if (seq.type === 'Interaction') {
        //Previous Object Data's
        const optionsObject = oldInteractionKey?.optionsObject;
        const ansObject = oldInteractionKey?.ansObject;
        const feedbackObject = oldInteractionKey?.feedbackObject;
        const responseObject = oldInteractionKey?.responseObject;
        const optionTitleObject = oldInteractionKey?.optionTitleObject;
        const optionsemotionObject = oldInteractionKey?.optionsemotionObject;
        const optionsvoiceObject = oldInteractionKey?.optionsvoiceObject;
        const scoreObject = oldInteractionKey?.scoreObject;
        const navigateObjects = oldInteractionKey?.navigateObjects;
        const filterNullFields = (
          obj: Record<string, any>,
        ): Record<string, any> => {
          return Object.fromEntries(
            Object.entries(obj).filter(([key, value]) => value !== null),
          );
        };

        return {
          ...prevInput,
          [interactionKey]: {
            ...prevInput[interactionKey],
            id: id,
            interaction: oldInteractionKey?.interaction,
            blockRoll: oldInteractionKey?.blockRoll,
            QuestionsEmotion: oldInteractionKey?.QuestionsEmotion,
            QuestionsVoice: oldInteractionKey?.QuestionsVoice,
            SkillTag: oldInteractionKey?.SkillTag,
            quesionTitle: oldInteractionKey?.quesionTitle,
            optionsObject: {
              A: optionsObject?.A,
              B: optionsObject?.B,
              C: optionsObject?.C,
            },
            ansObject: { A: ansObject?.A, B: ansObject?.B, C: ansObject?.C },
            // feedbackObject:{A: feedbackObject?.A,   B: feedbackObject?.B,    C: feedbackObject?.C},
            feedbackObject: filterNullFields({
              A: feedbackObject?.A,
              B: feedbackObject?.B,
              C: feedbackObject?.C,
            }),
            // responseObject:{A: responseObject?.A,    B: responseObject?.B,    C: responseObject?.C},
            responseObject: filterNullFields({
              A: responseObject?.A,
              B: responseObject?.B,
              C: responseObject?.C,
            }),
            optionTitleObject: {
              A: optionTitleObject?.A,
              B: optionTitleObject?.B,
              C: optionTitleObject?.C,
            },
            optionsemotionObject: {
              A: optionsemotionObject?.A,
              B: optionsemotionObject?.B,
              C: optionsemotionObject?.C,
            },
            optionsvoiceObject: {
              A: optionsvoiceObject?.A,
              B: optionsvoiceObject?.B,
              C: optionsvoiceObject?.C,
            },
            scoreObject: {
              A: scoreObject?.A ? scoreObject?.A : null,
              B: scoreObject?.B ? scoreObject?.B : null,
              C: scoreObject?.C ? scoreObject?.C : null,
            },
            navigateObjects: {
              A: navigateObjects?.A,
              B: navigateObjects?.B,
              C: navigateObjects?.C,
            },
          },
        };
      }
    });
  };

  const delSeq = (seq: any, i: any, name: any) => {
    const filteredNotes = Object.keys(input)
      .filter((noteKey) => input[noteKey].Notenavigate === seq.input)
      .map((noteKey) => {
        input[noteKey].Notenavigate = null;
        input[noteKey].NoteleadShow = null;
        return input[noteKey];
      });

    const filteredLinks = Object.keys(input)
      .filter((Linkkey) => input[Linkkey].Linknavigate === seq.input)
      .map((Linkkey) => {
        input[Linkkey].Linknavigate = null;
        input[Linkkey].LinkleadShow = null;
        return input[Linkkey];
      });
    const filteredKeyInsights = Object.keys(input)
      .filter((KeyInsightskey) => input[KeyInsightskey].KeyInsightsnavigate === seq.input)
      .map((KeyInsightskey) => {
        input[KeyInsightskey].KeyInsightsnavigate = null;
        input[KeyInsightskey].KeyInsightsleadShow = null;
        return input[KeyInsightskey];
      });
      const filteredPreAssessment = Object.keys(input)
      .filter((PreAssessmentkey) => input[PreAssessmentkey].PreAssessmentnavigate === seq.input)
      .map((PreAssessmentkey) => {
        input[PreAssessmentkey].PreAssessmentnavigate = null;
        input[PreAssessmentkey].PreAssessmentleadShow = null;
        return input[PreAssessmentkey];
      });
      const filteredPostAssessment = Object.keys(input)
      .filter((PostAssessmentkey) => input[PostAssessmentkey].PostAssessmentnavigate === seq.input)
      .map((PostAssessmentkey) => {
        input[PostAssessmentkey].PostAssessmentnavigate = null;
        input[PostAssessmentkey].PostAssessmentleadShow = null;
        return input[PostAssessmentkey];
      });
      const filteredvalidatePrompt = Object.keys(input)
      .filter((validatePromptkey) => input[validatePromptkey].validatePromptnavigate === seq.input)
      .map((validatePromptkey) => {
        input[validatePromptkey].validatePromptnavigate = null;
        input[validatePromptkey].validatePromptleadShow = null;
        return input[validatePromptkey];
      });
      const filteredevaluationPrompt = Object.keys(input)
      .filter((evaluationPromptkey) => input[evaluationPromptkey].evaluationPromptnavigate === seq.input)
      .map((evaluationPromptkey) => {
        input[evaluationPromptkey].evaluationPromptnavigate = null;
        input[evaluationPromptkey].evaluationPromptleadShow = null;
        return input[evaluationPromptkey];
      });
    const filteredDialog = Object.keys(input)
      .filter((dialogKey) => input[dialogKey].Dialognavigate === seq.input)
      .map((dialogKey) => {
        input[dialogKey].Dialognavigate = null;
        input[dialogKey].DialogleadShow = null;
        return input[dialogKey];
      });
    const filteredInteraction = Object.keys(input)
      .filter(
        (interactionkey) =>
          input[interactionkey].navigateObjects &&
          Object.values(input[interactionkey].navigateObjects).includes(
            seq.input,
          ),
      )
      .map((interactionkey) => {
        Object.keys(input[interactionkey].navigateObjects).forEach((option) => {
          if (input[interactionkey].navigateObjects[option] === seq.input) {
            input[interactionkey].navigateObjects[option] = null;
            input[interactionkey].navigateshowObjects[option] = null;
          }
        });
        return input[interactionkey];
      });
    if (name === 'Interaction') {
      setAlphabet((prevAlphabet: any) => {
        // Use filter to create a new array without items that match the condition
        const updatedAlphabet = prevAlphabet?.filter(
          (item: any) => item.seqs !== seq.id,
        );
        return updatedAlphabet;
      });
    }
    setItems((previtems: any) => {
      // Use filter to create a new array without items that match the condition
      const updatedItems = previtems?.filter(
        (item: any) => item.input !== seq.input,
      );
      return updatedItems;
    });
    setDeleteseq(true);
    dispatch(
      updatePreviewData({
        gameId: parseInt(id),
        action: {
          name: 'blockDelete',
          value: seq.id,
          quest: seq.questNo,
          DelseQ: seq.input,
        },
      }),
    );
    setIsDeleteActionDone((prev: any) => ({ ...prev, reqStatus: true }));
  };
  const deleteQuest = async (gameid: any, questNo: any) => {
    const data = {
      quest: questNo,
      exid: id,
    };
    const result = await QuestDeletion(gameid, JSON.stringify(data));
    if (result?.status !== 'Success') {
      if (result?.message === 'Game has No block') {
        toast({
          title: 'Game has No blocks',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return false;
      }
      return console.warn('updateBackground error :' + result?.err);
    } else {
      dispatch(
        updatePreviewData({
          gameId: parseInt(id),
          action: {
            name: 'questDelete',
            value: questNo,
            DelseQ: null,
            quest: questNo,
          },
          isModified: true,
        }),
      );
      setIsDeleteActionDone({ reqStatus: true, resStatus: null });
      setInteractionBlock([]);
      setItems([]);
      setInput([]);
      setAlphabet([]);
      setBlockItems([]);
      setListQuest(null);
      fetchBlocks();
      handleGet(1);
      setQuestTabState(1);
    }
  };

  let tarSeqRef;
  const handleTargetQuest = (progressItem: any, progressIndex: number) => {
    setTargetSequence(progressItem);
    tarSeqRef = document.getElementById(`tarSeqRef${progressItem?.id}`);
    /**update the choosed block sequence to show the screenpreview */
    const clickedQuestSeq = progressItem?.id;
    const clickedQuestNo = parseInt(clickedQuestSeq.split('.')[0]);
    const clickedSeqNo = parseInt(clickedQuestSeq.split('.')[1]);
    dispatch(
      updatePreviewData({
        currentQuest: clickedQuestNo,
        activeBlockSeq: clickedSeqNo,
        gameId: parseInt(id),
      }),
    );
    /**End of update the choosed block sequence to show the screenpreview */

    if (tarSeqRef) {
      tarSeqRef.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
    }
  };

  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();

  let arrowSeqRef: any;
  let focusSeqRef: any;

  const handleKeyDown = (event: any, i: any, seq: any) => {
    let indexToFind: any;
    setTargetSequence(seq);
    if (targetSequence) {
      indexToFind = items.findIndex(
        (item: any) => item.id === targetSequence.id,
      );
    } else {
      indexToFind = 0;
    }
    if (indexToFind >= 0 && indexToFind < items.length) {
      if (
        event.key &&
        (event.type === 'click' ||
          event.key !== 'Escape' ||
          event.ctrlKey === true)
      ) {
        if (seq) {
          setTargetSequence(seq);
        }
      }
      if (event.key === 'Escape') {
        setTargetSequence(null);
      }
      switch (event.code) {
        default:
          break;
      }

      if (event.type == 'click') {
        if (targetSequence?.id !== seq?.id) {
          focusSeqRef = document.getElementsByClassName(seq.id);
          focusSeqRef?.[0].classList.remove('non-caret');
          focusSeqRef?.[0].focus();
        }
      }

      if (event.code == 'Enter') {
        focusSeqRef = document.getElementsByClassName(seq.id);
        focusSeqRef?.[0].removeAttribute('readonly');
        focusSeqRef?.[0].classList.remove('non-caret');
        // focusSeqRef?.[0].focus();
      }

      if (event.ctrlKey === true && event.code === 'KeyC') {
        focusSeqRef = document.getElementsByClassName(seq.id);
        var isFieldFocused = document.activeElement.classList.contains(seq.id);
        var isFormFieldFocused = ['input', 'textarea', 'select'].includes(
          document.activeElement.tagName.toLowerCase(),
        );
        if (focusSeqRef?.[0].readOnly) {
          setCopySequence(seq);
        }
      }

      if (event.code === 'KeyV' && event.ctrlKey === true) {
        focusSeqRef = document.getElementsByClassName(seq.id);
        var isFieldFocused = document.activeElement.classList.contains(seq.id);
        var isFormFieldFocused = ['input', 'textarea', 'select'].includes(
          document.activeElement.tagName.toLowerCase(),
        );

        if (focusSeqRef?.[0].readOnly) {
          if (copySequence) {
            duplicateSeq(copySequence, i, copySequence.type);
          }
        }
      }

      if (event.ctrlKey === true && event.code === 'KeyD') {
        focusSeqRef = document.getElementsByClassName(seq.id);
        var isFieldFocused = document.activeElement.classList.contains(seq.id);
        var isFormFieldFocused = ['input', 'textarea', 'select'].includes(
          document.activeElement.tagName.toLowerCase(),
        );

        if (focusSeqRef?.[0].readOnly) {
          duplicateSeq(seq, i, seq.type);
        }
      }

      if (event.ctrlKey && event.shiftKey) {
        if (event.code === 'ArrowUp') {
          setTimeout(() => {
            focusSeqRef = document.getElementsByClassName(
              `${items[indexToFind === 0 ? 0 : indexToFind - 1]?.id}`,
            );
            focusSeqRef?.[0]?.focus();
          }, 200);
          moveItem(i, i - 1, seq);
        } else if (event.code === 'ArrowDown') {
          setTimeout(() => {
            focusSeqRef = document.getElementsByClassName(
              `${
                items[indexToFind === items.length ? 0 : indexToFind + 1]?.id
              }`,
            );
            focusSeqRef?.[0]?.focus();
          }, 200);
          moveItem(i, i + 1, seq);
        }
      }
    }
    dispatch(
      updatePreviewData({
        activeBlockSeq: parseInt(seq.id.split('.')[1]),
        gameId: parseInt(id),
        isModified: null,
      }),
    );
  };

  const moveItem = (startIndex: number, endIndex: number, seq: any) => {
    // Ensure endIndex is within the bounds of the array
    endIndex = Math.max(0, Math.min(items.length - 1, endIndex));
    focusSeqRef = document.getElementsByClassName(seq.id);
    focusSeqRef?.[0]?.focus();

    // Perform the move
    const updatedItems = [...items];
    const [movedItem] = updatedItems.splice(startIndex, 1);
    updatedItems.splice(endIndex, 0, movedItem);

    const updatedMovingItems = updatedItems.map((item: any, index) => {
      return {
        ...item,
        id: dummySequence[index] || item.id,
        upNext: upNextCount[index],
      };
    });

    const updateInteraction = updatedItems
      .map((item, index) => {
        if (item?.type === 'Interaction') {
          return { ...item, from: item.id, to: sequence[index] };
        }
        return null; // Return null for items that don't meet the condition
      })
      .filter((item) => item !== null);

    const updatedAlphabet = alphabet.map((item: { seqs: string }) => {
      // Find the corresponding updateInteraction item
      const correspondingUpdate = updateInteraction.find(
        (updateItem) => updateItem.from === item.seqs,
      );

      // If a corresponding updateInteraction item is found, update the seqs value
      if (correspondingUpdate) {
        return { ...item, seqs: correspondingUpdate.to };
      }

      // If no corresponding updateInteraction item is found, return the original item
      return item;
    });
    // Update the state with the new order
    setItems(updatedMovingItems);
    setAlphabet(updatedAlphabet);
    setBlockItems(updatedItems);
  };

  const updateExtensiveNavigation = (id: number) => {
    setExtensiveNavigation(id);
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    handleGetReflection();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleMouseEnter = async (review: any, index: number) => {
    try {
      if (review.readStatus === 0) {
        const sendreviews = JSON.stringify(review);
        const res = await addReadStatus(sendreviews);
        if (res?.status === 200 || res?.status === 'Success') {
          const updatedTabReviews = reviews[tab].map((rev: any) => {
            if (rev?.reviewId === review.reviewId) {
              return { ...rev, readStatus: 1 };
            }
            return rev;
          });
          let updatedReview = [...reviews];
          updatedReview[tab] = [...updatedTabReviews];
          setReviews([...updatedReview]);
        }
      }

      return;
    } catch (error) {
      // Handle errors that may occur during the API call
      console.error('API Error:', error);
    }
  };

  // const actionDoneRef = useRef(false);

  useEffect(() => {
    // if (actionDoneRef.current) return;

    if (
      isDeleteActionDone.reqStatus === true &&
      isDeleteActionDone.resStatus === true
    ) {
      // actionDoneRef.current = true;
      setIsDeleteActionDone({ reqStatus: null, resStatus: null });
      dispatch(resetDeleteAction({ gameId: id }));
    } else if (
      isDeleteActionDone.reqStatus === null &&
      isDeleteActionDone.resStatus === true
    ) {
      // actionDoneRef.current = true;
      dispatch(updatePreviewData({ isModified: true, gameId: parseInt(id) }));
      setIsDeleteActionDone({ reqStatus: null, resStatus: null });
    }
  }, [isDeleteActionDone]);

  const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
  return (
    <>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(10px)',
          }}
        >
          <HashLoader color="#3b38e0" />
        </div>
      )}

      <Grid templateColumns="repeat(5, 1fr)" gap={2}>
        <GridItem
          colSpan={{ lg: 0, xl: 0 }}
          display={{
            base: 'none',
            sm: 'none',
            md: 'none',
            lg: 'none',
            xl: 'block',
          }}
        >
          <HStack borderRadius={'20px'} width={'285px'} overflow={'auto'}>
            <Card
              position="fixed"
              flexDirection="column"
              bg={'#E2E8F0'}
              w="18%"
              top={'2%'}
              mb={'20px'}
              h="95vh"
              borderColor="#11047a"
              boxShadow="0 3px 10px rgba(0, 0, 0, 0.2)"
              overflowX={'auto'}
            >
              <Flex
                display={'flex'}
                justifyContent={'space-around'}
                alignItems={'center'}
              >
                <Text
                  color={'black'}
                  fontSize={25}
                  fontWeight={800}
                  letterSpacing={'2px'}
                  mr={'px'}
                  ml={'0px'}
                >
                  ATLANTIS
                </Text>
                <Box ml={'10px'} transform={'scale(1.3)'} borderRadius={'50%'}>
                  <SidebarResponsive routes={routes} />
                </Box>
              </Flex>
              <Flex>
                <Box
                  display="flex"
                  height="1px"
                  width="100%"
                  background="rgba(135, 140, 189, 0.3)"
                  marginTop="20px"
                ></Box>
              </Flex>
              <Flex
                position="relative"
                mt={'49px'}
                direction="column"
                justifyContent="space-between"
              >
                <Flex
                  _after={{
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    left: 0,
                    bottom: 0,
                    height: `${heightOfTab ? heightOfTab : '0px'}`,
                    bg: 'green',
                    transition: '0.5s linear',
                    zIndex: -1,
                    opacity: 1,
                  }}
                  position="absolute"
                  left="32.5px"
                  h="100%"
                  w="2px"
                  bg={'white'}
                  transition={'background 2.5s ease !important'}
                  zIndex={1}
                />
                <OrderStep
                  cursor={'pointer'}
                  onClick={() => handleTrans(1)}
                  mb="30px"
                  name="Background"
                  tabNo={1}
                  status={tab1}
                  BlockItems={BlockItems}
                  icon={
                    <IconBox
                      h="46px"
                      w="46px"
                      ml="8px"
                      bg="#FFFFFF"
                      transition="all 0.2s linear 0s"
                      boxShadow={stepPoseIcon}
                      icon={
                        <Icon
                          as={TbView360}
                          color={tab === 1 ? 'brand.500' : stepbgCheck} //icon color
                          h="24px"
                          w="24px"
                        />
                      }
                    />
                  }
                />
                <OrderStep
                  cursor={'pointer'}
                  onClick={() => handleTrans(2)}
                  mb="30px"
                  name="Character"
                  tabNo={2}
                  status={tab2}
                  BlockItems={BlockItems}
                  icon={
                    <IconBox
                      h="46px"
                      w="46px"
                      ml="8px"
                      // color='#fff'
                      boxShadow={stepAboutStoryIcon}
                      bg="#FFFFFF"
                      transition="all 0.2s linear 0s"
                      icon={
                        <Icon
                          as={FaRobot}
                          color={tab === 2 ? 'brand.500' : stepPoseCheck} //icon color{}
                          h="24px"
                          w="24px"
                        />
                      }
                    />
                  }
                />
                <OrderStep
                  cursor={'pointer'}
                  onClick={() => handleTrans(3)}
                  mb="30px"
                  name="Overview"
                  tabNo={3}
                  status={tab3}
                  BlockItems={BlockItems}
                  icon={
                    <IconBox
                      h="46px"
                      w="46px"
                      ml="8px"
                      boxShadow={stepBlockIcon}
                      bg="#FFFFFF"
                      transition="all 0.2s linear 0s"
                      icon={
                        <Icon
                          as={MdOutlineSubtitles}
                          color={tab === 3 ? 'brand.500' : stepAboutStoryCheck} //icon color{}{}
                          h="24px"
                          w="24px"
                        />
                      }
                    />
                  }
                />
                <OrderStep
                  data={cblocks}
                  quest={quest}
                  cursor={'pointer'}
                  onClick={() => handleTrans(4)}
                  mb="15px"
                  name="Story"
                  tabNo={4}
                  status={tab4}
                  handleTargetQuest={handleTargetQuest}
                  updateExtensiveNavigation={(id: number | null) =>
                    updateExtensiveNavigation(id)
                  }
                  extensiveNavigation={extensiveNavigation}
                  icon={
                    <IconBox
                      h="46px"
                      w="46px"
                      ml="8px"
                      boxShadow={stepAboutStoryCheck}
                      bg="#FFFFFF"
                      transition="all 0.2s linear 0s"
                      icon={
                        <Icon
                          as={GiBlackBook}
                          color={tab === 4 ? 'brand.500' : stepBlockCheck} //icon color{}{}{}
                          h="24px"
                          w="24px"
                        />
                      }
                    />
                  }
                  BlockItems={BlockItems}
                  listBlockItems={listBlockItems}
                  listQuest={listQuest}
                  id={id}
                  handleGet={handleGet}
                  fetchBlocks={fetchBlocks}
                  questTabState={questTabState}
                  setQuestTabState={setQuestTabState}
                  deleteQuest={deleteQuest}
                  delSeq={delSeq}
                />
                <OrderStep
                  cursor={'pointer'}
                  onClick={() => handleTrans(5)}
                  mb="30px"
                  name="Design"
                  tabNo={5}
                  status={tab5}
                  BlockItems={BlockItems}
                  icon={
                    <IconBox
                      h="46px"
                      w="46px"
                      ml="8px"
                      boxShadow={stepScoreIcon}
                      bg="#FFFFFF"
                      transition="all 0.2s linear 0s"
                      icon={
                        <Icon
                          as={FaCubes}
                          color={tab === 5 ? 'brand.500' : stepScoreCheck} //icon color{}{}{}{}
                          h="24px"
                          w="24px"
                        />
                      }
                    />
                  }
                />
                <OrderStep
                  cursor={'pointer'}
                  onClick={() => handleTrans(6)}
                  // mb="30px"
                  name="Preferences"
                  tabNo={6}
                  status={tab6}
                  BlockItems={BlockItems}
                  icon={
                    <IconBox
                      h="46px"
                      w="46px"
                      ml="8px"
                      boxShadow={stepSummariesIcon}
                      bg="#FFFFFF"
                      transition="all 0.2s linear 0s"
                      icon={
                        <Icon
                          as={MdTune}
                          color={tab === 6 ? 'brand.500' : stepSummariesCheck} //icon color{}{}{}{}{}
                          h="24px"
                          w="24px"
                        />
                      }
                    />
                  }
                />
              </Flex>
            </Card>
          </HStack>
        </GridItem>
        <GridItem display={{ sm: 'flex', xl: 'none' }} colSpan={5}>
          <Card w={'100%'} mt={{ base: '65px', xl: '100px' }}>
            <CenterMode
              setTab={setTab}
              completed={formData?.gameLastTabArray}
              ctab={tab}
            />
          </Card>
        </GridItem>
        <GridItem colSpan={{ sm: 5, md: 5, lg: 5, xl: 4 }}>
          <Box
            className="game-creation"
            mt={{ base: '10px', xl: '100px' }}
            pl={{ base: '0', lg: '10px' }}
          >
            <Grid templateColumns="repeat(1, 1fr)" gap={6}>
              <GridItem w="100%" colSpan={2}>
                {/*******************Changes-14/12/23*************************/}
                {preview && (
                  <ImagePreview
                    fetchImg={fetchImg}
                    isOpen={isOpen}
                    onOpen={onOpen}
                    onClose={onClose}
                    values={values}
                    setValues={setValues}
                    selectedCardIndex={selectedCardIndex}
                    handleBackground={handleBackground} // Ensure this prop is included
                  />
                )}

                {tab === 1 ? (
                  <Box
                    className="background-step"
                    display={{ base: 'block', md: 'flex', lg: 'flex' }}
                  >
                    <Box className="bg-img-list" width={'100%'}>
                      <Box
                        display={'flex'}
                        flexDir={'row'}
                        justifyContent={'space-between'}
                        alignItems={'start'}
                      >
                        <Text
                          fontSize={'20px'}
                          fontWeight={800}
                          // m={'10px 10px 10px 20px'}
                          pl={'13px'}
                        >
                          Select a Background
                        </Text>
                      </Box>

                      <Box borderRadius={'70px'} padding={'30px 0'}>
                        <SimpleGrid
                          columns={{ base: 1, md: 2, lg: 3 }}
                          spacing={6}
                        >
                          {img &&
                            img.map((img, i) => (
                              <Box key={i} position={'relative'}>
                                <Card
                                  backgroundColor={
                                    selectedCardIndex === i
                                      ? '#11047a'
                                      : 'white'
                                  }
                                  mb={{ base: '0px', xl: '10px', sm: '20px' }}
                                  padding={'13px'}
                                  key={i}
                                  position="relative"
                                  onMouseEnter={() => handleH(i)}
                                  onMouseLeave={() => handleL()}
                                  boxShadow={
                                    backgroundIndex === i
                                      ? '1px 4px 29px #44445429'
                                      : '1px 4px 29px #44445429'
                                  }
                                  transition={'0.3s'}
                                  // overflow="hidden"
                                >
                                  <Box
                                    position={'relative'}
                                    // overflow={'hidden'}
                                    borderRadius={'10px'}
                                  >
                                    <Img
                                      src={img?.gasAssetImage}
                                      w="100%"
                                      h={'250px'}
                                      borderRadius="20px"
                                      cursor="pointer"
                                    />

                                    {backgroundIndex === i ||
                                    windowWidth < 768 ? (
                                      <Flex
                                        position="absolute"
                                        bottom="0px"
                                        transform="translate(-50%, 0)"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-between"
                                        width="100%"
                                        style={{
                                          opacity: '1',
                                          transform: 'translateY(0)',
                                          transition:
                                            'transform 0.5s ease, opacity 0.5s ease',
                                        }}
                                      >
                                        <Box
                                          bg="white"
                                          width="50%"
                                          height="35px"
                                          borderBottomLeftRadius="10px"
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          cursor="pointer"
                                          _hover={{
                                            bg: '#f0f0f0',
                                          }}
                                          onClick={() =>
                                            handlePreview(
                                              img,
                                              backgroundIndex,
                                              i,
                                            )
                                          }
                                        >
                                          <span style={{ color: 'black' }}>
                                            Preview
                                          </span>
                                        </Box>
                                        <Box
                                          bg="#11047a"
                                          width="50%"
                                          height="35px"
                                          borderBottomRightRadius="10px"
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          cursor="pointer"
                                          _hover={{
                                            bg: '#11047ae3',
                                          }}
                                          onClick={() =>
                                            handleBackground(img, i)
                                          }
                                        >
                                          <span style={{ color: 'white' }}>
                                            {selectedCardIndex === i
                                              ? 'Selected'
                                              : 'Select'}
                                          </span>
                                        </Box>
                                      </Flex>
                                    ) : (
                                      <Flex
                                        position="absolute"
                                        bottom="0"
                                        transform="translate(-50%, 0)"
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-between"
                                        width="100%"
                                        style={{
                                          opacity: '0',
                                          transform: 'translateY(20px)',
                                          transition:
                                            'transform 0.5s ease, opacity 0.5s ease',
                                        }}
                                      >
                                        <Box
                                          bg="white"
                                          width="50%"
                                          height="35px"
                                          borderBottomLeftRadius="10px"
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          cursor="pointer"
                                        >
                                          <span style={{ color: 'black' }}>
                                            Preview
                                          </span>
                                        </Box>
                                        <Box
                                          bg="#11047a"
                                          width="100%"
                                          height="35px"
                                          borderBottomRightRadius="10px"
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          cursor="pointer"
                                        >
                                          <span style={{ color: 'white' }}>
                                            {selectedCardIndex === i
                                              ? 'Selected'
                                              : 'Select'}
                                          </span>
                                        </Box>
                                      </Flex>
                                    )}
                                  </Box>
                                  <Flex
                                    justifyContent={'space-between'}
                                    margin={'10px 0'}
                                    flexDirection={'column'}
                                  >
                                    <Box>
                                      <Text
                                        color={
                                          selectedCardIndex === i
                                            ? 'white'
                                            : 'black'
                                        }
                                        textTransform={'capitalize'}
                                        fontSize="md"
                                        fontWeight="bold"
                                        fontFamily="DM Sans, sans-serif"
                                      >
                                        {img?.gasAssetName}
                                      </Text>
                                    </Box>
                                    <Box mt={2} mb={2} h={'12px'}>
                                      {backgroundIndex === i ||
                                      windowWidth < 768 ? (
                                        <Tooltip
                                          label={img?.temp?.tempStoryLine}
                                          placement="top"
                                        >
                                          <Text
                                            fontSize={'12px'}
                                            fontWeight={'500'}
                                            onMouseEnter={() => setReadMore(i)}
                                            onMouseLeave={() =>
                                              setReadMore(null)
                                            }
                                            color={
                                              selectedCardIndex === i
                                                ? 'white'
                                                : 'black'
                                            }
                                            maxH={
                                              showFullTextStates[i]
                                                ? 'none'
                                                : '1.5em'
                                            } // Limit to one line (adjust height as needed)
                                            // overflow={'hidden'}
                                            // textOverflow={'ellipsis'}
                                            // whiteSpace={'nowrap'}
                                          >
                                            {img?.temp?.tempStoryLine?.length >
                                            60
                                              ? img?.temp?.tempStoryLine.slice(
                                                  0,
                                                  60,
                                                ) + '...'
                                              : img?.temp?.tempStoryLine}
                                          </Text>
                                        </Tooltip>
                                      ) : (
                                        ''
                                      )}
                                    </Box>
                                    <Flex
                                      justifyContent={'space-between'}
                                      margin={'0'}
                                      flexDirection={'column'}
                                      style={{
                                        opacity: hoveredStates[i] ? 1 : 0,
                                        height: hoveredStates[i] ? 'auto' : 0,
                                        overflow: 'hidden',
                                      }}
                                    >
                                      <Box
                                        display={'flex'}
                                        alignItems={'flex-end'}
                                      ></Box>
                                    </Flex>
                                  </Flex>
                                </Card>
                              </Box>
                            ))}
                        </SimpleGrid>
                      </Box>
                      {tab && tab === 1 && ShowReview && (
                        <Menu>
                          <MenuButton
                            p="0px"
                            bg={'brandScheme'}
                            position={'fixed'}
                            bottom={{ base: '105px', xl: '0' }}
                            right={{ base: '15px', xl: '5px' }}
                            className="menureviewshow"
                          >
                            <Icon
                              as={AiFillMessage}
                              bg={'#3311db'}
                              color={'#fff'}
                              w="70px"
                              h="70px"
                              borderRadius={'50%'}
                              p={'15px'}
                              me="10px"
                            />
                          </MenuButton>
                          <MenuList
                            boxShadow={shadow}
                            p="20px"
                            me={{ base: '30px', md: 'unset' }}
                            borderRadius="20px"
                            bg={menuBg}
                            border="none"
                            mt="10px"
                            minW={{ base: '360px' }}
                            maxW={{ base: '360px', md: 'unset' }}
                            zIndex={'100000000'}
                          >
                            <FormControl>
                              <FormLabel fontSize={18} fontWeight={700}>
                                {'Feedback For Background '}
                              </FormLabel>
                              <Box
                                w={'360px'}
                                maxH={'50vh'}
                                overflowY={'scroll'}
                              >
                                {reviews &&
                                reviews[tab] &&
                                reviews[tab]?.length !== 0 ? (
                                  reviews[tab]
                                    .filter((item: any) =>
                                      tab === 1 ? true : false,
                                    )
                                    .map((it: any, ind: number) => {
                                      const reviewer =
                                        reviewers &&
                                        reviewers.find(
                                          (rev: any) =>
                                            rev?.gameReviewerId ===
                                            it?.gameReviewerId,
                                        );
                                      return (
                                        <React.Fragment key={ind}>
                                          <Box
                                            bg={
                                              it?.readStatus === 0
                                                ? '#e1f5f9'
                                                : ''
                                            }
                                            p={'10px'}
                                            mb={'5px'}
                                            borderRadius={'10px'}
                                          >
                                            <Box
                                              w={'100%'}
                                              display={'flex'}
                                              justifyContent={'space-between'}
                                              onMouseEnter={() =>
                                                handleMouseEnter(it, ind)
                                              }
                                            >
                                              <Box
                                                w={'100%'}
                                                display={'flex'}
                                                alignItems={'center'}
                                              >
                                                <Img
                                                  src={pro}
                                                  w={'40px'}
                                                  h={'40px'}
                                                  alt="pro"
                                                  borderRadius={'50%'}
                                                />
                                                <Text
                                                  ml={'15px'}
                                                  fontSize={'sm'}
                                                  color={textColorPrimary}
                                                  fontWeight={'bold'}
                                                >
                                                  {reviewer?.emailId === null
                                                    ? reviewer?.ReviewingCreator
                                                        ?.ctMail
                                                    : reviewer?.emailId}
                                                </Text>
                                              </Box>
                                              <Box whiteSpace={'nowrap'}>
                                                <Text
                                                  fontSize={'12px'}
                                                  color={'gray'}
                                                >
                                                  Posted On :{' '}
                                                  {it?.updatedAt
                                                    ? new Date(
                                                        it.updatedAt,
                                                      ).toLocaleDateString()
                                                    : ''}
                                                </Text>
                                                {it?.readStatus === 0 && (
                                                  <Badge
                                                    mr={'5px'}
                                                    borderRadius={'none'}
                                                    width={'auto'}
                                                    h={'fit-content'}
                                                    variant="outline"
                                                    colorScheme="green"
                                                  >
                                                    New
                                                  </Badge>
                                                )}
                                              </Box>
                                            </Box>
                                            <Box mb={'10px'} mt={'10px'}>
                                              {it?.review}
                                            </Box>
                                          </Box>
                                        </React.Fragment>
                                      );
                                    })
                                ) : (
                                  <Box mb={'10px'} mt={'10px'}>
                                    {' No Feedback For Background '}
                                  </Box>
                                )}
                              </Box>
                            </FormControl>
                            <MenuItem>
                              <Box
                                w={'100%'}
                                display={'flex'}
                                justifyContent={'flex-end'}
                              >
                                <Button
                                  bg="#11047a"
                                  _hover={{ bg: '#190793' }}
                                  color="#fff"
                                  h={'46px'}
                                  w={'128px'}
                                  mr={'33px'}
                                  mt={'7px'}
                                >
                                  Close
                                </Button>
                              </Box>
                            </MenuItem>
                          </MenuList>
                        </Menu>
                      )}
                    </Box>
                  </Box>
                ) : tab === 2 ? (
                  ///////////////////////Non-Player IMAGE/////////////////////////////////
                  <>
                    {preview && (
                      <CharacterPreview
                        id={id}
                        languages={languages}
                        voices={voices}
                        prev={preview}
                        show={img}
                        players={players}
                        setPreview={setPreview}
                        makeInputFiled={makeInputFiled}
                        onClose={onClose}
                        values={values}
                        setValues={setValues}
                        previewId={previewId}
                        setFormData={setFormData}
                        formData={formData}
                        commonNextFunction={commonNextFunction}
                        staticAssetImageUrls={staticAssetImageUrls}
                      />
                    )}

                    <Box
                      className="character-step"
                      display={{ base: 'block', md: 'flex', lg: 'flex' }}
                    >
                      <Box className="character-img-list" width={'100%'}>
                        <Box
                          display={'flex'}
                          flexDir={'column'}
                          justifyContent={'start'}
                          alignItems={'start'}
                        >
                          <Text
                            fontSize={'20px'}
                            fontWeight={800}
                            // m={'10px 10px 10px 20px'}
                            pl={'13px'}
                          >
                            Select a Non-Playing Character
                          </Text>
                        </Box>

                        <Box
                          // height={'700px'}
                          // overflowY={'auto'}
                          borderRadius={'70px'}
                          padding={'30px 0'}
                        >
                          <SimpleGrid
                            className="gameCreationGrid"
                            columns={{ base: 1, md: 2, lg: 4 }}
                            spacing={6}
                          >
                            {players &&
                              players.map((player, i) => {
                                // Capitalize the name before passing it to the GameCard component
                                const capitalizedPlayerName =
                                  player.gasAssetName.charAt(0).toUpperCase() +
                                  player.gasAssetName.slice(1).toLowerCase();

                                return (
                                  <GameCard
                                    name={capitalizedPlayerName} // Use the capitalized name
                                    author={''}
                                    image={
                                      player.gasId && player?.gasAssetImage
                                    }
                                    tabState={'charater'}
                                    id={player.gasId}
                                    handleButtonOne={playerPerview}
                                    handleButtonTwo={makeInputFiled}
                                    handelDuplicate={setFormData}
                                    handelLaunch={''}
                                    handelAssign={formData}
                                    handelMakePublic={''}
                                    handelDelete={''}
                                    handleDownload={''}
                                  />
                                );
                              })}
                          </SimpleGrid>
                        </Box>
                        {tab && tab === 2 && ShowReview && (
                          <Menu>
                            <MenuButton
                              p="0px"
                              bg={'brandScheme'}
                              position={'fixed'}
                              bottom={{ base: '105px', xl: '0' }}
                              right={{ base: '15px', xl: '5px' }}
                              className="menureviewshow"
                            >
                              <Icon
                                as={AiFillMessage}
                                bg={'#3311db'}
                                color={'#fff'}
                                w="70px"
                                h="70px"
                                borderRadius={'50%'}
                                p={'15px'}
                                me="10px"
                              />
                            </MenuButton>
                            <MenuList
                              boxShadow={shadow}
                              p="20px"
                              me={{ base: '30px', md: 'unset' }}
                              borderRadius="20px"
                              bg={menuBg}
                              border="none"
                              mt="10px"
                              minW={{ base: '360px' }}
                              maxW={{ base: '360px', md: 'unset' }}
                              zIndex={'100000000'}
                            >
                              <FormControl>
                                <FormLabel fontSize={18} fontWeight={700}>
                                  {'Feedback For Character'}
                                </FormLabel>
                                <Box
                                  w={'360px'}
                                  maxH={'50vh'}
                                  overflowY={'scroll'}
                                >
                                  {reviews &&
                                  reviews[tab] &&
                                  reviews[tab]?.length !== 0 ? (
                                    reviews[tab]
                                      .filter((item: any) =>
                                        tab === 2 ? true : false,
                                      )
                                      .map((it: any, ind: number) => {
                                        const reviewer =
                                          reviewers &&
                                          reviewers.find(
                                            (rev: any) =>
                                              rev?.gameReviewerId ===
                                              it?.gameReviewerId,
                                          );
                                        return (
                                          <React.Fragment key={ind}>
                                            <Box
                                              bg={
                                                it?.readStatus === 0
                                                  ? '#e1f5f9'
                                                  : ''
                                              }
                                              p={'10px'}
                                              mb={'5px'}
                                              borderRadius={'10px'}
                                            >
                                              <Box
                                                w={'100%'}
                                                display={'flex'}
                                                justifyContent={'space-between'}
                                                onMouseEnter={() =>
                                                  handleMouseEnter(it, ind)
                                                }
                                              >
                                                <Box
                                                  w={'100%'}
                                                  display={'flex'}
                                                  alignItems={'center'}
                                                >
                                                  <Img
                                                    src={pro}
                                                    w={'40px'}
                                                    h={'40px'}
                                                    alt="pro"
                                                    borderRadius={'50%'}
                                                  />
                                                  <Text
                                                    ml={'15px'}
                                                    fontSize={'sm'}
                                                    fontWeight={'bold'}
                                                    color={textColorPrimary}
                                                  >
                                                    {reviewer?.emailId === null
                                                      ? reviewer
                                                          ?.ReviewingCreator
                                                          ?.ctMail
                                                      : reviewer?.emailId}
                                                  </Text>
                                                </Box>
                                                <Box whiteSpace={'nowrap'}>
                                                  <Text
                                                    fontSize={'12px'}
                                                    color={'gray'}
                                                  >
                                                    Posted On :{' '}
                                                    {it?.updatedAt
                                                      ? new Date(
                                                          it.updatedAt,
                                                        ).toLocaleDateString()
                                                      : ''}
                                                  </Text>
                                                  {it?.readStatus === 0 && (
                                                    <Badge
                                                      mr={'5px'}
                                                      borderRadius={'none'}
                                                      width={'auto'}
                                                      h={'fit-content'}
                                                      variant="outline"
                                                      colorScheme="green"
                                                    >
                                                      New
                                                    </Badge>
                                                  )}
                                                </Box>
                                              </Box>
                                              <Box mb={'10px'} mt={'10px'}>
                                                {it?.review}
                                              </Box>
                                            </Box>
                                          </React.Fragment>
                                        );
                                      })
                                  ) : (
                                    <Box mb={'10px'} mt={'10px'}>
                                      {' No Feedback For Character '}
                                    </Box>
                                  )}
                                </Box>
                              </FormControl>
                              <MenuItem>
                                <Box
                                  w={'100%'}
                                  display={'flex'}
                                  justifyContent={'flex-end'}
                                >
                                  <Button
                                    bg="#11047a"
                                    _hover={{ bg: '#190793' }}
                                    color="#fff"
                                    h={'46px'}
                                    w={'128px'}
                                    mr={'33px'}
                                    mt={'7px'}
                                  >
                                    Close
                                  </Button>
                                </Box>
                              </MenuItem>
                            </MenuList>
                          </Menu>
                        )}
                      </Box>
                    </Box>
                  </>
                ) : tab === 3 ? (
                  <>
                    <AboutStory
                      languages={languages}
                      defaultskills={defaultskills}
                      setDefaultSkills={setDefaultSkills}
                      setCat={setCat}
                      setFormData={setFormData}
                      setTags={setTags}
                      formData={formData}
                      handleChange={handleChange}
                      id={id}
                      setChatNote={setChatNote}
                      chatNote={chatNote}
                    />
                  </>
                ) : tab === 4 ? (
                  <>
                    <Customization
                    showReflectionQuestions={showReflectionQuestions}
                    BlockItems={BlockItems}
                      reviewers={reviewers && reviewers}
                      reviews={reviews && reviews[4]}
                      id={id}
                      formData={formData}
                      setBlockItems={setBlockItems}
                      serias={serias}
                      setserias={setserias}
                      setInput={setInput}
                      setUploadedFiles={setUploadedFiles}
                      input={input}
                      setItems={setItems}
                      items={items}
                      alphabet={alphabet}
                      setAlphabet={setAlphabet}
                      interactionBlock={interactionBlock}
                      setInteractionBlock={setInteractionBlock}
                      countalphabet={countalphabet}
                      setAlphabetCount={setAlphabetCount}
                      count={count}
                      setCount={setCount}
                      sequence={sequence}
                      setSequence={setSequence}
                      dummySequence={dummySequence}
                      setDummySequence={setDummySequence}
                      showSelectBlock={showSelectBlock}
                      setSelectBlock={setSelectBlock}
                      targetSequence={targetSequence}
                      handleKeyDown={handleKeyDown}
                      isDeleteSeq={isDeleteSeq}
                      setDeleteseq={setDeleteseq}
                      handleGet={handleGet}
                      fetchBlocks={fetchBlocks}
                      listQuest={listQuest}
                      questTabState={questTabState}
                      setQuestTabState={setQuestTabState}
                      deleteQuest={deleteQuest}
                      upNextCount={upNextCount}
                      foundLastInput={foundLastInput}
                      setUpNextCount={setUpNextCount}
                      ShowReview={ShowReview}
                      validation={validation}
                      setValidation={setValidation}
                      listBlockItems={listBlockItems}
                      languages={languages}
                      // setReviews={setReviews}
                      handleMouseEnter={handleMouseEnter}
                      scrollToElementEnabled={scrollToElementEnabled}
                      setScrollToElementEnabled={setScrollToElementEnabled}
                      setIsDeleteActionDone={setIsDeleteActionDone}
                      setChatNote={setChatNote}
                      chatNote={chatNote}
                    />
                  </>
                ) : tab === 5 ? (
                  <>
                    <AddScores
                      languages={languages}
                      defaultskills={defaultskills}
                      setShowFunction={setShowFunction}
                      showBadge={showBadge}
                      setShowBadge={setShowBadge}
                      reflection={reflection}
                      setReflection={setReflection}
                      setBadge={setBadge}
                      formData={formData}
                      inputRef={inputRef}
                      handleChange={handleChange}
                      updateHandleIntroMusic={handleIntroMusic}
                      setFormData={setFormData}
                      setTab={setTab}
                      onOpen={onOpen}
                      isOpen={isOpen}
                      onClose={onClose}
                      serias={serias}
                      showFunction={showFunction}
                      reflectionQuestions={reflectionQuestions}
                      reflectionQuestionsdefault={reflectionQuestionsdefault}
                      setReflectionQuestions={setReflectionQuestions}
                      handleReflectionInput={handleReflectionInput}
                      handlesaveReflection={handlesaveReflection}
                      currentTab={currentTab}
                      setCurrentTab={setCurrentTab}
                      openQuest={openQuest}
                      setOpenQuest={setOpenQuest}
                      handleGet={handleGet}
                      fetchBlocks={fetchBlocks}
                      setQuestTabState={setQuestTabState}
                      listQuest={listQuest}
                      CompKeyCount={CompKeyCount}
                      setCompKeyCount={setCompKeyCount}
                      Completion={Completion}
                      compliData={compliData}
                      setCompliData={setCompliData}
                      handleCompletionScreen={handleCompletionScreen}
                      handlecompletion={handlecompletion}
                      handleEnables={handleEnables}
                      RefelectionAnswer={RefelectionAnswer}
                      ThankyouFeedback={ThankyouFeedback}
                      ShowReview={ShowReview}
                      reviewers={reviewers && reviewers}
                      reviews={reviews}
                      tab={tab}
                      pro={pro}
                      handleMouseEnter={handleMouseEnter}
                      setChatNote={setChatNote}
                      chatNote={chatNote}
                      allbackgroundimg={img}
                      updateQuestBackground={updateQuestBackground}
                    />
                  </>
                ) : tab === 6 ? (
                  <>
                    <GreetingsForm
                      selectedAud={selectedAud}
                      setSelectedAud={setSelectedAud}
                      formData={formData}
                      setBadge={setBadge}
                      handleChange={handleChange}
                      updateSummaryState={handleSummaryState}
                      updateLanguage={handleLanguageChange}
                      updateImageBackGround={handleBackGroundImage}
                      setFormData={setFormData}
                      setSentAud={setSentAud}
                      fetchLanguagescount={fetchLanguagescount}
                      setLoading={setLoading}
                      loading={loading}
                      handleVoiceBack={handleVoiceBack}
                      launchPopup={launchPopup}
                      setLaunchPopup={setLaunchPopup}
                      setClose={setClose}
                      close={close}
                      handleLaunchConfirm={handleLaunchConfirm}
                      modalPopup={modalPopup}
                      setModalPopup={setModalPopup}
                      setEnableVoiceCallApi={setEnableVoiceCallApi}
                      setClickCount={setClickCount}
                      clickCount={clickCount}
                    />
                  </>
                ) : tab === 7 ? (
                  <CompletionScreen
                    formData={formData}
                    handleChange={handleChange}
                    inputRef={inputRef}
                  />
                ) : null}
              </GridItem>
            </Grid>

            <Box
              w={{
                base: '70%',
                sm: '76%',
                md: '85%',
                // lg: '76%',
                xl: '76%',
              }}
              position={'fixed'}
              top={0}
              zIndex={999999}
              className="game-creation-preview"
            >
              <Box display={'flex'} flexDirection={{ sm: 'column', md: 'row' }}>
                <Box
                  display={'flex'}
                  justifyContent={{
                    base: 'flex-end',
                    xl: tab === 1 ? 'flex-end' : 'space-between',
                  }}
                  w={'100%'}
                >
                  {tab !== 1 && (
                    <Box
                      display={{
                        base: 'none',
                        sm: 'none',
                        md: 'none',
                        lg: 'none',
                        xl: 'flex',
                      }}
                    >
                      <Flex justify={'flex-start'} alignItems={'center'}>
                        <IoArrowBackCircle
                          onClick={() => {
                            setTab(tab - 1);
                          }}
                          size={46} // Adjust the size as needed
                          color="#11047a"
                          style={{
                            zIndex: 99,
                            cursor: 'pointer',
                          }}
                          className="vintoh"
                        />
                      </Flex>
                    </Box>
                  )}
                  <Flex justify="center">
                    <Card
                      display={'flex'}
                      justifyContent={
                        tab === 1 || tab === 2 ? 'end' : 'flex-end'
                      }
                      flexDirection="row"
                      h="95px"
                      boxShadow={'1px 3px 14px #0000'}
                      zIndex={99}
                      background={'#0000 !important'}
                    >
                      <Menu isOpen={isOpen1} onClose={onClose1}>
                        <MenuButton
                          alignItems="center"
                          justifyContent="center"
                          w="37px"
                          h="37px"
                          lineHeight="100%"
                          onClick={onOpen1}
                          borderRadius="10px"
                        >
                          <Icon
                            as={BsShareFill}
                            color="#11047a"
                            mt="18px"
                            cursor={'pointer'}
                            w={'22px'}
                            h={'22px'}
                            mr={'9px'}
                          />
                        </MenuButton>
                        <Box
                          position="absolute"
                          left="0"
                          top="0"
                          w="170px"
                          minW="unset"
                          maxW="170px !important"
                          border="transparent"
                          borderRadius="20px"
                          bg="transparent"
                          p="15px"
                          zIndex="1000"
                        >
                          <MenuList
                            w="170px"
                            minW="unset"
                            maxW="170px !important"
                            border="transparent"
                            backdropFilter="blur(63px)"
                            boxShadow={bgShadow}
                            borderRadius="20px"
                            position="absolute"
                            p="15px"
                            zIndex="1000" // Set a higher z-index value
                            right={{ lg: '-180px', xl: '0' }}
                          >
                            <MenuItem
                              transition="0.2s linear"
                              color={textColor}
                              _hover={textHover}
                              p="0px"
                              borderRadius="8px"
                              _active={{
                                bg: 'transparent',
                              }}
                              _focus={{
                                bg: 'transparent',
                              }}
                              mb="10px"
                            >
                              <Flex align="center" onClick={handleShareReview}>
                                <Icon
                                  as={GoCodeReview}
                                  h="16px"
                                  w="16px"
                                  me="8px"
                                />
                                <Text fontSize="sm" fontWeight="400">
                                  Share for Review
                                </Text>
                              </Flex>
                            </MenuItem>
                            {tab && [4, 5, 1, 2].includes(tab) && (
                              <MenuItem
                                transition="0.2s linear"
                                color={textColor}
                                _hover={textHover}
                                p="0px"
                                borderRadius="8px"
                                _active={{
                                  bg: 'transparent',
                                }}
                                _focus={{
                                  bg: 'transparent',
                                }}
                                mb="10px"
                              >
                                <Flex align="center" onClick={handleShowReview}>
                                  <Icon
                                    as={
                                      ShowReview
                                        ? AiOutlineEyeInvisible
                                        : AiOutlineEye
                                    }
                                    h="16px"
                                    w="16px"
                                    me="8px"
                                  />
                                  <Text fontSize="sm" fontWeight="400">
                                    {ShowReview ? 'Hide Review' : 'Show Review'}
                                  </Text>
                                </Flex>
                              </MenuItem>
                            )}
                          </MenuList>
                        </Box>
                      </Menu>

                      {tab === 5 && isNextClicked && OkClose && (
                        <Box className="confirm">
                          <Flex
                            _before={{
                              content: '""',
                              background: '#1b1b1c4a',
                              height: '100%',
                              width: '100%',
                              position: 'fixed',
                              top: '0',
                              left: '0',
                              right: '0',
                            }}
                          >
                            <Card
                              zIndex={99}
                              position="fixed"
                              top="50%"
                              left="50%"
                              transform="translate(-50%, -50%)"
                              background="#fff"
                              marginLeft={'0px'}
                              width={{
                                base: '300px',
                                sm: '300px',
                                md: '500px',
                              }}
                              display="flex"
                              alignItems="center"
                              boxShadow="1px 2px 17px #42414556"
                              p="20px"
                            >
                              <Box w="100%" justifyContent={'center'}>
                                <Text
                                  color={textColor}
                                  fontSize="2xl"
                                  fontWeight="700"
                                  mb="20px"
                                >
                                  Confirmation
                                </Text>
                                <Text
                                  color={textColor}
                                  fontSize="18px"
                                  fontWeight="600"
                                  mb="20px"
                                  letterSpacing="0.5px"
                                >
                                  There are 6 screens—please make sure you have
                                  reviewed all the screens before proceeding
                                </Text>
                              </Box>
                              <Flex
                                justify="center"
                                w="50%"
                                marginTop="5px"
                                p="0 5px"
                                display="flex"
                              >
                                <Button
                                  color={'#fff'}
                                  bg={'#11047a'}
                                  _hover={{ color: '#fff', bg: '#11047a' }}
                                  mr={'10px'}
                                  onClick={() => {
                                    setOkClose(false);
                                    setTab(5);
                                  }}
                                >
                                  OK
                                </Button>
                              </Flex>
                            </Card>
                          </Flex>
                        </Box>
                      )}

                      {reviewAlert && (
                        <Box className="confirm">
                          <Flex
                            _before={{
                              content: '""',
                              background: '#1b1b1c4a',
                              height: '100%',
                              width: '100%',
                              position: 'fixed',
                              top: '0',
                              left: '0',
                              right: '0',
                            }}
                          >
                            <Card
                              zIndex={99}
                              position="fixed"
                              top="50%"
                              left="50%"
                              transform="translate(-50%, -50%)"
                              background="#fff"
                              marginLeft={'0px'}
                              width={{
                                base: '300px',
                                sm: '300px',
                                md: '500px',
                              }}
                              display="flex"
                              alignItems="center"
                              boxShadow="1px 2px 17px #42414556"
                              p="20px"
                            >
                              <Box w="100%" justifyContent={'center'}>
                                <Text
                                  color={textColor}
                                  fontSize="2xl"
                                  fontWeight="700"
                                  mb="20px"
                                >
                                  Alert
                                </Text>

                                {unreadCount && reviewUnReadAlert ? (
                                  <Text
                                    color={textColor}
                                    fontSize="18px"
                                    fontWeight="600"
                                    mb="20px"
                                    letterSpacing="0.5px"
                                  >
                                    You have {unreadCount} reviews pending to
                                    check for this Game
                                  </Text>
                                ) : completedReview ? (
                                  <Text
                                    color={textColor}
                                    fontSize="18px"
                                    fontWeight="600"
                                    mb="20px"
                                    letterSpacing="0.5px"
                                  >
                                    You have Reviews To Check for this Game
                                  </Text>
                                ) : null}
                              </Box>
                              <Flex
                                justify="center"
                                w="50%"
                                marginTop="5px"
                                p="0 5px"
                                display="flex"
                              >
                                <Button
                                  color={'#fff'}
                                  bg={'#11047a'}
                                  _hover={{ color: '#fff', bg: '#11047a' }}
                                  mr={'10px'}
                                  onClick={() => {
                                    setReviewAlert(false);
                                    completedReview
                                      ? handleReviewOkAlert()
                                      : setReviewAlert(false);
                                  }}
                                >
                                  OK
                                </Button>
                              </Flex>
                            </Card>
                          </Flex>
                        </Box>
                      )}
                      {tab !== 1 && tab !== 6 && languageCount > 0 ? (
                        <Select
                          options={[defaultLanguageOption, ...languageOptions]}
                          // options={languageOptions}
                          isSearchable
                          placeholder="Language.."
                          onChange={handleSelectChange}
                          onMenuOpen={() => setMenuOpen(true)}
                          value={[
                            defaultLanguageOption,
                            ...languageOptions,
                          ].find((option) => option.value === languages)}
                          styles={{
                            control: (base) => ({
                              ...base,
                              borderRadius: '12px',
                              // borderColor: formData.isCategoryIdInvalid ? 'red' : '#ccc',
                              _focus: { borderColor: 'teal.300' },
                              minHeight: '42px',
                              cursor: 'pointer',
                              fontSize: 'sm',
                              marginRight: '17px',
                              marginTop: '6px',
                              marginLeft: '11px',
                              width: '150px',
                            }),
                          }}
                        />
                      ) : null}
                      <Box display={{ base: 'none', xl: 'flex' }}>
                        {(tab === 4 && isGameHasBlock) ||
                        [5, 6].includes(tab) ? (
                          <Button
                            bg="#11047a"
                            _hover={{ bg: '#190793' }}
                            color="#fff"
                            h={'46px'}
                            w={'128px'}
                            display={'block'}
                            mr={'17px'}
                            mt={'6px'}
                            ml={'11px'}
                            onClick={handleEntirePrev}
                          >
                            Preview
                          </Button>
                        ) : null}

                        {tab === 5 ? (
                          <Button
                            bg="#11047a"
                            _hover={{ bg: '#190793' }}
                            color="#fff"
                            h={'46px'}
                            w={'128px'}
                            onClick={() => handleNext()}
                            mr={'33px'}
                            mt={'7px'}
                          >
                            Next
                          </Button>
                        ) : (
                          tab !== 1 &&
                          tab !== 2 &&
                          tab !== 5 && (
                            <Button
                              bg="#11047a"
                              _hover={{ bg: '#190793' }}
                              color="#fff"
                              h={'46px'}
                              w={'128px'}
                              onClick={commonNextFunction}
                              mr={'33px'}
                              mt={'7px'}
                            >
                              {tab === 6 || tab === 7 ? 'Launch' : 'Next'}
                            </Button>
                          )
                        )}
                      </Box>
                    </Card>
                  </Flex>
                </Box>
              </Box>
            </Box>
            <Box
              display={{
                base: tab === 1 ? 'none' : 'flex',
                xl: 'none',
              }}
              width={'100vw'}
              position={'fixed'}
              bottom={0}
              right={0}
              zIndex={999999}
              borderTop={'1px solid #d1d1d1'}
            >
              <Flex justify="center" w={'100%'}>
                <Card
                  display={'flex'}
                  borderRadius={'none'}
                  justifyContent={'space-between'}
                  flexDirection="row"
                  h="90px"
                  w={'100%'}
                  boxShadow={'1px 3px 14px #0000'}
                  zIndex={99}
                  className="game-creation-preview"
                >
                  {tab !== 1 && (
                    <Flex justify={'flex-start'} alignItems={'center'}>
                      <IoArrowBackCircle
                        onClick={() => {
                          setTab(tab - 1);
                        }}
                        size={46} // Adjust the size as needed
                        color="#11047a"
                        style={{
                          zIndex: 99,
                          cursor: 'pointer',
                        }}
                      />
                    </Flex>
                  )}

                  {tab === 5 ? (
                    <Flex justify={'flex-start'} alignItems={'center'}>
                      <IoArrowForwardCircle
                        onClick={handleNext}
                        size={46} // Adjust the size as needed
                        color="#11047a"
                        style={{
                          zIndex: 99,
                          cursor: 'pointer',
                        }}
                      />
                    </Flex>
                  ) : (
                    tab !== 1 &&
                    tab !== 2 &&
                    tab !== 5 &&
                    (tab === 6 || tab === 7 ? (
                      <Flex justify={'flex-start'} alignItems={'center'}>
                        <MdOutlineRocketLaunch
                          onClick={commonNextFunction}
                          size={35} // Adjust the size as needed
                          color="#fff"
                          style={{
                            padding: '5px',
                            borderRadius: '50%',
                            backgroundColor: '#11047A',
                            zIndex: 99,
                            cursor: 'pointer',
                          }}
                        />
                      </Flex>
                    ) : (
                      <Flex justify={'flex-start'} alignItems={'center'}>
                        <IoArrowForwardCircle
                          onClick={commonNextFunction}
                          size={46} // Adjust the size as needed
                          color="#11047a"
                          style={{
                            zIndex: 99,
                            cursor: 'pointer',
                          }}
                        />
                      </Flex>
                    ))
                  )}
                </Card>
              </Flex>
            </Box>
            {share && tableDataCheck && (
              <ShareReviewTable
                isOpen={isOpen}
                onClose={onClose}
                onOpen={onOpen}
                tableData={tableDataCheck}
              />
            )}
          </Box>
        </GridItem>
      </Grid>
    </>
  );
};

export default GameCreation;
